import React, { useEffect, useState, useContext, useRef, useMemo, useCallback } from 'react';
import { Row, Col, Select, Divider, notification, Button, DatePicker, Form, Input, Typography, Collapse, message, Upload, Modal, Tabs, List, Spin, Comment, Tooltip, InputNumber, Checkbox, Radio, Space, Table, Popconfirm, Menu, Dropdown, Switch, Avatar } from 'antd';
import CreatableSelect from 'react-select/creatable';
import { onCreateTasks, onGetTasks, onGetTaskByID, onUpdateTasks, onRemoveTagUser, onUpdateUnreadTasks, onGetRelatedTasks, onGetAllTasksAllStatus, onUpdateTasksReminder, onGetTasksReminder, onRemoveTasksReminder, onRemoveTasksReminder2, onUpdateSubTaskMsg, onSelfTaskDeadline, onSelfPreviousTaskDeadline } from '../../Controller/Management/TaskManagement';
import { onCreateChat, onGetChat, onCreateAttachment, onCreateAudio, onUpdateChatReminder, onUpdateChat } from '../../Controller/Chat';
import { getAllUserLists, onGetUserContact } from '../../Controller/Management/UserProf_Ctrl';
import ReactAudioPlayer from 'react-audio-player';
import FlipMove from 'react-flip-move';
import { onGetHoliday } from '../../Controller/Management/HolidaysManagement';
import RecordRTC from 'recordrtc';
import AppContext from "../AppContext"
import moment, { suppressDeprecationWarnings } from 'moment';
import "antd/dist/antd.css";
import "../../css/Task.css";
import "../../css/chat.css";
import "../../css/mention-style.css"
// import ChatMessage from './ChatMessage'; // Import the new ChatMessage component
import { FixedSizeList as WindowList } from 'react-window';
import { printToPreview } from '../../Controller/FilePreview';
import { GetTranslation } from '../../Models/shared/general';
import { AudioOutlined, CheckCircleOutlined, ArrowUpOutlined, UpCircleTwoTone, PictureOutlined, LeftCircleTwoTone, MoreOutlined, SendOutlined, ArrowDownOutlined, FileOutlined, MinusCircleOutlined, PlusOutlined, ExclamationCircleOutlined, ArrowRightOutlined, ClockCircleOutlined, PushpinOutlined, ScheduleTwoTone, ScheduleFilled, CheckOutlined, CloseOutlined, UserAddOutlined, DeleteOutlined, SaveOutlined, EditOutlined, CheckSquareOutlined, BorderOutlined } from "@ant-design/icons";
import T_Error from "../404";
import { ListConsumer } from 'antd/lib/list';
import { getUserbyId } from '../../Controller/Management/UserProf_Ctrl'
import { onGetDepartmentById } from '../../Controller/Management/DepartmentManagement'
import { isMacOs, isMobile, isIOS } from 'react-device-detect';
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import Stack from '@mui/material/Stack';
import { getRenderPropValue } from 'antd/lib/_util/getRenderPropValue';
import { MentionsInput, Mention } from 'react-mentions'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import defaultStyle from './defaultStyle'
import defaultMentionStyle from './defaultMentionStyle'
import RefreshIcon from '@mui/icons-material/Refresh';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import PushPinIcon from '@mui/icons-material/PushPin';
//import 'react-images/build/css/index.css'; // Import the styles
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import BackToTodayIcon from '@mui/icons-material/Today';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';

import videojs from 'video.js';
import VREPlayer from 'videojs-react-enhanced';
import 'video.js/dist/video-js.css';
import { set } from 'lodash';
import { TakeoutDining } from '@mui/icons-material';
import FiberNewIcon from '@mui/icons-material/FiberNew';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import Snackbar from '@mui/material/Snackbar';
import Fade from '@mui/material/Fade';
import Slide from '@mui/material/Slide';
import Grow from '@mui/material/Grow';

import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import FormatQuoteOutlinedIcon from '@mui/icons-material/FormatQuoteOutlined';

import PhotoAlbum from "react-photo-album";
import Lightbox from "yet-another-react-lightbox";
import 'yet-another-react-lightbox/styles.css'
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Share from "yet-another-react-lightbox/plugins/share";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Download from "yet-another-react-lightbox/plugins/download";
import { SelectProvider } from '@mui/base';
//naxgo.online

//import Gallery from 'react-image-gallery';

const { Panel } = Collapse;
const { TextArea, Search } = Input;
const { Text, Paragraph } = Typography;
const { Option } = Select;
const { TabPane } = Tabs;

const userlang = navigator.language || navigator.userLanguage;


export default function TaskManagement(prop) {

    //===== VARIABLE ====
    const global = useContext(AppContext)
    const userid = global.UserIdentity.userid;
    const username = global.UserIdentity.username;
    const globaldepartment = global.UserIdentity.department;
    const globalgrouping = global.UserIdentity.grouping;
    const nickname = global.UserIdentity.nickname || "";
    const tasktype = global.UserIdentity.tasktype;
    const taskfilter = global.UserIdentity.taskfilter;
    const tasknameglobal = global.UserIdentity.taskname;
    const [form] = Form.useForm();
    const [textform] = Form.useForm();
    const [datasource, setDataSource] = useState({ "all": [] });

    const [holidaysdatasource, setHolidaysdatasource] = useState([])
    const [selfrawdatasource, setSelfrawdatasource] = useState([])
    const [selfdatasource, setSelfdatasource] = useState([])
    const [selfloadmore, setSelfloadmore] = useState(false)
    const [selfdatasourcelength, setSelfdatasourcelength] = useState(0)
    const [isMaintenance, setIsMaintenance] = useState(false);
    const [newdatasource, setNewDatasource] = useState([]);

    const [fulllist, setfulllist] = useState([]);
    const [userdepartment, setuserdepartment] = useState("")
    //======== IMAGE ========
    const [previewIconVisible, setPreviewIconVisible] = useState(false);
    const [previewIconImage, setPreviewIconImage] = useState('');

    //===== DISABLE =====
    const [conddisable, setConddisable] = useState(false);      // CONDITIONS
    const [statdisable, setStatdisable] = useState(false);      // STATUS
    const [extenddisable, setextenddiable] = useState(true);      // EXTEND ICON    

    const [onceperiodview, setonceperiodview] = useState("hidden");


    const [mentionvalue, setMentionValue] = useState("");
    const [temptaskid, setTemptaskid] = useState("")
    const [taguserlist, settaguserlist] = useState("");

    const [dayjsdate, setdayjsdate] = useState();

    const [dayjsstartdate, setdayjsstartdate] = useState();

    const [repeatperiodview, setrepeatperiodview] = useState("hidden");
    const [repeatperiod, setrepeatperiod] = useState("");
    const [remindertype, setremindertype] = useState("");

    const [reminderdatasource, setreminderdatasource] = useState("");
    const [reminderdate, setreminderdate] = useState("");
    const [reminderdate1, setreminderdate1] = useState("");
    const [remindertime, setremindertime] = useState("");
    const [remindertime1, setremindertime1] = useState("");
    const [reminderday, setreminderday] = useState("");
    const [reminderweek, setreminderweek] = useState([]);
    const [remindermonth, setremindermonth] = useState("");
    const [remindertaskid, setremindertaskid] = useState("");
    const [reminderchatid, setreminderchatid] = useState("");
    const [remindertaskname, setremindertaskname] = useState("");
    const [remindermessage, setremindermessage] = useState("");
    const [reminderdeletebutton, setreminderdeletebutton] = useState(false);
    const [reminderobjectid, setreminderobjectid] = useState("");
    // const [filtered, setFilteredDs]         = useState([]);
    const [userLists, setUserLists] = useState([]);
    const [FULLuserLists, setFULLUserLists] = useState([]);
    const [conditions, setConditions] = useState("");
    const [reloads, setReloads] = useState(0);
    const [status, setStatus] = useState(-1);
    const [chatmsg, setChatmsg] = useState("");

    // Inside your component
    const intervalIdRef = useRef(null);
    const [replyTo, setReplyTo] = useState(null);  // This state holds the message being replied to

    const [editBy, setEditBy] = useState(null);  // This state holds the message being edit to


    const [currentask, setcurrentask] = useState("main");
    const [displaymode, setDisplaymode] = useState("task");

    const [currenttaskamount, setcurrenttaskamount] = useState(0);

    const [currenttaskdata, setcurrenttaskdata] = useState();

    //======= COUNT ========
    const count = 5;
    const [newIndex, setnewindex] = useState(1);

    //==== BTN DISABLED =====
    const [refreshdisable, setRefreshDisable] = useState(false);
    const [btndisable, setBtnDisable] = useState(false);
    const [btnchecklist, setbtnchecklist] = useState(true);

    //===== LISTS ======
    const [filelist, setFileList] = useState([]);
    const [taskfilelist, setTaskFileList] = useState([]);
    const [typelist, setTypeList] = useState([]);
    const [chatlist, setChatList] = useState([]);
    const [newStatus, setNewStatus] = useState(-1);
    const [taskName, setTaskName] = useState("");
    const [searchUser, setSearchUser] = useState("");
    const [workstime, setworkstime] = useState(0)
    const [worketime, setworketime] = useState(0)
    const [disablehour, setdisablehour] = useState([])
    const [workduration, setworkduration] = useState(0)

    const [CurrentData, setCurrentData] = useState([]);
    // ===== LIST ======
    const [initLoading, setInitLoading] = useState(true);
    const [loading, setLoading] = useState(false);

    const [taskinitLoading, settaskInitLoading] = useState(true);
    const [taskloading, setTaskLoading] = useState(false);


    //====== COLLAPSE ======
    const [isEdit, setIsEdit] = useState(0);  // FORM IS EDIT
    const [taskdata, setTaskData] = useState("");
    const [chatdata, setChatData] = useState([]);
    const [collapse, setCollapse] = useState([]); // SET IS COLLAPSE

    //======= MODAL ========
    const [modalTitle, setModalTitle] = useState("")
    const [modalVisible, setModalVisible] = useState(false);
    const [modalVisible1, setModalVisible1] = useState(false);
    const [modalVisible2, setModalVisible2] = useState(false);
    const [modalVisible3, setModalVisible3] = useState(false);
    const [modalVisible4, setModalVisible4] = useState(false);

    const [headerVisible, setheaderVisible] = useState(false);

    const [checklistmodalvisible, setChecklistmodalvisible] = useState(false);
    const [currentchecklist, setCurrentchecklist] = useState({});

    const [modalVisibleTagUser, setModalVisibleTagUser] = useState(false);
    const [listdata, setlistdata] = useState({}); // status data
    const [deadline, setdeadline] = useState("");
    const [startdate, setstartdate] = useState("");
    const [plansdate, setplansdate] = useState("");
    const [planedate, setplanedate] = useState("");
    const [workmanhours, setworkmanhours] = useState(1.0);
    const [currentstatus, setCurrentstatus] = useState("");
    const [taskitems, setTaskItems] = useState([]);
    const [checklist, setchecklist] = useState([]);
    const [Showtaguserlist, setShowtaguserlist] = useState([]);
    const [tagnamelist, settagnamelist] = useState([]);
    const [workmantype, setworkmantype] = useState("Days")
    const [extendmessage, setextendmessage] = useState("");

    const [Snackvisible, setSnackvisible] = useState(false)
    const [taskformat, setTaskformat] = React.useState('task');
    const [editdata, setEditdata] = useState(null)

    const [loadpreviousbutton, setLoadpreviousbutton] = useState(false)
    // State to manage the open/closed state of the lightbox
    const [IsImageOpen, setIsImageOpen] = useState(false);

    const [imagelist, setimagelist] = useState([]);

    const [SelectedImageIndex, setSelectedImageIndex] = useState(0);

    const { Howl, Howler } = require('howler');

    const [datasourceCONTACT, setDataSourceCONTACT] = useState([]);

    const [listloading1, setlistloading1] = useState(false)
    const [ModalTag, setModalTag] = useState(false);

    // State to hold user selections with permissions
    const [userPermissions, setUserPermissions] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectedTagUserIds, setSelectedTagUserIds] = useState([]);

    const mentionsInputRef = useRef(null);

    const [displayLimit, setDisplayLimit] = useState(1);

    const [showNoteListAll, setShowNoteListAll] = useState(false);

    const toggleShowNoteListAll = () => setShowNoteListAll(!showNoteListAll);



    const [newchecklisttitle, setnewchecklisttitle] = useState("")
    const todayId = "today-section"; // Define a unique ID for today's section

    // State to hold the current status filter
    const [statusFilter, setStatusFilter] = useState('all');
    const [displayLimitChecklist, setDisplayLimitChecklist] = useState(5);  // Only show first 5 items initially
    const [filterCompleted, setFilterCompleted] = useState(false); // State to keep track of filter


    const [recordbutton, setRecordbutton] = useState(false)

    const [recording, setRecording] = useState(false);
    const [mediaRecorder, setMediaRecorder] = useState(null);
    const [audioURL, setAudioURL] = useState('');
    const [recordingTimeoutId, setRecordingTimeoutId] = useState(null);
    const recordTimeout = useRef(null);

    const [selectedItemIndex, setSelectedItemIndex] = useState(null);

    // Extend your existing state to include which item's text should be expanded
    const [expandedTextIndex, setExpandedTextIndex] = useState(null);

    const [expandedChecklistIndex, setExpandedChecklistIndex] = useState({ date: null, index: null });
    const [editChecklistIndex, setEditChecklistIndex] = useState({ date: null, index: null });  // Track which task is being edited
    const [editChecklistitem, setEditChecklistitem] = useState(null);
    const [linktaskid, setLinktaskid] = useState(null)

    const [ChatRoomActiveKey, setChatRoomActiveKey] = useState(null);
    const [ChatRoomItem, setChatRoomItem] = useState(null);
    const [ChatRoomMentionUser, setChatRoomMentionUser] = useState(null)

    const [ChatRoomHeader, setChatRoomHeader] = useState(false)
    const [transitionClass, setTransitionClass] = useState('');


    const [showMentionList, setShowMentionList] = useState(false);
    const [mentionSearch, setMentionSearch] = useState('');
    const [mentionSuggestions, setMentionSuggestions] = useState([]);

    const [activeTab, setActiveTab] = useState('1');

    // Ref for the chat content
    const chatContentRef = useRef(null);
    const textAreaRef = useRef(null);

    let fullchatdata = null

    const UpdatePinMsg = useCallback((val, result) => {

        var chatinfo = ChatRoomItem
        console.log("pin reulst >>>", result)
        console.log("pin reulst >>>", val)

        var result33 = newdatasource.filter(x => x._id == chatinfo._id)[0];
        let updPintext = result

        if (result33 != undefined) {
            if (result33.pinmsg != undefined) {
                if (result33.pinmsg == result) {
                    updPintext = ""
                }
            }
        }


        let data =
        {
            taskid: chatinfo._id,
            pinmsg: updPintext

        }



        let newds1 = newdatasource;
        let newindex1 = newdatasource.findIndex(x => x._id == chatinfo._id);

        console.log("newds1[newindex1] >>>", newds1[newindex1])
        newds1[newindex1].pinmsg = updPintext;
        onUpdateTasks(data)

        setNewDatasource(newds1);
        onTaskChange(chatinfo._id)
    },[chatdata]);


    const showModalTagUser = (val, result) => {

        var newlist = [];
        var obj = {};
        var count = 0;

        result.forEach(function (items) {

            // console.log("items >>>>", items)
            obj = {}
            obj["userid"] = items.userid
            obj["countunread"] = items.countunread
            obj["unread"] = items.unread
            obj["permission"] = items.permission

            var temptagDisplayuser = FULLuserLists.filter(x => x._id == items.userid)[0].userid;

            obj["displayuserid"] = temptagDisplayuser
            newlist.push(obj)


        })



        setShowtaguserlist(newlist)

        setModalVisibleTagUser(true);

    };

    const handleCloseModalTagUser = (val) => {


        setModalVisibleTagUser(false);


    };


    const handleCancelTagUser = (taskresult, taguserresult) => {

        // console.log("taguserresult >>>", taguserresult)
        // console.log("taskresult >>>", taskresult)

        var isUserIdInArray = false;

        if (taguserresult == userid) {
            isUserIdInArray = true
        }

        var temptaguserlist = taskresult.taguser.filter(x => x.userid != taguserresult);
        let data = {
            taskid: taskresult._id,
            taguser: temptaguserlist
        }

        onUpdateTasks(data)

        var temptagDisplayuser1 = FULLuserLists.filter(x => x._id == taguserresult)[0].userid


        let newds1 = newdatasource;
        let newindex1 = newdatasource.findIndex(x => x._id == taskresult._id);
        newds1[newindex1].taguser = temptaguserlist



        var newlist = [];
        var obj = {};
        var count = 0;


        temptaguserlist.forEach(function (items) {

            obj = {}
            obj["userid"] = items.userid
            obj["countunread"] = items.countunread
            obj["unread"] = items.unread
            obj["permission"] = items.permission

            var temptagDisplayuser = FULLuserLists.filter(x => x._id == items.userid)[0].userid;

            obj["displayuserid"] = temptagDisplayuser
            newlist.push(obj)


        })

        onSendMessage(ChatRoomItem, `${temptagDisplayuser1} has left the conversation`)

        // setModalVisibleTagUser(false)


        setBtnDisable(false)


        message.success("Successfully Left Conversation")
        console.log("isUserIdInArray >>>", isUserIdInArray)
        if (isUserIdInArray == true) {

            newds1 = newds1.filter(x => x._id != taskresult._id);

        }



        setNewDatasource(newds1)

        setShowtaguserlist(newlist)


    };

    const handleOwnerChanger = (taskresult, taguserresult) => {

        let data = {}
        var temptaguserlist = taskresult.taguser.filter(x => x.userid != taguserresult);

        if (taskresult.createdby == taskresult.assignto) {
            data = {
                taskid: taskresult._id,
                createdby: taguserresult,
                assignto: taguserresult,
                taguser: temptaguserlist
            }
        }
        else {
            data = {
                taskid: taskresult._id,
                createdby: taguserresult,
                taguser: temptaguserlist
            }
        }

        onUpdateTasks(data)

        let newds1 = newdatasource;
        let newindex1 = newdatasource.findIndex(x => x._id == taskresult._id);
        newds1[newindex1].taguser = temptaguserlist


        var temptagDisplayuser1 = FULLuserLists.filter(x => x._id == taguserresult)[0].userid
        var temptagDisplayuser2 = FULLuserLists.filter(x => x._id == userid)[0].userid

        if (taskresult.createdby == taskresult.assignto) {
            newds1[newindex1].createdby = temptaguserlist
            newds1[newindex1].assignto = temptaguserlist
        }
        else {
            newds1[newindex1].createdby = temptaguserlist
        }


        var newlist = [];
        var obj = {};
        var count = 0;


        temptaguserlist.forEach(function (items) {

            obj = {}
            obj["userid"] = items.userid
            obj["countunread"] = items.countunread
            obj["unread"] = items.unread
            obj["permission"] = items.permission

            var temptagDisplayuser = FULLuserLists.filter(x => x._id == items.userid)[0].userid;
            var temptagDisplayuser1 = FULLuserLists.filter(x => x._id == userid)[0].userid;

            obj["displayuserid"] = temptagDisplayuser
            newlist.push(obj)


        })

        onSendMessage(ChatRoomItem, `${temptagDisplayuser1} become task owner, ${temptagDisplayuser2} has left the conversation.`)

        newds1 = newds1.filter(x => x._id != taskresult._id);

        setModalVisibleTagUser(false)


        setBtnDisable(false)

        setNewDatasource(newds1)



        setShowtaguserlist(newlist)

        message.success("Task Owner Changed")

    }


    const ChatRoomHeaderExpand = useCallback(() => {
        console.log("HI")
        setChatRoomHeader(prevState => !prevState);
        // setChatRoomHeader(true);
    }, []);


    const handleInputChange = (e) => {
        const value = e.target.innerText;
        console.log("handleInputChange >>", value)
        changeMentionMsg(value);

        const lastChar = value.slice(-1);
        if (lastChar === '@') {
            setShowMentionList(true);
            setMentionSearch('');
            setMentionSuggestions(ChatRoomMentionUser);
        } else {
            const mentionMatch = value.match(/@(\w*)$/);
            if (mentionMatch) {
                const search = mentionMatch[1];
                setMentionSearch(search);
                setMentionSuggestions(
                    ChatRoomMentionUser.filter(user => user.display.includes(search))
                );
            } else {
                setShowMentionList(false);
            }
        }
    };

    const handleMentionClick = (user) => {
        const inputText = textAreaRef.current.innerText;
        const newText = inputText.replace(/@$/, `@${user.display} `);
        textAreaRef.current.innerText = newText;
        changeMentionMsg(newText);

        setShowMentionList(false);
    };



    const handleBlur = () => {
        setShowMentionList(false);
    };

    const handleInputFocus = () => {
        setTimeout(() => {
            textAreaRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 300); // Adjust timeout to match the keyboard animation
    };



    const changeMentionMsg = (val) => {

        let temptaguserlist = []
        if (val.includes("@[")) {
            var tempval = val.substring(val.indexOf("@["), val.length)
            var splitvar = tempval.split("@")

            if (splitvar) {
                splitvar.forEach(function (xdata) {
                    if (xdata.includes("[")) {
                        if (xdata.includes("]")) {
                            let tempdata = xdata
                            temptaguserlist.push(tempdata.substring(tempdata.indexOf("[") + 1, tempdata.indexOf("]")))
                        }
                    }
                })
            }
        }


        // const setData = new Set(temptaguserlist);
        // const uniqueArray = Array.from(setData);
        // settaguserlist(uniqueArray)
        setChatmsg(val)

    }

    const handleMenuClick = useCallback((e, item) => {
        // console.log("menu item", item)
        // console.log("menu e", e)
        if (e.key === 'reply') {
            // Invoke reply logic

            setReplyTo(item)


            scrollToAndFocusMentionsInput(`${item.taskid}`)
        } else if (e === 'delete') {
            // Invoke forward logic

            //console.log('delete message:', item);

            return onUpdateChat({
                chatid: item._id,
                status: 0
            }).then(data => {
                console.log("update chat data >>>", data);

                if (data.status == "ok") {
                    message.success("Message Deleted !!!")
                    // console.log("chatdata >>>",chatdata)
                    // console.log("chatlist >>>",chatlist)

                    var tempchatdata = chatdata
                    var tempchatlist = chatlist

                    tempchatdata = tempchatdata.filter(x => x._id != item._id)
                    tempchatlist = tempchatlist.filter(x => x._id != item._id)

                    setChatList(tempchatlist)
                    setChatData(tempchatdata)
                }
                else {
                    message.error("Message Fail to Delete !!!")
                }
            })



        }
        else if (e.key === "edit") {
            console.log("edit item >>>", item)

            setEditBy(item)
            setChatmsg(item.message)

            // let arrayfilelist = [];
            // if (item.filepath) {
            //     const paths = item.filepath.split(',');
            //     arrayfilelist = paths.map((filepath, index) => ({
            //         uid: -index - 1, // Ensure unique negative uid for existing files
            //         name: filepath.split('/').pop(), // Extract filename from path
            //         status: 'done', // Mark as uploaded
            //         url: `https://qc9sk2.naxgo.online/${filepath}`, // File's URL for download or preview
            //     }));
            // }

            // if (item.filepath != undefined && item.filepath != "") {
            //     console.log("arrayfilelist >>>", arrayfilelist)

            //     setFileList(arrayfilelist)
            //     //onFileChange(arrayfilelist)
            // }
            // else {
            //     setFileList([])
            // }
        }
        else if (e.key === 'addchecklist') {

            console.log("add check list item >>>", item)


            setActiveTab(2)
            setChatRoomHeader(true)

            setnewchecklisttitle(item.message)

            // scrollToAndFocusChecklist(`C${item.taskid}`)
            // let newds = newdatasource;
            // let newindex = newdatasource.findIndex(x => x._id == item.taskid);


            // // console.log("newds[newindex] >>>",newds[newindex])
            // // console.log("newds[newindex].checklist >>>",newds[newindex].checklist)
            // if (newds[newindex] != undefined) {
            //     if (newds[newindex].checklist != undefined && newds[newindex].checklist.length > 0) {
            //         newds[newindex].checklist.push({ items: item.message, status: false, createdte: moment().unix() })
            //     }
            //     else {
            //         newds[newindex].checklist = [{ items: item.message, status: false, createdte: moment().unix() }]
            //     }

            // }

            // onUpdate(newds[newindex], null, newds[newindex].checklist)

            // var msg = `Check List Updated at ${moment().format("DD/M ddd h:mm a")} \n\n Added : \n${item.message}`

            // onSendMessage(newds[newindex], msg)

            // setNewDatasource(newds);
            // onReload()

        }
        else if (e.key === 'savenote') {

            return onUpdateChat({
                chatid: item._id,
                savetonote: 1
            }).then(data => {
                console.log("update chat data >>>", data);

                if (data.status == "ok") {

                    //scrollToAndFocusMentionsInput(`M${item.taskid}`)
                    var tempchatdata = chatdata
                    var tempchatlist = chatlist

                    let tempchatdataindex = tempchatdata.findIndex(x => x._id == item._id);
                    let tempchatlistindex = tempchatlist.findIndex(x => x._id == item._id);

                    if (tempchatdata[tempchatdataindex] != undefined) {
                        tempchatdata[tempchatdataindex].savetonote = 1
                    }

                    if (tempchatlist[tempchatlistindex] != undefined) {
                        tempchatlist[tempchatlistindex].savetonote = 1
                    }
                    setChatList(tempchatlist)
                    setChatData(tempchatdata)

                    message.success("Message saved to note !!!")

                    let newds = newdatasource;
                    let newindex = newdatasource.findIndex(x => x._id == item.taskid);

                    // console.log("newds[newindex] >>>",newds[newindex])
                    // console.log("newds[newindex].checklist >>>",newds[newindex].checklist)
                    if (newds[newindex] != undefined) {
                        if (newds[newindex].notelist != undefined && newds[newindex].notelist.length > 0) {
                            newds[newindex].notelist.push({ ...item, notecreatedte: moment().unix() })
                        }
                        else {
                            newds[newindex].notelist = []
                            newds[newindex].notelist.push({ ...item, notecreatedte: moment().unix() })
                        }

                    }

                    onUpdate(newds[newindex], null, null, null, null, newds[newindex].notelist)

                    // var msg = `Check List Updated at ${moment().format("DD/M ddd h:mm a")} \n\n Added : \n${item.message}`

                    // onSendMessage(newds[newindex], msg)

                    setNewDatasource(newds);
                    //onReload()
                }
                else {
                    message.error("Message Fail to save !!!")
                }
            })

        }
        else if (e.key === 'deletenote') {

            return onUpdateChat({
                chatid: item._id,
                savetonote: 0
            }).then(data => {
                console.log("update chat data >>>", data);

                if (data.status == "ok") {
                    //scrollToAndFocusMentionsInput(`M${item.taskid}`)
                    var tempchatdata = chatdata
                    var tempchatlist = chatlist

                    let tempchatdataindex = tempchatdata.findIndex(x => x._id == item._id);
                    let tempchatlistindex = tempchatlist.findIndex(x => x._id == item._id);

                    if (tempchatdata[tempchatdataindex] != undefined) {
                        tempchatdata[tempchatdataindex].savetonote = 0
                    }

                    if (tempchatlist[tempchatlistindex] != undefined) {
                        tempchatlist[tempchatlistindex].savetonote = 0
                    }
                    setChatList(tempchatlist)
                    setChatData(tempchatdata)


                    message.success("Note deleted !!!")

                    let newds = newdatasource;
                    let newindex = newdatasource.findIndex(x => x._id == item.taskid);


                    // console.log("newds[newindex] >>>",newds[newindex])
                    // console.log("newds[newindex].checklist >>>",newds[newindex].checklist)
                    if (newds[newindex] != undefined) {
                        if (newds[newindex].notelist != undefined && newds[newindex].notelist.length > 0) {
                            newds[newindex].notelist = newds[newindex].notelist.filter(x => x._id != item._id)
                        }
                    }

                    onUpdate(newds[newindex], null, null, null, null, newds[newindex].notelist)

                    // var msg = `Check List Updated at ${moment().format("DD/M ddd h:mm a")} \n\n Added : \n${item.message}`

                    // onSendMessage(newds[newindex], msg)

                    setNewDatasource(newds);
                    //onReload()
                }
                else {
                    message.error("Message Fail to delete !!!")
                }
            })

        }
        // Add more cases as needed
    }, [chatdata, chatlist, newdatasource, userid]);

    const messageActionsMenuWithDelete = useCallback((item) => {


        return (
            <Menu onClick={(e) => handleMenuClick(e, item)}>
                <Menu.Item key="reply">{GetTranslation(userlang, "Mention")}</Menu.Item>
                <Popconfirm
                    title={`Are you sure want to remove this message?`}
                    onConfirm={(e) => handleMenuClick("delete", item)}
                    // onCancel={() => console.log('User canceled delete')}
                    okText="Yes"
                    cancelText="No"
                >
                    {/* <Menu.Item key="delete" >{GetTranslation(userlang, "Delete")}</Menu.Item> */}
                </Popconfirm>
                {/* <Menu.Item key="edit">{GetTranslation(userlang, "Edit")}</Menu.Item> */}
                {/* <Menu.Item key="addchecklist">{GetTranslation(userlang, "Add Task List")}</Menu.Item> */}
                {/* {
                    item.savetonote != undefined && item.savetonote == 1 ?

                        <>
                            <Menu.Item key="deletenote">{GetTranslation(userlang, "Delete Note")}</Menu.Item>
                        </>
                        :
                        <>
                            <Menu.Item key="savenote">{GetTranslation(userlang, "Save Note")}</Menu.Item>
                        </>
                } */}
                {/* Additional menu items can be added here as needed */}
            </Menu>
        );
    }, [handleMenuClick, userlang]);

    const messageActionsMenuNoDelete = useCallback((item) => {

        return (
            <Menu onClick={(e) => handleMenuClick(e, item)}>
                <Menu.Item key="reply">{GetTranslation(userlang, "Mention")}</Menu.Item>
                {/* <Menu.Item key="addchecklist">{GetTranslation(userlang, "Add Task List")}</Menu.Item> */}
                {/* {
                    item.savetonote != undefined && item.savetonote == 1 ?

                        <>
                            <Menu.Item key="deletenote">{GetTranslation(userlang, "Delete Note")}</Menu.Item>
                        </>
                        :
                        <>
                            <Menu.Item key="savenote">{GetTranslation(userlang, "Save Note")}</Menu.Item>
                        </>
                } */}

                {/* Additional menu items can be added here as needed */}
            </Menu>
        );
    }, [handleMenuClick, userlang]);

    const Checklist = ({ checklist, taskdata, item }) => {

        console.log("checklist 1 >>>", checklist)
        console.log("checklist 2 >>>", taskdata)
        console.log("checklist 3 >>>", filterCompleted)
        var tempchecklisttrue = checklist.filter((item) => item.status === true).sort(compareCompletedate); // Only true
        // var tempchecklistfalse = checklist.filter((item) => item.status !== true).sort(compareDeadlines); // False and undefined

        // var tempchecklisttrue = checklist.filter((item) => item.status === true)
        //     .map((item, index) => ({
        //         ...item,
        //         sortindex: item.sortindex !== undefined ? item.sortindex : index
        //     })); // Adds sortindex if it doesn't exist

        var tempchecklistfalse = checklist.filter((item) => item.status !== true)
            .map((item, index) => ({
                ...item,
                sortindex: item.sortindex !== undefined ? item.sortindex : index
            })); // Adds sortindex if it doesn't exist

        var tempfinalresult = (filterCompleted ? tempchecklisttrue : tempchecklistfalse)
            .sort((a, b) => a.sortindex - b.sortindex); // Sort by sortindex

        const [editStates, setEditStates] = useState(
            tempfinalresult.map(item => ({
                isEditing: false,
                value: item.items,
                items: item.items,
                status: item.status ? item.status : false,
                originalValue: item.items, // Preserve the original value
                userid: item.userid ? item.userid : null,
                deadline: item.deadline ? item.deadline : null,
                originalUserid: item.userid ? item.userid : null, // Preserve the original value,
                originalDeadline: item.deadline ? item.deadline : null, // Preserve the original value
                completeddate: item.completeddate ? item.completeddate : null,
                sortindex: item.sortindex ? item.sortindex : null
            }))
        );

        console.log("checklist 4 >>>", tempfinalresult)

        const [newItem, setNewItem] = useState({
            isEditing: false,
            value: "",
            deadline: null,
            userid: null
        });


        var checkuserlist = []

        // Perform the search once and use destructuring to get the properties.
        var user = FULLuserLists.find(x => x._id === userid);
        var tempuserid = user?.userid || "Unknown user";
        var tempmarkingcode = user?.markingcode || "Unknown user";

        // Push the formatted user information into the list.
        checkuserlist.push({ value: "ALL", label: `ALL` });
        checkuserlist.push({ value: userid, label: `${tempuserid} (${tempmarkingcode})` });

        if (taskdata.taguser != undefined && taskdata.taguser.length > 0) {

            taskdata.taguser.forEach((items) => {

                // Perform the search once and use destructuring to get the properties.
                var user1 = FULLuserLists.find(x => x._id === items.userid);
                var tempuserobjid1 = user1?._id || "Unknown user";
                var tempuserid1 = user1?.userid || "Unknown user";
                var tempmarkingcode1 = user1?.markingcode || "Unknown user";

                // Push the formatted user information into the list.
                if (tempuserobjid1 != "Unknown user") {
                    checkuserlist.push({ value: tempuserobjid1, label: `${tempuserid1} (${tempmarkingcode1})` });
                }


            })
        }


        console.log("checkuser list >>>", checkuserlist)

        // Create refs for each checklist item
        const inputRefs = useRef(checklist.map(() => React.createRef()));


        const toggleEdit = (index) => {
            const newEditStates = [...editStates];
            if (!newEditStates[index].isEditing) {
                newEditStates[index].isEditing = true;
                setEditStates(newEditStates);
                // Ensure the text area gets focus after being made visible
                setTimeout(() => {
                    inputRefs.current[index]?.current?.focus();
                }, 100);
            }
        };



        const handleCheckboxChange = (index, taskdata, checkboxitem) => {
            // Create a new array with all items
            var newChecklist = [...editStates];

            // Toggle the status of the item at the given index
            newChecklist[index].status = editStates[index].status === true ? false : true;
            newChecklist[index].completeddate = moment().unix();

            let newds1 = newdatasource;
            let newindex1 = newdatasource.findIndex(x => x._id == taskdata._id);

            if (displaymode == "self") {
                newds1 = selfrawdatasource;
                newindex1 = selfrawdatasource.findIndex(x => x._id == taskdata._id);
            }

            // Filtering logic after status toggle
            if (filterCompleted === true) {

                newChecklist = [...newChecklist, ...tempchecklistfalse];
            }
            else if (filterCompleted === false) {

                newChecklist = [...newChecklist, ...tempchecklisttrue];
            }

            newds1[newindex1].checklist = newChecklist

            //setNewDatasource(newds1)
            onUpdate(newds1[newindex1], null, newChecklist)

            var msg = `Checklist updated at ${moment().format("DD/M ddd h:mm a")}\n
                        ${checkboxitem.items} Status changed to  ${editStates[index].status === true ? "Done" : "Processing"}`


            onSendMessage(newds1[newindex1], msg)

        };

        const handleChange = (value, index) => {
            console.log("edit value >>>", value)
            const newEditStates = [...editStates];
            newEditStates[index].value = value;
            newEditStates[index].items = value;
            setEditStates(newEditStates);
        };

        const handleUserChange = (userid, index) => {
            const newEditStates = [...editStates];
            newEditStates[index].userid = userid;
            setEditStates(newEditStates);
        };

        const handleDateChange = (newDate, index) => {
            const newEditStates = [...editStates];
            // Check if newDate is null or a valid date object
            newEditStates[index].deadline = newDate ? newDate.unix() : null;  // Convert to UNIX timestamp if not null
            setEditStates(newEditStates);
        };




        const handleMoveUp = async (index, taskitem) => {
            if (index > 0) {
                try {
                    const newEditStates = [...editStates];
                    // newEditStates[index].isMovingUp = true;
                    // newEditStates[index - 1].isMovingDown = true;
                    // Swap the items
                    [newEditStates[index], newEditStates[index - 1]] = [newEditStates[index - 1], newEditStates[index]];
                    // Swap their sortindex values
                    [newEditStates[index].sortindex, newEditStates[index - 1].sortindex] = [newEditStates[index - 1].sortindex, newEditStates[index].sortindex];
                    setEditStates(newEditStates);

                    // // Clear the movement flags after animation
                    // setTimeout(() => {
                    //     newEditStates[index].isMovingUp = false;
                    //     newEditStates[index - 1].isMovingDown = false;
                    //     setEditStates(newEditStates);
                    // }, 300); // Duration of the transition

                    // Create a new array with all items, considering the filterCompleted state
                    var newChecklist = [...newEditStates];

                    // Filtering logic after status toggle
                    if (filterCompleted === true) {

                        newChecklist = [...newChecklist, ...tempchecklistfalse];
                    }
                    else if (filterCompleted === false) {

                        newChecklist = [...newChecklist, ...tempchecklisttrue];
                    }

                    // Update tasks in the backend
                    const response = await onUpdateTasks({
                        taskid: taskitem._id,
                        checklist: newChecklist
                    });

                    let newds1 = newdatasource;
                    let newindex1 = newdatasource.findIndex(x => x._id == taskitem._id);

                    newds1[newindex1].checklist = newChecklist;

                    setNewDatasource(newds1);


                    toggleItemActions(index - 1);

                    // Optionally process response here
                    //console.log("Update successful:", response);
                } catch (error) {
                    console.error("Error updating tasks:", error);
                }
            }
        };


        const handleMoveDown = async (index, taskitem) => {
            if (index < editStates.length - 1) { // Ensure the item is not the last one
                try {
                    const newEditStates = [...editStates];
                    // Swap the items
                    [newEditStates[index], newEditStates[index + 1]] = [newEditStates[index + 1], newEditStates[index]];
                    // Swap their sortindex values
                    [newEditStates[index].sortindex, newEditStates[index + 1].sortindex] = [newEditStates[index + 1].sortindex, newEditStates[index].sortindex];
                    setEditStates(newEditStates);

                    // Create a new array with all items, considering the filterCompleted state
                    var newChecklist = [...newEditStates];
                    // Filtering logic after status toggle
                    if (filterCompleted === true) {

                        newChecklist = [...newChecklist, ...tempchecklistfalse];
                    }
                    else if (filterCompleted === false) {

                        newChecklist = [...newChecklist, ...tempchecklisttrue];
                    }

                    // Update tasks in the backend
                    const response = await onUpdateTasks({
                        taskid: taskitem._id,
                        checklist: newChecklist
                    });

                    let newds1 = newdatasource;
                    let newindex1 = newdatasource.findIndex(x => x._id == taskitem._id);

                    newds1[newindex1].checklist = newChecklist;

                    setNewDatasource(newds1);


                    toggleItemActions(index + 1);
                    // if (expandedTextIndex === index) {
                    //     setExpandedTextIndex(null); // Collapse if it's already expanded
                    // } else {
                    //     setExpandedTextIndex(index); // Expand the clicked item
                    // }
                    // Optionally process response here
                    //console.log("Update successful:", response);
                } catch (error) {
                    console.error("Error updating tasks:", error);
                }
            }
        };





        const handleSave = (index, taskdata, checkboxitem) => {
            const newEditStates = [...editStates];
            newEditStates[index].isEditing = false;
            setEditStates(newEditStates);


            console.log("newEditStates index >>>", index)

            console.log("newEditStates >>>", newEditStates)
            // Create a new array with all items
            var newChecklist = [...editStates];

            let newds1 = newdatasource;
            let newindex1 = newdatasource.findIndex(x => x._id == taskdata._id);


            if (displaymode == "self") {
                newds1 = selfrawdatasource;
                newindex1 = selfrawdatasource.findIndex(x => x._id == taskdata._id);
            }


            newds1[newindex1].checklist = newChecklist
            // Constructing the value change message
            let valueChangeMsg = `Check List: '${newChecklist[index].value}'`;
            if (newChecklist[index].originalValue !== newChecklist[index].value) {
                valueChangeMsg += `\n (changed from '${newChecklist[index].originalValue}' to '${newChecklist[index].value}')`; // Include both original and changed values
            }

            // Constructing the user change message if there's a change
            let userChangeMsg = '';
            if (newChecklist[index].originalUserid !== newChecklist[index].userid) {
                console.log("newChecklist[index].originalUserid >>>", newChecklist[index].originalUserid)
                console.log("newChecklist[index].userid >>>", newChecklist[index].userid)
                userChangeMsg = `,\n User changed from '${getUserLabel(newChecklist[index].originalUserid, FULLuserLists)}' to '${getUserLabel(newChecklist[index].userid, FULLuserLists)}'`;
            }

            // Constructing the deadline change message if there's a change
            let deadlineChangeMsg = '';
            if (newChecklist[index].originalDeadline !== newChecklist[index].deadline) {
                // Convert UNIX timestamp (seconds) to Moment.js date (milliseconds)
                const originalDate = newChecklist[index].originalDeadline ? moment(newChecklist[index].originalDeadline * 1000).format('DD MMM YYYY HH:mm') : 'No deadline';
                const newDate = newChecklist[index].deadline ? moment(newChecklist[index].deadline * 1000).format('DD MMM YYYY HH:mm') : 'No deadline';
                deadlineChangeMsg = `,\n Deadline changed from '${originalDate}' to '${newDate}'`;
            }

            const msg = `Checklist updated at ${moment().format("DD MMM YYYY HH:mm a")}\n${valueChangeMsg}${userChangeMsg}${deadlineChangeMsg}`;

            // Filtering logic after status toggle
            if (filterCompleted === true) {

                newChecklist = [...newChecklist, ...tempchecklistfalse];
            }
            else if (filterCompleted === false) {

                newChecklist = [...newChecklist, ...tempchecklisttrue];
            }

            const cleanedChecklist = newChecklist.map(({ originalUserid, originalValue, originalDeadline, value, isEditing, ...rest }) => {
                return rest;
            });

            // Call the update function to process changes in the datasource
            onUpdate(newds1[newindex1], null, cleanedChecklist);
            // Send the constructed message
            onSendMessage(newds1[newindex1], msg);
            // Optionally save the changes here (e.g., update the database)
        };

        const handleCancel = (index) => {
            // const newEditStates = [...editStates];
            // newEditStates[index].value = newEditStates[index].originalValue; // Reset to original value
            // newEditStates[index].items = newEditStates[index].originalValue; // Reset to original value
            // newEditStates[index].isEditing = false; // Exit edit mode
            // setEditStates(newEditStates);

            const newEditStates = [...editStates];
            const item = newEditStates[index];
            // Reset to original values
            item.value = item.originalValue;
            item.items = item.originalValue
            item.userid = item.originalUserid;
            item.deadline = item.originalDeadline;
            item.isEditing = false; // Exit edit mode
            setEditStates(newEditStates);

        };

        const handleDelete = (index, taskdata, checkboxitem) => {


            var newEditStates = [...editStates];
            newEditStates[index].isEditing = false;
            setEditStates(newEditStates);

            // Create a new array with all items
            var newChecklist = [...editStates];
            newChecklist = newChecklist.filter((i) => i.items !== newEditStates[index].items);

            let newds1 = newdatasource;
            let newindex1 = newdatasource.findIndex(x => x._id == taskdata._id);
            if (displaymode == "self") {
                newds1 = selfrawdatasource;
                newindex1 = selfrawdatasource.findIndex(x => x._id == taskdata._id);
            }

            newds1[newindex1].checklist = newds1[newindex1].checklist.filter((i) => i.items !== newEditStates[index].items);

            // Filtering logic after status toggle
            if (filterCompleted === true) {

                newChecklist = [...newChecklist, ...tempchecklistfalse];
            }
            else if (filterCompleted === false) {

                newChecklist = [...newChecklist, ...tempchecklisttrue];
            }

            onUpdate(newds1[newindex1], null, newChecklist)

            var msg = `Checklist updated at ${moment().format("DD/M ddd h:mm a")}\n
                         ${checkboxitem.items} Removed`


            onSendMessage(newds1[newindex1], msg)
            // Optionally save the changes here (e.g., update the database)
        };

        const handleAddNewClick = () => {
            setNewItem({ isEditing: true, value: "", deadline: null, userid: null });

        };
        const handleNewChecklistChange = (e) => {
            console.log("save value >>>", e)
            setNewItem(prevItem => ({ ...prevItem, value: e.target.value, isEditing: true }));
            //setnewchecklisttitle("")
        };


        const handleSaveNewChecklistItem = (taskdata1) => {
            console.log("save new item >>>", newItem)
            var savenew = false
            var savevalue = ""
            if (newItem.value.trim()) {

                savenew = true
                savevalue = newItem.value.trim()
            }
            else {
                var tempvalue = newchecklisttitle


                if (tempvalue.trim()) {

                    savenew = true
                    savevalue = tempvalue.trim()
                }
            }



            if (savenew == true) {
                setNewItem({ isEditing: false, value: "", deadline: null, userid: null });

                let newds1 = newdatasource;
                let newindex1 = newdatasource.findIndex(x => x._id == taskdata1._id);


                if (displaymode == "self") {
                    newds1 = selfrawdatasource;
                    newindex1 = selfrawdatasource.findIndex(x => x._id == taskdata1._id);

                }

                if (newItem.deadline != null) {
                    newItem.deadline = moment(newItem.deadline.$d).unix()
                }
                if (newds1[newindex1] != undefined) {
                    if (newds1[newindex1].checklist != undefined && newds1[newindex1].checklist.length > 0) {
                        newds1[newindex1].checklist.push({ items: savevalue, status: false, deadline: newItem.deadline, userid: newItem.userid })
                    }
                    else {
                        newds1[newindex1].checklist = []
                        newds1[newindex1].checklist.push({ items: savevalue, status: false, deadline: newItem.deadline, userid: newItem.userid })
                    }

                }

                onUpdate(newds1[newindex1], null, newds1[newindex1].checklist)

                // Constructing the message with optional user and deadline information
                let msgDetails = [`${savevalue} Added`];
                if (newItem.userid) {
                    msgDetails.push(`\nAssigned to: ${getUserLabel(newItem.userid, FULLuserLists)}`);
                }
                if (newItem.deadline) {
                    msgDetails.push(`\nDeadline: ${moment.unix(newItem.deadline).format('DD MMM YYYY HH:mm')}`);
                }

                const msg = `Checklist updated at ${moment().format("DD MMM YYYY HH:mm a")}\n${msgDetails.join(", ")}`;

                setnewchecklisttitle("")

                onSendMessage(newds1[newindex1], msg)

            }
        };

        const handleCancelNewChecklistItem = () => {
            setNewItem({ isEditing: false, value: "" });
            setnewchecklisttitle("")
        };


        const showMoreItems = () => {
            setDisplayLimitChecklist(checklist.length);  // Load 5 more items
        };

        const hideItems = () => {
            setDisplayLimitChecklist(5);  // Set this to your initial number of items to display
        };

        const onDragEnd = (result) => {
            if (!result.destination) {
                return; // dropped outside the list
            }

            const items = reorder(
                editStates,
                result.source.index,
                result.destination.index
            );

            setEditStates(items); // Set the new state with reordered items
        };

        const reorder = (list, startIndex, endIndex) => {
            const result = Array.from(list);
            const [removed] = result.splice(startIndex, 1);
            result.splice(endIndex, 0, removed);

            return result;
        };

        const toggleItemActions = index => {
            setSelectedItemIndex(prevIndex => (prevIndex === index ? null : index));
            if (expandedTextIndex === index) {
                setExpandedTextIndex(null); // Collapse if it's already expanded
            } else {
                setExpandedTextIndex(index); // Expand the clicked item
            }
        };




        // Function to toggle the completion status of a checklist item
        const toggleCompletion = (itemId) => {
            const newItems = checklist.map(item => {
                if (item.id === itemId) {
                    return { ...item, status: !item.completed };
                }
                return item;
            });

        };

        // Function to truncate text to 100 words
        const truncateText = (text) => {
            //const words = text.split(" ");
            // if (text.length > 10) {
            //     return text.slice(0, 10).join(" ") + "...";
            // }
            if (text.length > 45) {
                return text.slice(0, 45) + " ...";
            }
            return text;
        };

        const onTaskFileChange = (info) => {
            console.log("upload info >>>", info)
            // console.log("taskfilelist ",taskfilelist)
            let newFileList = [...info.fileList];
            // let newFileList = taskfilelist
            let index = 0;
            if (newFileList && newFileList.length > 0 && newFileList.length >= filelist.length) {
                for (let i = 0; i < newFileList.length; i++) {
                    let fileItem = newFileList[i];
                    let src = fileItem.url;

                    if (!src && fileItem.originFileObj) {
                        new Promise(resolve => {
                            const reader = new FileReader();
                            reader.readAsDataURL(fileItem.originFileObj);
                            reader.onload = () => resolve(reader.result);
                        }).then(src => {
                            index = i;
                            newFileList[index].preview = src;
                            setTaskFileList(newFileList);
                        });
                    }
                }
            } else {
                setTaskFileList(newFileList);
            }
        }

        const BinarySwitch = ({ isCompleted, setIsCompleted }) => {
            return (
                <div
                // style={{ margin: '20px' }}
                >
                    <label>
                        {/* {isCompleted ? 'Show Completed Tasks' : 'Show All Tasks'} */}
                        <Switch
                            checkedChildren="Completed"
                            unCheckedChildren="Pending"
                            checked={isCompleted}
                            onChange={setIsCompleted}
                            style={{ marginLeft: '10px' }}
                        />
                    </label>
                </div>
            );
        };


        return (
            <div className="checklist-container">

                {newItem.isEditing ? (
                    <div className="new-checklist-item">
                        <Row gutter={16}>
                            <Col span={24}>
                                <Input.TextArea
                                    value={newItem.value}
                                    onChange={(e) => handleNewChecklistChange(e)}
                                    autoSize={{ minRows: 2, maxRows: 4 }}
                                    placeholder="Enter new checklist item"
                                />
                                <Select
                                    value={newItem.userid}
                                    onChange={(value) => setNewItem({ ...newItem, userid: value })}
                                    placeholder="Select User"
                                    style={{ width: '100%', marginTop: '8px', zIndex: 9999 }}
                                    dropdownStyle={{ zIndex: 9999 }} // Ensure the dropdown itself has a high z-index

                                >
                                    {checkuserlist.map(option => {
                                        // console.log("option >>>",option); // Log each user option
                                        return (
                                            <Select.Option key={option.value} value={option.value}>{option.label}</Select.Option>
                                        );
                                    })}
                                </Select>

                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                        label="Task List Deadline"
                                        value={newItem.deadline ? dayjs.unix(newItem.deadline) : null}
                                        onChange={(newDate) => setNewItem({ ...newItem, deadline: newDate ? newDate.unix() : null })}
                                        renderInput={(params) => <TextField {...params} fullWidth />}
                                        PaperProps={{ style: { zIndex: 9999 } }} // Ensure the DateTimePicker dropdown has a high z-index
                                    />
                                </LocalizationProvider>



                            </Col>
                            <Col span={24}>
                                <Button onClick={() => handleSaveNewChecklistItem(ChatRoomItem)} type="primary" style={{ width: '100%' }}>Save</Button>
                                <Button onClick={handleCancelNewChecklistItem} type="default" style={{ width: '100%', marginTop: '10px' }}>Cancel</Button>
                            </Col>
                        </Row>
                    </div>
                ) : (
                    <>
                        <div className="binary-switch-button-container">

                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={handleAddNewClick}
                            />

                            <BinarySwitch isCompleted={filterCompleted} setIsCompleted={setFilterCompleted} />
                        </div>

                    </>

                )}
                <List
                    itemLayout="horizontal"
                    dataSource={editStates}
                    renderItem={(checklistitem, index) => (
                        <List.Item className="checklist-item">
                            {selectedItemIndex === index ? (
                                <>

                                    {checklistitem.isEditing ? (
                                        <div className="editing-fields">
                                            <Input.TextArea
                                                value={checklistitem.value}
                                                onChange={(e) => handleChange(e.target.value, index)}
                                                autoSize={{ minRows: 2, maxRows: 6 }}
                                            />
                                            <Select
                                                defaultValue={checklistitem.userid}
                                                style={{ width: '100%', marginTop: '8px' }}
                                                placeholder="Select User"
                                                onChange={(userid) => handleUserChange(userid, index)}
                                                dropdownStyle={{ zIndex: 9999 }} // Ensure the dropdown itself has a high z-index
                                            >
                                                {checkuserlist.map(option => (
                                                    <Select.Option key={option.value} value={option.value}>{option.label}</Select.Option>
                                                ))}
                                            </Select>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <LocalizationProvider key={index} dateAdapter={AdapterDayjs}>
                                                    <DateTimePicker
                                                        label="Task List Deadline"
                                                        value={checklistitem.deadline ? dayjs.unix(checklistitem.deadline) : null}
                                                        onChange={(newDate) => handleDateChange(newDate, index)}
                                                        renderInput={(params) => <TextField {...params} fullWidth />}
                                                        PaperProps={{ style: { zIndex: 9999 } }} // Ensure the DateTimePicker dropdown has a high z-index
                                                    />
                                                </LocalizationProvider>
                                            </LocalizationProvider>
                                            <Button icon={<SaveOutlined />} onClick={() => handleSave(index, ChatRoomItem)} style={{ marginTop: '8px', width: '100%' }}>Save</Button>
                                            <Button icon={<CloseOutlined />} onClick={() => handleCancel(index)} style={{ marginTop: '8px', width: '100%' }}>Cancel</Button>
                                        </div>
                                    ) : (
                                        <>
                                            <div className={`checklist-item-content expanded`} onClick={() => toggleItemActions(index)}>
                                                <Checkbox
                                                    checked={checklistitem.status}
                                                    onChange={() => handleCheckboxChange(index, ChatRoomItem, checklistitem)}
                                                />
                                                <span className="checklist-item-text">{checklistitem.value}</span>


                                            </div>
                                            <div className="checklist-item-info">
                                                {editStates[index].userid && (
                                                    <div className="assigned-to">{getUserLabel(editStates[index].userid, FULLuserLists)}
                                                    </div>
                                                )}
                                                {filterCompleted ? (
                                                    editStates[index].completeddate && (
                                                        <div className="completedate">
                                                            Completed: {formatDate(editStates[index].completeddate)}
                                                        </div>
                                                    )
                                                ) : (
                                                    editStates[index].deadline && (
                                                        <div className={moment().isAfter(moment.unix(editStates[index].deadline)) ? "deadline past" : "deadline"}>
                                                            Due: {formatDeadline(editStates[index].deadline)}
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                            <div className="button-group">
                                                {filterCompleted !== true && (
                                                    <Button icon={<EditOutlined />} onClick={() => toggleEdit(index, item, checklistitem)} />
                                                )}
                                                <Popconfirm
                                                    title="Are you sure to delete this item?"
                                                    onConfirm={() => handleDelete(index, item, checklistitem)}
                                                    okText="Yes"
                                                    cancelText="No"
                                                >
                                                    <Button icon={<DeleteOutlined />} type="danger" />
                                                </Popconfirm>
                                                {filterCompleted !== true && (
                                                    <Button
                                                        icon={<ArrowUpOutlined />}
                                                        onClick={() => handleMoveUp(index, ChatRoomItem)}

                                                        hidden={index === 0}
                                                    />
                                                )}

                                                {filterCompleted !== true && (
                                                    <Button
                                                        icon={<ArrowDownOutlined />}
                                                        onClick={() => handleMoveDown(index, ChatRoomItem)}

                                                        hidden={index === editStates.length - 1}
                                                    />
                                                )}

                                            </div>
                                        </>

                                    )}
                                </>
                            ) : (
                                <>
                                    <div className="checklist-item-content" onClick={() => toggleItemActions(index)}>
                                        <span className="checklist-item-text">{checklistitem.value}</span>

                                    </div>
                                    <div className="checklist-item-info">
                                        {editStates[index].userid && (
                                            <div className="assigned-to">{getUserLabel(editStates[index].userid, FULLuserLists)}
                                            </div>
                                        )}
                                        {filterCompleted ? (
                                            editStates[index].completeddate && (
                                                <div className="completedate">
                                                    Completed: {formatDate(editStates[index].completeddate)}
                                                </div>
                                            )
                                        ) : (
                                            editStates[index].deadline && (
                                                <div className={moment().isAfter(moment.unix(editStates[index].deadline)) ? "deadline past" : "deadline"}>
                                                    Due: {formatDeadline(editStates[index].deadline)}
                                                </div>
                                            )
                                        )}
                                    </div>
                                </>

                            )}
                        </List.Item>
                    )}
                />
            </div>
        );
    };

    const handlePanelClick = (item) => {
        setChatRoomItem(item);

        setTaskLoading(true)
        var tempmentionvalue = [...mentionvalue]

        var createduserid = tempmentionvalue.filter(x => x._id == item.createdby)
        var assigntouserid = tempmentionvalue.filter(x => x._id == item.assignto)


        var filteredMentionvalue = tempmentionvalue

        //if (item.createdby != userid) {
        if (Array.isArray(item.taguser) && item.taguser.length > 0) {
            filteredMentionvalue = tempmentionvalue.filter(mv => item.taguser.some(tu => tu.userid === mv._id));
        }
        else {
            filteredMentionvalue = []
        }
        //}


        //if (item.createdby != userid) {
        // Combine and deduplicate the arrays only if needed
        // Since we're combining arrays, ensure no duplicates if necessary
        // This example assumes the items are objects and distinct by _id

        // Merge and deduplicate based on _id
        let combinedIds = [...filteredMentionvalue, ...createduserid, ...assigntouserid];
        filteredMentionvalue = combinedIds.reduce((acc, current) => {
            const x = acc.find(item => item._id === current._id);
            if (!x) {
                return acc.concat([current]);
            } else {
                return acc;
            }
        }, []);

        setChatRoomMentionUser(filteredMentionvalue)
        setTransitionClass('slide-in');
        setTimeout(() => {
            setChatRoomItem(item);
            setTaskLoading(false)
        }, 200); // Match the duration of the animation

    };

    const handleBackClick = useCallback(() => {
        //setChatRoomItem(null);
        setTaskLoading(true)
        setTransitionClass('slide-out');
        setTimeout(() => {
            setChatRoomItem(null);
            onTaskChange()
            setChatRoomHeader(false)
            setTransitionClass('');
            setTaskLoading(false)
        }, 200); // Match the duration of the animation
    }, []);


    const handleIconPreviewCancel = () => {
        setPreviewIconVisible(false)
    }


    const handleIconPreview = (file) => {
        if (file.type.includes("image")) {
            // Show image preview
            setPreviewIconImage(file.preview);
            setPreviewIconVisible(true);
        } else if (file.type.startsWith("audio") && file.url) {
            // Create an audio element for playback
            const audioElement = document.createElement('audio');
            audioElement.src = file.url;
            audioElement.controls = true;
            const playbackContainer = document.createElement('div');
            playbackContainer.appendChild(audioElement);
            document.body.appendChild(playbackContainer); // Append somewhere in your document

            // Play audio
            audioElement.play();

            // Optionally, handle cleanup on audio end
            audioElement.onended = () => {
                playbackContainer.removeChild(audioElement);
                document.body.removeChild(playbackContainer);
            };
        } else {
            // Handle other file types
            printToPreview({ b64Data: file.preview, type: file.type });
        }
    };




    const hideNotes = () => {
        setDisplayLimit(1);
    };



    const handleTouchStart = () => {
        // const stream = navigator.mediaDevices.getUserMedia({ audio: true });
        // Set a timeout to start recording after 0.5 seconds
        recordTimeout.current = setTimeout(() => {
            startRecording();
        }, 300);  // 500 ms = 0.5 seconds
    };

    const handleTouchEnd = () => {
        // Clear the timeout if the mouse up event occurs before 0.5 seconds
        clearTimeout(recordTimeout.current);
        if (recording) {
            stopRecording();
        }
    };

    const handleMouseDown = () => {
        //const stream = navigator.mediaDevices.getUserMedia({ audio: true });
        // Set a timeout to start recording after 0.5 seconds for mouse down too
        recordTimeout.current = setTimeout(() => {
            startRecording();
        }, 300);
    };

    const handleMouseUp = () => {
        // Clear the timeout if the mouse up event occurs before 0.5 seconds
        clearTimeout(recordTimeout.current);
        if (recording) {
            stopRecording();
        }
    };

    const startRecording = async () => {
        try {
            // Check for microphone permissions without prompting the user
            const permissionStatus = await navigator.permissions.query({ name: 'microphone' });

            if (userid == '') {

            }
            console.log("permissionStatus.state >>>", permissionStatus.state)
            if (permissionStatus.state === 'granted') {
                // Permission is already granted

                console.log("Microphone permission already granted.");
            } else if (permissionStatus.state === 'prompt') {
                // Permission needs to be requested
                console.log("Requesting microphone permission...");
                await navigator.mediaDevices.getUserMedia({ audio: true });
                // No need to handle the granted case here, getUserMedia will prompt and resolve
            } else {
                // Permission is denied
                throw new Error('Microphone access is denied.');
            }
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

            const newMediaRecorder = new MediaRecorder(stream);

            const audioChunks = [];
            let startTime = Date.now();

            newMediaRecorder.ondataavailable = event => {
                audioChunks.push(event.data);
            };

            newMediaRecorder.onstop = () => {
                const duration = (Date.now() - startTime) / 1000;
                console.log("audio duration >>>", duration);
                if (duration >= 0.3) {
                    let mimeType = 'audio/webm;codecs=opus';
                    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                        mimeType = 'audio/mp3';
                    }

                    console.log("mimeType >>>", mimeType);

                    const audioBlob = new Blob(audioChunks, { type: mimeType });
                    const newAudioUrl = URL.createObjectURL(audioBlob);

                    setAudioURL(prevAudioUrl => {
                        if (!prevAudioUrl) {
                            console.log('Recording stopped and available at:', newAudioUrl);
                            //onSendMessage(item,"","manual msg")
                            return newAudioUrl;
                        }
                        console.log('Existing audioUrl is still in use:', prevAudioUrl);
                        return prevAudioUrl;
                    });
                } else {
                    console.log('Recording was too short and was not saved.');
                }
                stream.getTracks().forEach(track => track.stop()); // Stop the media stream
            };


            newMediaRecorder.start();
            setMediaRecorder(newMediaRecorder);
            setRecording(true);

            // Automatically stop recording after 30 seconds
            const timeoutId = setTimeout(() => {
                if (newMediaRecorder.state === "recording") {
                    newMediaRecorder.stop();
                    stopRecording()
                }
            }, 30000);
            setRecordingTimeoutId(timeoutId);
        } catch (error) {
            console.error('The following error occurred:', error);
        }
    };
    const startRecordingtest = async () => {
        try {
            let stream;
            // Check if the Permissions API is supported
            if (navigator.permissions && navigator.permissions.query) {
                const permissionStatus = await navigator.permissions.query({ name: 'microphone' });
                message.success("permissionStatus.state >>>", permissionStatus.state);

                if (permissionStatus.state === 'denied') {
                    throw new Error('Microphone access is denied.');
                }
                // Permission needs to be requested or is already granted
                stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                if (permissionStatus.state === 'granted') {
                    message.success("Microphone permission already granted.");
                } else {
                    message.success("Requesting microphone permission...");
                }
            } else {
                // Fallback if the Permissions API is not available
                console.log("Permissions API not supported, requesting access...");
                stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            }

            const newMediaRecorder = new MediaRecorder(stream);

            const audioChunks = [];
            let startTime = Date.now();

            newMediaRecorder.ondataavailable = event => {
                audioChunks.push(event.data);
            };

            newMediaRecorder.onstop = () => {
                const duration = (Date.now() - startTime) / 1000;
                console.log("audio duration >>>", duration);
                if (duration >= 0.3) {
                    let mimeType = 'audio/webm;codecs=opus';
                    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                        mimeType = 'audio/mp3';
                    }

                    console.log("mimeType >>>", mimeType);

                    const audioBlob = new Blob(audioChunks, { type: mimeType });
                    const newAudioUrl = URL.createObjectURL(audioBlob);

                    setAudioURL(prevAudioUrl => {
                        if (!prevAudioUrl) {
                            console.log('Recording stopped and available at:', newAudioUrl);
                            //onSendMessage(item,"","manual msg")
                            return newAudioUrl;
                        }
                        console.log('Existing audioUrl is still in use:', prevAudioUrl);
                        return prevAudioUrl;
                    });
                } else {
                    console.log('Recording was too short and was not saved.');
                }
                stream.getTracks().forEach(track => track.stop()); // Stop the media stream
            };


            newMediaRecorder.start();
            setMediaRecorder(newMediaRecorder);
            setRecording(true);

            // Automatically stop recording after 30 seconds
            const timeoutId = setTimeout(() => {
                if (newMediaRecorder.state === "recording") {
                    newMediaRecorder.stop();
                    stopRecording()
                }
            }, 30000);
            setRecordingTimeoutId(timeoutId);
        } catch (error) {
            notification.error({
                message: 'An Error Occurred',
                description: 'The following error occurred: ' + error.message,
                duration: 0,  // This will also make the notification persistent
                btn: <Button size="small" onClick={() => notification.close()}>Close</Button>
            });
        }
    };

    const stopRecording = () => {
        if (mediaRecorder && mediaRecorder.state === "recording") {
            mediaRecorder.stop();
        }
        if (recordingTimeoutId) {
            clearTimeout(recordingTimeoutId);
        }

        setRecording(false);
    };


    const deleteRecording = () => {
        URL.revokeObjectURL(audioURL);
        setAudioURL('');
    };

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }




    // Function to format timestamp
    function formatDate(timestamp) {
        return moment.unix(timestamp).format('DD MMM YYYY HH:mm');
    }


    function compareDeadlines(a, b) {
        // Assign a very high timestamp to undefined deadlines to sort them at the end
        const deadlineA = a.deadline ?? Number.MAX_SAFE_INTEGER;
        const deadlineB = b.deadline ?? Number.MAX_SAFE_INTEGER;

        return deadlineA - deadlineB; // Ascending order
    }

    function compareCompletedate(a, b) {
        // Assign a very high timestamp to undefined deadlines to sort them at the end
        const completedateA = a.completedate ?? Number.MAX_SAFE_INTEGER;
        const completedateB = b.completedate ?? Number.MAX_SAFE_INTEGER;

        return completedateA - completedateB; // Ascending order
    }


    function formatDeadline(unixTimestamp) {
        const deadline = moment(unixTimestamp * 1000);
        const now = moment();
        const diffDays = deadline.diff(now, 'days');
        const diffHours = deadline.diff(now, 'hours');
        const diffMinutes = deadline.diff(now, 'minutes');
        const isPast = now.isAfter(deadline);

        let timeString;

        if (Math.abs(diffDays) < 1) { // Less than 24 hours difference
            if (Math.abs(diffHours) < 1) { // Less than 1 hour difference
                timeString = `${isPast ? '-' : '+'}${diffMinutes} min`;
            } else {
                const hours = Math.abs(diffHours);
                const minutes = Math.abs(diffMinutes % 60); // remaining minutes
                timeString = `${isPast ? '-' : '+'}${hours} hr ${minutes} min`;
            }
        } else {
            timeString = `${isPast ? '-' : '+'}${diffDays} days`;
        }

        return `${timeString}, ${deadline.format('DD MMM HH:mm A')}`;
    }







    const Message = ({ from, message1, createDate, index, item }) => {
        // Format createDate to a more human-readable form
        // Assuming createDate is in a format that can be directly used in JavaScript Date
        const formattedDate = moment.unix(createDate).format("YYYY/MM/DD HH:mm A");
        // Function to call onDelete with the item's identifier
        const handleDelete = () => {
            console.log("index >>>", index)

            console.log("item >>>", item)
            console.log("message >>>", message1)

            return onUpdateChat({
                chatid: item._id,
                savetonote: 0
            }).then(data => {
                console.log("update chat data >>>", data);

                if (data.status == "ok") {

                    var tempchatdata = chatdata
                    var tempchatlist = chatlist

                    let tempchatdataindex = tempchatdata.findIndex(x => x._id == item._id);
                    let tempchatlistindex = tempchatlist.findIndex(x => x._id == item._id);

                    if (tempchatdata[tempchatdataindex] != undefined) {
                        tempchatdata[tempchatdataindex].savetonote = 0
                    }

                    if (tempchatlist[tempchatlistindex] != undefined) {
                        tempchatlist[tempchatlistindex].savetonote = 0
                    }
                    setChatList(tempchatlist)
                    setChatData(tempchatdata)


                    message.success("Note deleted !!!")

                    let newds = newdatasource;
                    let newindex = newdatasource.findIndex(x => x._id == item.taskid);


                    // console.log("newds[newindex] >>>",newds[newindex])
                    // console.log("newds[newindex].checklist >>>",newds[newindex].checklist)
                    if (newds[newindex] != undefined) {
                        if (newds[newindex].notelist != undefined && newds[newindex].notelist.length > 0) {
                            newds[newindex].notelist = newds[newindex].notelist.filter(x => x._id != item._id)
                        }
                    }

                    onUpdate(newds[newindex], null, null, null, null, newds[newindex].notelist)

                    // var msg = `Check List Updated at ${moment().format("DD/M ddd h:mm a")} \n\n Added : \n${item.message}`

                    // onSendMessage(newds[newindex], msg)

                    setNewDatasource(newds);
                    onReload()
                }
                else {
                    message.error("Message Fail to delete !!!")
                }
            })

            //.notelist
            //onDelete(item._id); // Assuming each message has a unique _id
        };

        return (
            <div className="message-container">
                <div className="message-header">
                    <span className="message-from">{from}</span>
                    <span className="message-date">{formattedDate}</span>
                    <button onClick={handleDelete} className="delete-btn">X</button>
                </div>
                <StyledMessage message={{ message: message1 }} msgtype={"message"}></StyledMessage>
            </div>
        );
    };

    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }





    const scrollToAndFocusMentionsInput = (elementid) => {

        // Use a timeout to allow the panel to finish expanding
        setTimeout(() => {
            const panelElement = document.getElementById(`reply${elementid}`);
            const panelElement2 = document.getElementById(`input${elementid}`);
            if (panelElement) {
                panelElement.scrollIntoView({ behavior: 'smooth', block: 'start' });

                if (panelElement2) {
                    // Set focus to the element
                    panelElement2.focus();
                }


            }
        }, 300); // Adjust timeout as necessary
    };


    const scrollToAndFocusChecklist = (elementid) => {


        setTimeout(() => {
            const panelElement = document.getElementById(elementid);
            if (panelElement) {
                panelElement.scrollIntoView({ behavior: 'smooth', block: 'start' });

            }
        }, 300); // Adjust timeout as necessary


    };



    const onNavigateToday = () => {
        const todaySection = document.getElementById(todayId);
        if (todaySection) {
            //todaySection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    // Function to toggle permission status
    const togglePermission = (userid) => {
        const updatedPermissions = userPermissions.map(user => {
            if (user.userid === userid) {
                return {
                    ...user,
                    permission: user.permission === 'private' ? 'public' : 'private'
                };
            }
            return user;
        });
        setUserPermissions(updatedPermissions);
    };

    const openTagModal = (val) => {
        setModalTag(true)
        setcurrenttaskdata(val)
        setUserPermissions([])
        console.log("taguser >>>", val)
    }


    const handleTagUserPermission = (taskdata, itemdata) => {

        console.log("task data >>>", taskdata)
        console.log("item data >>>", itemdata)

        console.log("Showtaguserlist >>>", Showtaguserlist)
        let temppermission
        let temptaguserlist = Showtaguserlist
        if (itemdata.permission == 'public') {
            temppermission = 'private'
        }
        else if (itemdata.permission == 'private') {
            temppermission = 'public'
        }

        // Update the permission in taskdata.taguser for the matching userid
        taskdata.taguser = taskdata.taguser.map(tagUser => {
            if (tagUser.userid === itemdata.userid) {
                // If the userid matches, update the permission
                return { ...tagUser, permission: temppermission };
            } else {
                // If not, return the tagUser object unchanged
                return tagUser;
            }
        });

        // Update the permission in taskdata.taguser for the matching userid
        temptaguserlist = temptaguserlist.map(tagUser => {
            if (tagUser.userid === itemdata.userid) {
                // If the userid matches, update the permission
                return { ...tagUser, permission: temppermission };
            } else {
                // If not, return the tagUser object unchanged
                return tagUser;
            }
        });

        onUpdate(taskdata, null, undefined, taskdata.taguser)
        // Creating a message that includes the userids of newly tagged users
        var msg = `${itemdata.displayuserid} permission changed to ${temppermission}`;
        if (temppermission == "private") {
            msg = `${itemdata.displayuserid} permission changed to ${temppermission}\n\nUser is tag privately, user can’t see the message if you don’t @`;
        }
        onSendMessage(taskdata, msg)

        setShowtaguserlist(temptaguserlist)
    }

    // Function to handle the save action
    const handleTagModalSave = () => {
        // Assuming userPermissions, currenttaskdata, and userLists are defined elsewhere



        var tempcurrenttaskdata = { ...ChatRoomItem }; // Create a shallow copy to prevent direct mutation
        let taggedUserIds = []; // To store the userids for the message

        let publicUserIds = [];
        let privateUserIds = [];


        const transformedPermissions = userPermissions.map(permission => {
            // Find the corresponding _id in userLists for each userid
            const user = userLists.find(user => user.userid === permission.userid);
            if (!user) return null; // Skip if no matching user found

            if (permission.permission === 'public') {
                publicUserIds.push(permission.userid); // Assuming userid here is actually the _id from userLists
            } else if (permission.permission === 'private') {
                privateUserIds.push(permission.userid);
            }
            taggedUserIds.push(permission.userid); // Add userid to the taggedUserIds list

            return {
                userid: user._id, // Use the _id from userLists
                unread: 1, // Default or calculated value
                countunread: 1, // Default or calculated value
                permission: permission.permission // Include the permission field
            };
        }).filter(item => item !== null); // Remove any null entries




        // If tempcurrenttaskdata.taguser is undefined or not an array, initialize it as an array
        if (!Array.isArray(tempcurrenttaskdata.taguser)) {
            tempcurrenttaskdata.taguser = [];
        }

        // Merge into tempcurrenttaskdata.taguser
        tempcurrenttaskdata.taguser.push(...transformedPermissions);


        console.log("tempcurrenttaskdata >>>", tempcurrenttaskdata)

        // Creating a message that includes the userids of newly tagged users
        // Construct message parts for public and private, only if there are userIDs in the respective arrays
        let messageParts = [];
        if (publicUserIds.length > 0) {
            messageParts.push(`Public: ${publicUserIds.join(', ')}`);
        }
        if (privateUserIds.length > 0) {
            messageParts.push(`Private: ${privateUserIds.join(', ')}`);
        }

        console.log("publicUserIds.length >>>", publicUserIds.length)
        console.log("privateUserIds.length >>>", privateUserIds.length)
        if (publicUserIds.length > 0 || privateUserIds.length > 0) {

            var msg = `User Tagged:\n\n${messageParts.join('\n\n')} `

            if (privateUserIds.length > 0) {
                msg = `User Tagged:\n\n${messageParts.join('\n\n')} \n\nUser is tag privately, user can’t see the message if you don’t @ `;

            }
            // Combine message parts into the final message
            onSendMessage(tempcurrenttaskdata, msg)
            // setModalVisible2(false);

            onUpdate(tempcurrenttaskdata, null, undefined, tempcurrenttaskdata.taguser)

            let newds = newdatasource;
            let newindex = newdatasource.findIndex(x => x._id == tempcurrenttaskdata._id);

            if (newds[newindex] != undefined) {
                newds[newindex] = tempcurrenttaskdata;

            }
            setNewDatasource(newds);

            onTaskChange(tempcurrenttaskdata._id);

            setUserPermissions([]);
            setSelectedUsers([]);

            //onReload()
        }



        cancelTagModal(); // Assuming this closes the modal
    };

    // Handle change in the AntD Select component
    const handleTagModalSelectUser = (selectedUserIds) => {
        // Update permissions for newly selected users
        const updatedPermissions = selectedUserIds.map(userid => {
            // If the user is already in userPermissions, maintain their current permission
            const existingUser = userPermissions.find(user => user.userid === userid);
            return existingUser || { userid, permission: 'private' }; // Default to private if not already in the list
        });

        setUserPermissions(updatedPermissions);
    };

    const cancelTagModal = (val, result) => {

        setModalTag(false)

    }

    const handleTaskFormat = (event, newTaskType) => {
        setTaskformat(newTaskType);
    };



    const openLightbox = useCallback((index, images) => {
        console.log("light box index >>>", index)
        setSelectedImageIndex(index);
        setIsImageOpen(true);
        setimagelist(images)
    }, [chatdata]);

    const handleSnackClose = () => {
        setSnackvisible(false)

    }
    function SlideTransition(props) {
        return <Slide {...props} direction="up" />;
    }

    const handleChecklistOk = () => {

        setChecklistmodalvisible(false);
        setchecklist([{ items: "", status: "" }])
    };

    const handleChecklistCancel = () => {

        setChecklistmodalvisible(false);
        setchecklist([{ items: "", status: "" }])
    };





    // Function to clear the reply state, invoked for example by an 'X' button in the reply indicator
    const clearReply = () => {
        setReplyTo(null);
    };

    // Function to clear the reply state, invoked for example by an 'X' button in the reply indicator
    const clearEdit = () => {
        setEditBy(null);
    };

    const Checklistcolumns = [
        {
            title: 'Items',
            dataIndex: 'items',
            key: 'items', sorter: (a, b) => a.items.localeCompare(b.items),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        placeholder={`Search Items`}
                        value={selectedKeys[0]}
                        onChange={e => {
                            setSelectedKeys(e.target.value ? [e.target.value] : []);
                            confirm({ closeDropdown: false });
                        }}
                        onPressEnter={() => {
                            confirm();
                        }}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <button
                        type="button"
                        onClick={() => {
                            clearFilters();
                            confirm();
                        }}
                        style={{ width: 90, marginRight: 8 }}
                    >
                        Reset
                    </button>
                    <button
                        type="button"
                        onClick={() => {
                            confirm();
                        }}
                        style={{ width: 90 }}
                    >
                        Search
                    </button>
                </div>
            ),
            onFilter: (value, record) => record.items.toString().toLowerCase().includes(value.toLowerCase()),

        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            sorter: (a, b) => {
                // Convert boolean to number and treat undefined as -1 or any other number that fits the sorting logic
                const convertStatusToNumber = status => {
                    if (status === undefined) return -1;
                    return status ? 1 : 0;
                };
                return convertStatusToNumber(a.status) - convertStatusToNumber(b.status);
            },
            render: status => (
                status ? <CheckOutlined style={{ color: 'green' }} /> : <CloseOutlined style={{ color: 'red' }} />
            ),
        },
    ];

    var Screenwidth = window.innerWidth;
    //===== GET TASKS LISTS =======
    useEffect(() => {

        onGetUserLists({})
        onGetHolidaysbyyear()

        onGetReminderLists({ createdby: userid })


        if ((localStorage.getItem('taskpage')) != 2) {
            localStorage.removeItem("taskfilter")
            localStorage.removeItem("tasktype")
            localStorage.removeItem("taskname")

        }
        else {
            localStorage.setItem('taskpage', 1)
        }
        if ((localStorage.getItem('taskfilter')) != undefined) {

            setConditions(localStorage.getItem('taskfilter'));
        }
        else {
            setConditions('all');
        }

        if ((localStorage.getItem('tasktype')) != undefined) {
            var intstatus = 0.0
            intstatus = parseFloat(localStorage.getItem('tasktype'))
            setStatus(intstatus);
        }
        else {
            setStatus(0);
        }

        if ((localStorage.getItem('action')) != undefined) {
            var actiontext = localStorage.getItem('action')
            if (actiontext == "opennewtask") {

                setCollapse(["1"]);
                localStorage.setItem("action", "opennewtask11")


            }
            else {
                setCollapse("");
            }

        }
        else {
            setCollapse("");
        }



        if ((localStorage.getItem('taskname')) != undefined) {

            onTaskSearch(localStorage.getItem('taskname'))

        }




        //  getusershiftdetail();

        getTaskTypeByShift()
        //  FunctiononGetAllTasksAllStatus()

    }, [])

    useEffect(() => {
        // Check if getUserMedia is supported
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            console.log('getUserMedia supported.');
        } else {
            console.log('getUserMedia not supported on your browser!');
        }

        // Cleanup function to revoke any unused audio URLs
        return () => {
            if (audioURL) {
                URL.revokeObjectURL(audioURL);
            }
        };
    }, [audioURL]);


    useEffect(() => {

        return () => {
            if (intervalIdRef.current) {
                clearInterval(intervalIdRef.current);
            }
        };
    }, []);

    useEffect(() => {
        // Scroll to the bottom when chatRoomItem changes
        if (chatContentRef.current) {
            chatContentRef.current.scrollTop = chatContentRef.current.scrollHeight;
        }
    }, [ChatRoomItem, chatdata]);

    //====== DATASOURCE ======
    useEffect(() => {
        //20210825 GET DATASOURCE

        if (displaymode == "task") {
            if (conditions != "" && status != -1) {

                setTaskLoading(false);
                onRefresh({ taskname: taskName, conditions: conditions, searchUser: searchUser, isSearch: 1, index: 1 });
                setcurrentask("main")
                setTaskName("")

            }
        }
        else {

            onGetselftaskdeadline()

            setLoadpreviousbutton(false)

        }

    }, [conditions, status, reloads]);

    useEffect(() => {

        //console.log("collapse >>>",collapse.length)

        scrollToAndFocusChecklist(collapse)

    }, [collapse])
    useEffect(() => {

        if (displaymode == "task") {
            console.log("linktaskid >>>", linktaskid)
            if (linktaskid == "created") {
                console.log("Repeated Task !!!")
            }
            else if (linktaskid) {
                setCollapse(linktaskid)
                onTaskChange(linktaskid)
                console.log(1111)
            }
            else {
                console.log(22222)
                if (conditions != "" && status != -1) {

                    console.log(33333)
                    setTaskLoading(false);
                    onRefresh({ taskname: taskName, conditions: conditions, searchUser: searchUser, isSearch: 1, index: 1 });
                    setcurrentask("main")
                    setTaskName("")

                }
            }

        }
        else if (displaymode == "self") {

            onGetselftaskdeadline()

            setLoadpreviousbutton(false)

        }

    }, [displaymode]);

    async function onGetselftaskdeadline(type) {

        setTaskLoading(true)

        var selfresult = await onSelfTaskDeadline({ userid: userid })

        console.log("selfresult >>", selfresult)
        var tasksByDate = {};
        if (selfresult.data && selfresult.data.group2 && selfresult.data.group2.length > 0) {
            var tasks = selfresult.data.group2

            const now = moment();
            const lastDeadline = tasks.reduce((latest, task) => {
                const taskDate = task.deadline ? moment.unix(task.deadline) : null;
                return (taskDate && (!latest || taskDate.isAfter(latest))) ? taskDate : latest;
            }, null);

            tasks.forEach(task => {
                let dateKey = task.deadline ? moment.unix(task.deadline).format('YYYY-MM-DD') : 'No Deadline';
                if (task.deadline && moment.unix(task.deadline).isBefore(now, 'day')) {
                    dateKey = moment.unix(task.deadline).format('YYYY-MM-DD');
                } else if (task.deadline) {
                    // For future tasks, ensure every day until the last deadline is accounted for
                    const endDate = lastDeadline ? lastDeadline.format('YYYY-MM-DD') : dateKey;
                    let currentDate = moment().format('YYYY-MM-DD');
                    while (currentDate <= endDate) {
                        if (!tasksByDate[currentDate]) {
                            tasksByDate[currentDate] = [];
                        }
                        currentDate = moment(currentDate).add(1, 'days').format('YYYY-MM-DD');
                    }
                }
                if (!tasksByDate[dateKey]) {
                    tasksByDate[dateKey] = [];
                }
                tasksByDate[dateKey].push(task);
            });

        }

        // Sorting tasks within each date
        Object.keys(tasksByDate).forEach(date => {
            tasksByDate[date].sort((a, b) => {
                return (a.deadline ? moment.unix(a.deadline) : moment().add(100, 'years'))
                    .diff(b.deadline ? moment.unix(b.deadline) : moment().add(100, 'years'));
            });
        });

        setSelfdatasource(tasksByDate)
        setSelfrawdatasource(selfresult.data.taskdata)
        console.log("tasksByDate >>", tasksByDate)


        setTaskLoading(false)
        //onNavigateToday()

    }
    // async function onGetselftaskdeadline(type) {

    //     setTaskLoading(true)

    //     var selfresult = await onSelfTaskDeadline({ userid: userid })

    //     //console.log("selfdatasource >>",selfdatasource)

    //     // console.log("selfrawdatasource >>",selfrawdatasource)

    //     var finalresult = []

    //     if (selfresult.data.length > 0) {
    //         finalresult = [...selfresult.data]
    //     }

    //     //console.log("finalresult >>>>", finalresult)
    //     if (finalresult.length > 0) {
    //         // Sort the finalresult by "deadline"
    //         const sortedFinalResult = finalresult.sort((a, b) => a.deadline - b.deadline);

    //         // Find the earliest date considering both startdate and deadline
    //         let initialStartDate = finalresult.find(item => item.startdate !== undefined);
    //         let startDate = initialStartDate ? moment.unix(initialStartDate.startdate) : moment.unix(finalresult[0].deadline);

    //         let earliestDate = finalresult.reduce((earliest, item) => {
    //             // Use item.deadline as a fallback if item.startdate is not available
    //             const itemStartDate = item.startdate ? moment.unix(item.startdate) : moment.unix(item.deadline);
    //             const itemDeadline = moment.unix(item.deadline);

    //             if (itemStartDate.isBefore(earliest)) {
    //                 return itemStartDate;
    //             }
    //             return earliest;
    //         }, moment.unix(finalresult[0].startdate || finalresult[0].deadline)); // Initialize with the first item's startdate or deadline


    //         const endDate = moment.unix(sortedFinalResult[sortedFinalResult.length - 1].deadline).add(1, 'day');


    //         console.log("earliestDate >>", earliestDate)
    //         console.log("endDate >>", endDate)
    //         // Initialize groupedByDate with all dates between start and end
    //         const groupedByDate = {};
    //         let currentDate = earliestDate.clone();

    //         while (currentDate.isSameOrBefore(endDate)) {
    //             const formattedDate = currentDate.format("dddd D-MMM-YYYY");
    //             groupedByDate[formattedDate] = [];
    //             currentDate.add(1, 'day');  // Move to the next day
    //         }

    //         // Fill in data for each date
    //         for (const item of sortedFinalResult) {
    //             if (item.startdate) {
    //                 const formattedStartDate = moment.unix(item.startdate).format("dddd D-MMM-YYYY");

    //                 if (groupedByDate[formattedStartDate]) {
    //                     groupedByDate[formattedStartDate].push({
    //                         ...item,
    //                         tasktype: "start",
    //                         newtaskid: `S${item._id}`
    //                         // Add other properties as needed
    //                     });
    //                 }
    //             }
    //             const formattedDate = moment.unix(item.deadline).format("dddd D-MMM-YYYY");

    //             // Check if the date exists in groupedByDate before pushing
    //             if (groupedByDate[formattedDate]) {
    //                 groupedByDate[formattedDate].push({
    //                     ...item,
    //                     tasktype: "end",
    //                     newtaskid: `E${item._id}`
    //                     // Add other properties as needed
    //                 });
    //             }
    //         }


    //         setSelfrawdatasource(finalresult)
    //         setSelfdatasource(groupedByDate)

    //         console.log(" groupedByDate >>>", groupedByDate)
    //     }
    //     else {
    //         setSelfdatasource([])
    //         setSelfrawdatasource([])

    //     }



    //     setTaskLoading(false)
    //     //onNavigateToday()

    // }

    async function onGetselfprevioudtaskdeadline(type) {

        setTaskLoading(true)

        var recordlength = selfdatasourcelength
        console.log("recordlength >>>", recordlength)
        var selfpreviousresult = await onSelfPreviousTaskDeadline({ userid: userid, recordlength: recordlength })

        var finalresult = []


        if (selfpreviousresult.data.length > 0) {
            setSelfdatasourcelength(recordlength + selfpreviousresult.data.length)

            finalresult = [...selfrawdatasource, ...selfpreviousresult.data]


            //console.log("finalresult >>>>", finalresult)
            if (finalresult.length > 0) {
                // Sort the finalresult by "deadline"
                const sortedFinalResult = finalresult.sort((a, b) => a.deadline - b.deadline);

                // Find the earliest date considering both startdate and deadline
                let initialStartDate = finalresult.find(item => item.startdate !== undefined);
                let startDate = initialStartDate ? moment.unix(initialStartDate.startdate) : moment.unix(finalresult[0].deadline);

                let earliestDate = finalresult.reduce((earliest, item) => {
                    // Use item.deadline as a fallback if item.startdate is not available
                    const itemStartDate = item.startdate ? moment.unix(item.startdate) : moment.unix(item.deadline);
                    const itemDeadline = moment.unix(item.deadline);

                    if (itemStartDate.isBefore(earliest)) {
                        return itemStartDate;
                    }
                    return earliest;
                }, moment.unix(finalresult[0].startdate || finalresult[0].deadline)); // Initialize with the first item's startdate or deadline


                const endDate = moment.unix(sortedFinalResult[sortedFinalResult.length - 1].deadline).add(1, 'day');



                // Initialize groupedByDate with all dates between start and end
                const groupedByDate = {};
                let currentDate = earliestDate.clone();

                while (currentDate.isSameOrBefore(endDate)) {
                    const formattedDate = currentDate.format("dddd D-MMM-YYYY");
                    groupedByDate[formattedDate] = [];
                    currentDate.add(1, 'day');  // Move to the next day
                }

                // Fill in data for each date
                for (const item of sortedFinalResult) {
                    if (item.startdate) {
                        const formattedStartDate = moment.unix(item.startdate).format("dddd D-MMM-YYYY");

                        if (groupedByDate[formattedStartDate]) {
                            groupedByDate[formattedStartDate].push({
                                ...item,
                                tasktype: "start",
                                newtaskid: `S${item._id}`
                                // Add other properties as needed
                            });
                        }
                    }
                    const formattedDate = moment.unix(item.deadline).format("dddd D-MMM-YYYY");

                    // Check if the date exists in groupedByDate before pushing
                    if (groupedByDate[formattedDate]) {
                        groupedByDate[formattedDate].push({
                            ...item,
                            tasktype: "end",
                            newtaskid: `E${item._id}`
                            // Add other properties as needed
                        });
                    }
                }


                setSelfrawdatasource(finalresult)
                setSelfdatasource(groupedByDate)
                setSelfloadmore(false)
            }

        }
        else {
            message.success("All Task Loaded !")
            setSelfdatasourcelength(0)
            setSelfloadmore(true)
        }
        console.log("selfpreviousresult >>>", selfpreviousresult)

        setTaskLoading(false)

    }
    async function getTaskTypeByShift() {
        var data = {}
        var result = await getUserbyId({ userid: userid })
        // const resultSourceProfile = await Source_ProfileGet(data1)
        if (result.data.length > 0) {
            if (result.data.department != undefined) {

                const result1 = await onGetDepartmentById({ departmentid: result.data.department })
                //   console.log("result1>>>",result1)
                if (result1.data[0].typelist != undefined) {
                    setuserdepartment(result1.data[0].name)
                    setTypeList([...result1.data[0].typelist])
                }
            }

        }



    }

    const TaskTypeListing = () => {
        return (
            <>
                {
                    typelist.map((f, index) =>
                        <Option value={f}>{f}</Option>

                    )
                }
            </>
        )
    }

    function dayjsstartdatechange(newValue) {
        if (newValue) {
            console.log("Start date change >>>", newValue);

            // If the new start date is after the current deadline,
            // adjust the deadline to be 1 day after the new start date.
            if (dayjsdate && dayjsdate.isBefore(newValue)) {
                setdayjsdate(newValue.add(1, 'day'));
            }

            // Update the start date.
            setdayjsstartdate(newValue);
        }
    }

    function dayjsdatechange(newValue) {
        if (newValue) {
            console.log("Deadline change >>>", newValue);

            // If the new deadline is before the current start date,
            // adjust the start date to be 1 day before the new deadline.
            if (dayjsstartdate && dayjsstartdate.isAfter(newValue)) {
                setdayjsstartdate(newValue.subtract(1, 'day'));
            }

            // Update the deadline.
            setdayjsdate(newValue);
        }
    }


    //======   GET USER SHIFT TIME ==========



    //===== CREATE FORM =======
    const onCreate = () => {
        //===== TO VALIDATE FORM ITEM ======
        form.validateFields()
            .then(values => {
                //let taskname    = values.taskname == undefined  || values.taskname.trim() == "" ? values.description.substr(0, 100) : values.taskname.trim();


                setTaskLoading(true)
                let deadline = dayjsdate == NaN ? "" : dayjsdate == undefined ? "" : dayjsdate == "" ? "" : moment(dayjsdate.$d).unix();
                let startdate = dayjsstartdate == NaN ? "" : dayjsstartdate == undefined ? "" : dayjsstartdate == "" ? "" : moment(dayjsstartdate.$d).unix();
                //let assignto = userLists.find(x => x.userid == values.assignto)?._id || "";
                // console.log("values >>>", values)
                // console.log("values.assignto >>>", values.assignto)

                let taguser = []
                if (values.assignto != undefined) {
                    if (values.assignto.length > 0) {
                        let obj = {}

                        values.assignto.forEach(function (items) {

                            obj = {}
                            obj["userid"] = userLists.find(x => x.userid == items)?._id || ""
                            obj["unread"] = 1
                            obj["countunread"] = 1
                            obj["permission"] = 'public'

                            taguser.push(obj)
                        })
                    }
                }

                let assignto = userid;
                let reportto = userLists.find(x => x.userid == values.assignto)?.reportto || "";
                let tasktype = values.tasktype || "Others";
                let taskpriority = values.taskpriority || "P0";
                let keyuser = values.keyuser || [];
                let tagdate = values.tagdate == undefined || values.tagdate == "" ? "" : values.tagdate.set({ "date": 1, "hour": 10, "minute": 59, "seconds": 59 }).unix();
                let tagname = ""


                let taskname1 = values.description.substr(0, 100).trim();

                var lines1 = taskname1.split('\n');

                let taskname = lines1[0].substr(0, 100).trim();
                localStorage.removeItem("taskuserid")

                setdayjsdate("")

                setdayjsstartdate("")

                console.log("startdate >>>>", startdate)
                console.log("save task value >>>>", values)


                if (values.tagname != undefined) {
                    if (values.tagname[0] != undefined) {
                        tagname = values.tagname[0].label
                        taskname = taskname + " : " + moment.unix(tagdate).format("MMMYY").toLocaleUpperCase() + ' ' + tagname.toLocaleUpperCase()

                    }
                    else if (values.tagname.label != undefined) {
                        tagname = values.tagname.label
                        taskname = taskname + " : " + moment.unix(tagdate).format("MMMYY").toLocaleUpperCase() + ' ' + tagname.toLocaleUpperCase()
                    }

                }

                //  taskname = taskname.toLocaleUpperCase()


                var newlist = []
                var obj = {}
                var count = 1
                // var newfulldatasource = fulllist.data

                // newfulldatasource.forEach(function(items)
                // {

                //     obj = {}
                //     if(items.mainthread == "")
                //     {
                //         if(items.tagdate == tagdate)
                //         {
                //             if(items.tagname == tagname)
                //             {
                //                 obj["taskname"] = items.taskname
                //                 obj["description"] = items.description
                //                 obj["tagdate"] = items.tagdate
                //                 obj["tagname"] = items.tagname
                //                 obj["createdte"] = moment.unix(items.createdte).format("YYYY-MM-DD")
                //                 obj["count"] = count
                //                 if(items.status == 0)
                //                 {
                //                     obj["status"] = "In Progress"
                //                 }
                //                 else if(items.status == 1)
                //                 {
                //                     obj["status"] = "Completed"
                //                 }
                //                 else if(items.status == 2)
                //                 {
                //                     obj["status"] = "On Hold"
                //                 }
                //                 else if(items.status == 3)
                //                 {
                //                     obj["status"] = "Approve"
                //                 }
                //                 else if(items.status == 9)
                //                 {
                //                     obj["status"] = "Cancel"
                //                 }
                //                 obj['mainthread'] = items.mainthread
                //                 newlist.push(obj)

                //             }
                //         }

                //     }

                // })


                // var GLeaguehelper6 = {};
                // var alerttable= newlist.reduce(function(r, o) {
                // var key = o.createdte+'-'+o.status;

                //    if (!GLeaguehelper6[key]) {
                //     GLeaguehelper6[key] = Object.assign({}, o); // create a copy of o
                //       r.push(GLeaguehelper6[key]);
                //    } else {
                //     GLeaguehelper6[key].count += o.count;
                //     // Ghelper[key].instances += o.instances;
                //    }
                //    return r;
                // }, []);

                // var summarytext = ""

                // for(var x =0;x < alerttable.length;x++)
                // {
                //     summarytext = summarytext+"\n"+"Created At : "+alerttable[x].createdte + " ,records :  " + alerttable[x].count + " ,status : " + alerttable[x].status +"\n"
                // }



                // if(alerttable.length >= 1 && tagname != "" && tagdate != "" && isEdit != 1)
                // {
                //     var answer = window.confirm('Found '+ newlist.length +' records duplicates \n'+summarytext + "\nPress [ OK ] to continue create new task." + "\nPress [ Cancel ] to cancel process.");
                //     if (answer) {
                //         // Save it!
                //         console.log('Thing was saved to the database.');
                //       } else {
                //         // Do nothing!
                //         console.log('Thing was not saved to the database.');
                //         return
                //       }
                // }

                let staatunread = 1
                if (assignto == userid) {
                    staatunread = 0
                }
                //===== SEND TO API =======
                // if (isEdit == 1 && assignto == userid) {
                //     message.error(GetTranslation(userlang, "Cannot assign to self"));
                // }
                if (taskpriority != "P0" && deadline == "" && tasktype != "Others") {
                    message.error(GetTranslation(userlang, "Deadline Missing"));
                }
                else if (isEdit == 2) {

                    values = {
                        taskid: values.taskid,
                        filepath: values.filepath,
                        taskpriority: taskpriority,
                        taskname: taskname,
                        description: values.description,
                        deadline: deadline,
                        startdate: startdate,
                        status: 0,
                        assignto: assignto,
                        createdby: userid,
                        reportto: reportto,
                        mainthread: values.mainthread,
                        tasktype: tasktype,
                        keyuser: keyuser,
                        plansdate: "",
                        planedate: "",
                        workmanhours: 0,
                        workmantype: "",
                        actsdate: "",
                        actendate: "",
                        process: "",
                        currentstatus: "Not Planned",
                        extendcount: 0,
                        extenddeadline: "",
                        checklist: [],
                        tagdate: tagdate,
                        tagname: tagname,
                        taguser: taguser,
                        lastmsgtime: moment().unix(),
                        cbunread: 0,
                        atunread: staatunread
                    }

                    console.log("update task >>>", values)



                    onCreateAttachment(filelist)
                        .then(val => {
                            console.log("111")
                            if (val.data && val.data != undefined && val.data.length > 0) {
                                var path = val.data;
                                values.filepath = path.map(x => x.filepath).toString();
                            }
                            console.log("222")


                        })
                        .catch(err => {
                            message.error("Failed to upload attachments");
                            setBtnDisable(false);
                        });

                    onUpdate(values)

                    setTaskLoading(false)
                    //onRefresh({ taskname: taskName, conditions: conditions, searchUser: searchUser, isSearch: 1, index: 1 });

                    //onReload()
                }
                else {
                    values = {
                        taskpriority: taskpriority,
                        taskname: taskname,
                        description: values.description,
                        deadline: deadline,
                        startdate: startdate,
                        status: 0,
                        assignto: assignto,
                        createdby: userid,
                        reportto: reportto,
                        mainthread: isEdit == 1 ? values.mainthread : "",
                        tasktype: tasktype,
                        keyuser: keyuser,
                        plansdate: "",
                        planedate: "",
                        workmanhours: 0,
                        workmantype: "",
                        actsdate: "",
                        actendate: "",
                        process: "",
                        currentstatus: "Not Planned",
                        extendcount: 0,
                        extenddeadline: "",
                        checklist: [],
                        tagdate: tagdate,
                        tagname: tagname,
                        taguser: taguser,
                        lastmsgtime: moment().unix(),
                        cbunread: 0,
                        atunread: staatunread
                    }


                    onCreateAttachment(filelist)
                        .then(val => {
                            if (val.data && val.data != undefined && val.data.length > 0) {
                                var path = val.data;
                                values.filepath = path.map(x => x.filepath).toString();
                            }

                            //====== CREATE TASKS =======
                            onCreateTasks(values)
                                .then(updateval => {
                                    //===== UPDATE MAIN THREAD ID ATS TO 1 IF THE MAIN TASKS IS ASSIGN TO ======
                                    console.log("updateval >>>", updateval)
                                    setTaskLoading(false)
                                    if (updateval.msg == "Chat Existed") {

                                        let newds = { all: [] }
                                        newds.all = updateval.data

                                        //setNewDatasource(result.data)


                                        onRefreshNewDatasource(newds, conditions);

                                        setLinktaskid("create")
                                        setDisplaymode("task");

                                        setCollapse()
                                        message.error("Chat created fail, found related chat !")
                                    }
                                    else {
                                        if (isEdit == 1) {
                                            return onGetRelatedTasks({ mainthreadid: values.mainthread })
                                                .then(parentData => {
                                                    if (parentData.status == "err") {
                                                        throw parentData.msg;
                                                    }
                                                    if (updateval.data.deadline != "") {
                                                        var tempdeadline = moment.unix(updateval.data.deadline)

                                                        var tempdeadline2 = moment(tempdeadline).subtract(2, "hours")
                                                        if (updateval.data.assignto == userid) {
                                                            CreateDeadlineReminder(updateval.data.taskid, updateval.data.taskname, moment(tempdeadline2).unix(), userid, updateval.data.assignto)
                                                        }
                                                        else {
                                                            CreateDeadlineReminder(updateval.data.taskid, updateval.data.taskname, moment(tempdeadline2).unix(), userid, updateval.data.assignto)

                                                            CreateDeadlineReminder(updateval.data.taskid, updateval.data.taskname, moment(tempdeadline2).unix(), userid, updateval.data.createdby)
                                                        }


                                                    }


                                                    // let parentData  = datasource.find(x => x._id == values.mainthread);
                                                    if (parentData.data[0]?.assignto == userid) {
                                                        //==== IF THE TASKS ASSIGN TO IS YOU (userid) =====
                                                        return onUpdateTasks({
                                                            taskid: values.mainthread,
                                                            ats: 1
                                                        }).then(data => {
                                                            return updateval.data;
                                                        })
                                                    }

                                                    if (parentData.data[0]?.createdby == userid) {
                                                        return onUpdateTasks({
                                                            taskid: values.mainthread,
                                                            cbs: 1
                                                        })
                                                            .then(data => {
                                                                return updateval.data;
                                                            })
                                                    }
                                                })
                                                .catch(err => {
                                                    return err;
                                                });
                                        }
                                        else {

                                            if (updateval.data.deadline != "") {
                                                var tempdeadline = moment.unix(updateval.data.deadline)

                                                var tempdeadline2 = moment(tempdeadline).subtract(2, "hours")

                                                if (updateval.data.assignto == userid) {
                                                    CreateDeadlineReminder(updateval.data._id, updateval.data.taskname, moment(tempdeadline2).unix(), userid, updateval.data.assignto)
                                                }
                                                else {
                                                    CreateDeadlineReminder(updateval.data._id, updateval.data.taskname, moment(tempdeadline2).unix(), userid, updateval.data.assignto)

                                                    CreateDeadlineReminder(updateval.data._id, updateval.data.taskname, moment(tempdeadline2).unix(), userid, updateval.data.createdby)
                                                }
                                            }


                                            return updateval.data;
                                        }
                                    }


                                })
                                .then(x => {
                                    console.log("save task >>>", x)

                                    if (x == undefined) {

                                    }
                                    else {
                                        //===== ADD DATASOURCE ======
                                        let newConditions;
                                        if (x.assignto == userid) {
                                            newConditions = "all";
                                        }
                                        else {
                                            newConditions = "all";
                                        }

                                        let newTaskData = datasource;
                                        if (newTaskData[newConditions] == undefined) { newTaskData[newConditions] = [] }
                                        newTaskData[newConditions].push(x);
                                        // 20210829 IF CONDITIONS IS SELF, NEED ADD ON REQUESTED
                                        if (newConditions == "self") {
                                            newTaskData["all"].push(x);
                                        }


                                        setDataSource(newTaskData);

                                        //=== IF GOT SEARCH TASK NAME ======
                                        if (taskName != "") {
                                            onRefreshNewDatasource(newTaskData, "all");    // put this because use effect not reading
                                        }
                                        else {
                                            //== NO TASK NAME AND GOT CONDITIONS ===
                                            onRefreshNewDatasource(newTaskData, conditions);    // put this because use effect not reading
                                        }

                                        setIsEdit(0);
                                        setCollapse([]);
                                        message.success(GetTranslation(userlang, "New chat create successfully!!"));
                                        if (x.deadline != "" && x.assignto == userid) {
                                            if (displaymode == "self") {
                                                onGetselftaskdeadline()
                                            }


                                        }

                                        // FunctiononGetAllTasksAllStatus()
                                        form.resetFields();
                                    }

                                }).catch(err => {
                                    message.error("Failed to create chat");
                                    console.log("error", err)
                                });
                        })
                        .catch(err => {
                            message.error("Failed to upload attachments");
                            setBtnDisable(false);
                        });
                }
            });
    }

    async function CreateDeadlineReminder(taskid, taskname, deadline, Puserid, Passignto) {

        var tempreminderdate = moment.unix(deadline).format("YYYYMMDD");
        var tempremindertime = moment.unix(deadline).format("HH:mm");
        var crontab = ""
        var splitvar = tempremindertime.split(":")


        crontab = splitvar[1].toString() + " " +
            splitvar[0].toString() + " " +
            moment(tempreminderdate).format("DD").toString() + " " +
            moment(tempreminderdate).format("MM").toString() + " " +
            "*"




        var data =
        {
            taskid: taskid,
            chatid: "",
            taskname: taskname,
            message: "",
            rgroup: "deadline",
            rtype: "once",
            rperiod: "",
            rdate: deadline,
            rtime: remindertime,
            rweek: [],
            rmonth: "",
            rstatus: 1,
            createdby: Passignto,
            crontab: crontab
        }

        const result = updateDeadlineReminder(data);

    }

    async function DeleteDeadlineReminder(taskid) {
        var data =
        {
            taskid: taskid,

        }
        console.log("remidner delete data >>>>", data)
        const result = removeDeadlineReminder(data);

    }

    async function updateDeadlineReminder(data) {
        const result = await onUpdateTasksReminder(data);
        if (result && result.status === "ok") {
        }
        else {
            message.error(result.msg);

        }
    };

    async function removeDeadlineReminder(data) {

        const result = await onRemoveTasksReminder2(data);
        if (result && result.status === "ok") {
        }
        else {
            message.error(result.msg);

        }
    };
    //==== ON REFRESH ===
    const onRefresh = (data) => {
        setTaskLoading(true)
        let { conditions = '', taskname = '', isSearch = 0, searchUser = '', index = 1 } = data;
        var newStatus = status;

        //===== STATUS IS UNVERIFIED (1.1) =====
        if (newStatus == 1.1) {
            newStatus = 1;
        }

        if (conditions == "all") {
            //const allConditions = ["self", "requested", "instructed", "subordinary"];
            const allConditions = ["all"]
            //let selflen, requestedlen, instructedlen, subordinarylen;
            let alllen

            //===== IF SEARCH BY TITLE ======
            if (isSearch == 1) {
                alllen = 1;
            }
            // else{
            //     // INDEX FOR PARAM USE FOR LOAD MORE HERE
            //     selflen         = datasource[allConditions[0]].filter(x => x.status == newStatus).length == 0 ? 1 : datasource[allConditions[0]].filter(x => x.status == newStatus).length + 1;
            //     // DEDUCT IS BECAUSE GOT SELF INSIDE REQ
            //     requestedlen    = datasource[allConditions[1]].filter(x => x.status == newStatus).length == 0 ? 1 : datasource[allConditions[1]].filter(x => x.status == newStatus).length + 1 - selflen + 1;
            //     instructedlen   = datasource[allConditions[2]].filter(x => x.status == newStatus).length == 0 ? 1 : datasource[allConditions[2]].filter(x => x.status == newStatus).length + 1;
            //     subordinarylen  = datasource[allConditions[3]].filter(x => x.status == newStatus).length == 0 ? 1 : datasource[allConditions[3]].filter(x => x.status == newStatus).length + 1;
            // }
            else {
                alllen = datasource[allConditions[0]].length
            }



            return Promise.all([
                onGetTasks({ searchUser: searchUser, taskname: taskname, index: alllen, conditions: allConditions[0], status: newStatus, userid: userid })
            ])
                .then(([all]) => {
                    let newds = isSearch == 1 ? { "all": [] } : datasource;
                    //let newds           =  datasource;
                    newds = onCheckExist(all.data, newds, allConditions[0]); // ALL

                    console.log('newds >>> ', newds);
                    setDataSource(newds);

                    onRefreshNewDatasource(newds, conditions);
                    //=== INIT TASK LOADING ===
                    settaskInitLoading(false);
                    setTaskLoading(false)
                })
                .catch(err => {
                    console.log("111")
                    message.error(GetTranslation(userlang, "Cannot get data"));
                    setIsMaintenance(true);
                });
        }
        else {
            //===== IF SEARCH BY TITLE ======
            if (isSearch == 1) {
                index = 1;
            }

            return Promise.all([
                onGetTasks({ searchUser: searchUser, taskname: taskname, index: index, conditions: conditions, status: newStatus, userid: userid })
            ])
                .then(([val]) => {
                    let newds = isSearch == 1 ? { "all": [] } : datasource;
                    newds = onCheckExist(val.data, newds, conditions);    // TO CHECK DATA IS EXIST

                    setDataSource(newds);
                    onRefreshNewDatasource(newds, conditions);
                    //=== INIT TASK LOADING ===
                    settaskInitLoading(false);
                    setTaskLoading(false)
                })
                .catch(err => {
                    console.log("222")
                    message.error(GetTranslation(userlang, "Cannot get data"));
                    setIsMaintenance(true);
                });
        }

    }

    //===== ON REFRESH AND SET NEW DATASOURCE ======
    const onRefreshNewDatasource = (ds, cond) => {


        if (cond == "all") {
            let table = ds;
            if (table[cond] == undefined) {
                table[cond] = [];
            }


            //==== ADD SELF, REQUESTED, INSTRUCTED AND SUBORDINARY TO TABLE[ALL] ====
            table = onCheckExist(ds["all"], table, cond);

            table = table[cond];
            console.log('TABLE >>>> ', table);
            // IF NO SEARCH BY TASK NAME NO NEED STATUS LOAD
            // if(taskName == ""){
            //     table               = onStatusLoad(status, table);
            // }


            //==== SORT BY UPDATETE =====
            onSort(table);
            setNewDatasource(table);
            setnewindex(table.length + 1);

        }
        else if (cond == "requested") {
            let table = ds;

            //==== ADD SELF TO TABLE[REQUESTED] ====
            table = onCheckExist(ds["self"], table, cond);
            table = table[cond];
            table = onStatusLoad(status, table);

            //  console.log('TABLE REQ >>> ', table);

            //==== SORT BY UPDATETE =====
            onSort(table);
            setNewDatasource(table);
            setnewindex(table.length + 1);
        }
        else {
            let table = ds[cond];
            table = onStatusLoad(status, table);

            console.log('TABLE >>>> ', table);

            //==== SORT BY UPDATETE =====
            onSort(table);
            setNewDatasource(table);
            setnewindex(table.length + 1);
        }



        if (ds.all != undefined) {
            var Grouphelper = {};
            var NewTagNameList = ds.all.reduce(function (r, o) {
                var key = o.tagname;

                if (!Grouphelper[key]) {
                    Grouphelper[key] = Object.assign({}, o); // create a copy of o
                    r.push(Grouphelper[key]);
                } else {
                    //Grouphelper[key].count += o.count;
                    // Ghelper[key].instances += o.instances;
                }
                return r;
            }, []);

            var newlist = [];
            var obj = {};
            var count = 0;

            NewTagNameList.forEach(function (items) {

                obj = {}
                if (items.tagname != undefined) {
                    if (items.tagname != "") {
                        obj["value"] = items.tagname.toString().trim().toLocaleUpperCase()
                        obj["label"] = items.tagname.toString().trim().toLocaleUpperCase()
                        newlist.push(obj)
                    }
                }

            })
            settagnamelist([...newlist])

            //   console.log('NewTagNameList >>',newlist)

        }

    }

    const onReminderRedirectDatasource = (data) => {

    }

    //====== ON TASK DATA GET ======
    const onTaskNameDatasource = (data) => {
        let { taskname = '', isSearch = 0, searchUser = '' } = data;
        const allConditions = ["all"];
        let alllen;

        //===== IF SEARCH BY TITLE ======
        if (isSearch == 1) {
            alllen = 1   //20210920 Add Subordinary
        }
        else {
            // INDEX FOR PARAM USE FOR LOAD MORE HERE
            alllen = datasource[allConditions[0]].length == 0 ? 1 : datasource[allConditions[0]].length + 1
        }

        if (searchUser != "") {
            //==== IF SEARCH USER NO NEED CHECK FOR SELF ====
            return Promise.all([
                onGetTasks({ searchUser: searchUser, taskname: taskname, index: alllen, conditions: allConditions[0], userid: userid })
            ])
                .then(([all]) => {
                    let newds = isSearch == 1 ? { "all": [] } : datasource;
                    newds = onCheckExist(all.data, newds, allConditions[0]);

                    setDataSource(newds);
                    onRefreshNewDatasource(newds, "all");

                    //   setConditions("");
                    //   setStatus(-1);

                    // setNewDatasource(newds);
                    // setnewindex(newds.length + 1);


                    //==== IF INDEX IS 1 AND NO TASK FOUND ======
                    // else if(Object.keys(val.data).length == 0 && index == 1){
                    //     setNewDatasource([]);
                    //     setnewindex(1);
                    // }
                    // setDataSource(newds);
                    // onRefreshNewDatasource(newds);
                    // //=== INIT TASK LOADING ===
                    // settaskInitLoading(false);
                })
                .catch(err => {
                    console.log("333")
                    message.error(GetTranslation(userlang, "Cannot get data"));
                    setIsMaintenance(true);
                });
        }
        else {
            return Promise.all([
                onGetTasks({ searchUser: searchUser, taskname: taskname, index: alllen, conditions: allConditions[0], userid: userid })
            ])
                .then(([all]) => {
                    let newds = isSearch == 1 ? { "all": [] } : datasource;
                    newds = onCheckExist(all.data, newds, allConditions[0]);

                    setDataSource(newds);
                    onRefreshNewDatasource(newds, "all");

                    // setConditions("");
                    // setStatus(-1);
                })
                .catch(err => {
                    console.log("444")
                    message.error(GetTranslation(userlang, "Cannot get data"));
                    setIsMaintenance(true);
                });
        }
    }

    //====== ON GET USER LISTS ======= 
    const onGetUserLists = async (data) => {
        var result = await onGetUserContact({ userid: userid })

        var finaluserlist = []
        var finalmentionuserlist = []

        return getAllUserLists(data)
            .then(user => {

                setFULLUserLists(user.data)
                let usertemplist1 = user.data

                var ownuserid = usertemplist1.filter(x => x._id == userid);

                var tempuserid = usertemplist1.filter(x => x._id != userid);

                let tempmentionuserlist = []

                var usertemplist = []
                usertemplist.push(ownuserid[0])

                for (var x = 0; x < tempuserid.length; x++) {
                    usertemplist.push(tempuserid[x])
                }


                if (globalgrouping == "public") {

                    for (var x = 0; x < usertemplist.length; x++) {
                        tempmentionuserlist.push({ display: usertemplist[x].userid, id: usertemplist[x].userid, _id: usertemplist[x]._id })
                    }


                    finaluserlist = usertemplist
                    finalmentionuserlist = tempmentionuserlist

                }
                else if (globalgrouping == "private") {
                    let temptable = usertemplist
                    let temptable1 = usertemplist

                    var buildnew1 = temptable.filter(function (buildnew1) {
                        return buildnew1._id == userid;
                    });
                    var buildnew2 = temptable1.filter(function (buildnew1) {
                        return buildnew1._id == usertemplist.find(x => x._id == userid)?.reportto || "";
                    });

                    if (buildnew2.length > 0) {
                        buildnew1.push(buildnew2[0])
                    }

                    for (var x = 0; x < buildnew1.length; x++) {
                        tempmentionuserlist.push({ display: buildnew1[x].userid, id: buildnew1[x].userid, _id: usertemplist[x]._id })
                    }

                    finaluserlist = buildnew1
                    finalmentionuserlist = tempmentionuserlist
                }
                else if (globalgrouping == "department") {

                    let temptable = usertemplist
                    let temptable1 = usertemplist
                    var buildnew1 = temptable.filter(function (buildnew1) {
                        return buildnew1.department == globaldepartment;
                    });

                    var buildnew2 = temptable1.filter(function (buildnew1) {
                        return buildnew1._id == usertemplist.find(x => x._id == userid)?.reportto || "";
                    });

                    if (buildnew2.length > 0) {
                        buildnew1.push(buildnew2[0])
                    }

                    for (var x = 0; x < buildnew1.length; x++) {
                        tempmentionuserlist.push({ display: buildnew1[x].userid, id: buildnew1[x].userid, _id: usertemplist[x]._id })
                    }


                    finaluserlist = buildnew1
                    finalmentionuserlist = tempmentionuserlist

                }
                else {
                    for (var x = 0; x < usertemplist.length; x++) {
                        tempmentionuserlist.push({ display: usertemplist[x].userid, id: usertemplist[x].userid, _id: usertemplist[x]._id })
                    }

                    finaluserlist = usertemplist
                    finalmentionuserlist = tempmentionuserlist
                }


                var result1
                if (result.data.length != undefined) {
                    result1 = result.data.filter(x => x.cstatus == 1)
                }

                if (result1 != undefined) {
                    for (var x = 0; x < result1.length; x++) {
                        finaluserlist.push(result1[x])
                    }

                    for (var x = 0; x < result1.length; x++) {
                        finalmentionuserlist.push({ display: result1[x].userid, id: result1[x].userid, _id: usertemplist[x]._id })
                    }
                }

                var Grouphelper = {};
                var Grouphelperresult = finaluserlist.reduce(function (r, o) {
                    var key = o._id + '-' + o.useird;

                    if (!Grouphelper[key]) {
                        Grouphelper[key] = Object.assign({}, o); // create a copy of o
                        r.push(Grouphelper[key]);
                    } else {
                        Grouphelper[key].userid = o.userid;
                        //Grouphelper[key].sourceCount += o.sourceCount;
                        // Ghelper[key].instances += o.instances;
                    }
                    return r;
                }, []);

                var Grouphelper1 = {};
                var Grouphelperresult1 = finalmentionuserlist.reduce(function (r, o) {
                    var key = o.id;

                    if (!Grouphelper1[key]) {
                        Grouphelper1[key] = Object.assign({}, o); // create a copy of o
                        r.push(Grouphelper1[key]);
                    } else {
                        Grouphelper1[key].id = o.id;
                        //Grouphelper[key].sourceCount += o.sourceCount;
                        // Ghelper[key].instances += o.instances;
                    }
                    return r;
                }, []);

                console.log("finalmentionuserlist >>>", finalmentionuserlist)
                console.log("finaluserlist >>>", finaluserlist)
                console.log("Grouphelperresult1 >>>", Grouphelperresult1)
                setMentionValue(Grouphelperresult1)
                setUserLists(Grouphelperresult);
            })
            .catch(err => {
                console.log("555")
                message.error(GetTranslation(userlang, "Cannot get data"));
                setIsMaintenance(true);
            });


    }

    const onGetHolidaysbyyear = async (data) => {

        var result = await onGetHoliday({ yearint: [moment().year(), moment().subtract(1, "year").year()] })

        console.log("holidays result >>>", result)

        if (result.data.length > 0) {

            var obj = {}
            var newoutput = []




            result.data.forEach(function (items) {

                // Parse the UTC date
                var utcDate = moment.utc(items.date);

                // Convert it to the local timezone
                var localDate = utcDate.local();

                // Format the date
                var formattedDate = localDate.format('dddd D-MMM-YYYY');


                obj = {}

                obj["formattedDate"] = formattedDate
                obj["title"] = items.title

                newoutput.push(obj)

            })
            setHolidaysdatasource(newoutput)
        }
    }
    const onGetReminderLists = (data) => {
        return onGetTasksReminder(data)
            .then(user => {

                var result11 = user.data.filter(x => x.rgroup == "task");
                setreminderdatasource(result11)

            })
            .catch(err => {
                message.error(GetTranslation(userlang, "Cannot get reminder"));
                setIsMaintenance(true);
            });


    }

    const onConditionChange = (data) => {
        console.log("onConditionChange data >>>", data)
        setnewindex(1);
        setConditions(data);

    }

    const onStatusChange = (data) => {
        console.log("onStatusChange data >>>", data)
        setnewindex(1);
        setStatus(data);
    }

    //20210718 add refresh all windows
    const onReload = (data) => {
        // setRefreshDisable(true);
        // window.location.reload();

        let x = reloads
        x++
        setReloads(x)
    }

    const onUpdate = (data, tempdeadline, tempchecklist, temptaguser, tempstartdate, tempnotelist) => {
        //===== UPDATE DEADLINES ======
        let obj = {};
        const id = data._id; //MONGO ID DATA
        let temppingmsg
        if (deadline != "") {

            if (extenddisable == true) {
                obj = {
                    taskid: id,
                    extenddeadline: deadline.unix(),
                    extendcount: data.extendcount + 1,
                    currentstatus: "In Progress"
                }

            }
            else {
                obj = {
                    taskid: id,
                    deadline: deadline.unix()
                }

            }

        }
        if (startdate != "") {
            obj = {
                taskid: id,
                startdate: startdate.unix()
            }
        }
        if (tempdeadline) {


            obj = {
                taskid: id,
                deadline: tempdeadline.unix(),

            }
        }
        if (tempstartdate) {
            obj = {
                taskid: id,
                startdate: tempstartdate.unix()
            }
        }
        if (tempnotelist) {
            obj = {
                taskid: id,
                notelist: tempnotelist
            }
        }
        //===== UPDATE PLAN DATE ======
        if (plansdate != "") {

            var plansdate1 = plansdate
            var dateObj = new Date(plansdate1);
            var plansdate1 = moment(dateObj);
            var workmanhours1 = plansdate.diff(planedate, "hours")



            //  if(workmantype == "Days")
            //  {

            //   planedate1 = moment(plansdate1,"YYYY-MM-DD HH:59").add(workmanhous1,"days")
            //   console.log("Add Days")
            //  }
            //  else
            //  {

            //   planedate1 = moment(plansdate1,"YYYY-MM-DD HH:59").add(workmanhous1,"hours")
            //   console.log("Add Hours")
            //  }


            obj = {
                taskid: id,
                plansdate: plansdate.unix(),
                planedate: planedate.unix(),
                workmanhours: workmanhours1,
                workmantype: "Hours",
                currentstatus: "Not Started"
            }


        }

        // ==== TASK ITEM ======

        if (tempchecklist != undefined) {

            obj = {
                taskid: id,
                checklist: tempchecklist
            }


        }

        if (temptaguser != undefined) {
            obj = {
                taskid: id,
                taguser: temptaguser
            }
        }
        if (newStatus != -1) {
            let completedate = moment().unix();
            //if(data.completedate == "" || data.completedate == undefined){

            // === UPDATE START NOW =======
            if (newStatus == 0 && currentstatus == "In Progress") {
                obj = {
                    taskid: id,
                    currentstatus: currentstatus,
                    actsdate: moment().unix(),
                    status: newStatus
                }

            }
            else if ((newStatus == 1 || newStatus == 3) && currentstatus == "Complete Task") {

                if (data.createdby == userid) {
                    obj = {
                        taskid: id,
                        currentstatus: currentstatus,
                        actendate: moment().unix(),
                        status: newStatus,
                        completedate: completedate,
                    }
                }
                else {
                    obj = {
                        taskid: id,
                        currentstatus: currentstatus,
                        status: newStatus,
                        completedate: completedate,
                    }
                }
            }
            else if (newStatus == 1 && currentstatus == "Submited Task") {

                obj = {
                    taskid: id,
                    currentstatus: currentstatus,
                    actendate: moment().unix(),
                    status: newStatus,
                    completedate: completedate
                }

            }
            else if (data.status == 2 & newStatus == 0 && data.currentstatus == "On Hold" && currentstatus == "Not Planned") {
                obj = {
                    taskid: id,
                    currentstatus: currentstatus,
                    plansdate: "",
                    planedate: "",
                    deadline: "",
                    actsdate: "",
                    workmanhours: 0,
                    actendate: "",
                    extendcount: 0,
                    extenddeadline: "",
                    status: newStatus,
                    completedate: completedate
                }
            }
            else {
                // === UPDATE STATUS =======
                obj = {
                    taskid: id,
                    status: newStatus,
                    currentstatus: currentstatus,
                    completedate: completedate,
                }
            }
        }

        if (isEdit == 2) {
            obj = {
                taskid: data.taskid,
                taskname: data.taskname,
                description: data.description,
                deadline: data.deadline,
                assignto: data.assignto,
                filepath: data.filepath
            }

        }


        console.log("update obj >>>", obj)
        onUpdateTasks(obj)
            .then(x => {
                setdayjsdate()

                if (newStatus == 3 || newStatus == 9) {
                    console.log("delete reminder !!!")
                    DeleteDeadlineReminder(id)
                }
                //==== update data ====
                if (deadline != "") {
                    if (extenddisable == true) {
                        data.extenddeadline = deadline.unix()
                        data.extendcount += 1
                        data.currentstatus = "In Progress"
                    }
                    else {

                        data.deadline = deadline.unix();

                    }
                    // onRefreshDatepicker(data);
                }

                if (startdate != "") {
                    data.startdate = startdate.unix();
                }
                if (tempdeadline) {
                    data.deadline = tempdeadline.unix()
                }
                if (tempstartdate) {
                    data.startdate = tempstartdate.unix();
                }
                //==== update Plan date ====

                if (plansdate != "") {

                    var plansdate1 = plansdate
                    var dateObj = new Date(plansdate1);
                    var plansdate1 = moment(dateObj);
                    var workmanhours1 = plansdate.diff(planedate, "hours")



                    data.plansdate = plansdate.unix();
                    data.planedate = planedate.unix();
                    data.workmanhours = workmanhours1
                    data.workmantype = "Hours"
                    data.currentstatus = "Not Started"
                    //  onRefreshDatepicker(data);
                }

                // === UPDATE START NOW =======
                if (currentstatus == "In Progress") {
                    data.currentstatus = currentstatus
                    data.actsdate = moment().unix
                }
                else if ((newStatus == 1 || newStatus == 3) && currentstatus == "Complete Task") {

                    if (data.createdby == userid) {
                        // obj = {
                        //     taskid: id,
                        //     currentstatus: currentstatus,
                        //     actendate: moment().unix(),
                        //     status: newStatus,
                        //     completedate: completedate,
                        // }
                        data.actendate = moment().unix()
                        data.completedate = moment().unix()
                    }
                    else {
                        // obj = {
                        //     taskid: id,
                        //     currentstatus: currentstatus,
                        //     status: newStatus,
                        //     completedate: completedate,
                        // }
                        data.completedate = moment().unix()
                    }

                }

                //==== TASK ITEM ======
                if (tempchecklist != "" && tempchecklist != undefined && tempchecklist.length > 0) {
                    data.checklist = tempchecklist

                }

                if (temptaguser != "" && temptaguser != undefined && temptaguser.length > 0) {
                    data.taguser = temptaguser

                }

                //===== update status ======
                if (newStatus != -1) {
                    data.status = newStatus;
                    data.currentstatus = currentstatus
                }

                if (isEdit == 2) {
                    console.log("update x >>>", x)

                    console.log("update data >>>", data)
                }
                let _editid = x.data._id;
                let editData = datasource[conditions].filter(x => x._id == _editid);
                let newTaskData = datasource
                newTaskData[conditions] = newTaskData[conditions].filter(y => y._id != _editid);
                newTaskData[conditions].push(x.data);
                setDataSource(newTaskData);

                console.log("newTaskData >>>", newTaskData)

                let newSelfData = selfrawdatasource
                newSelfData = newSelfData.filter(y => y._id != _editid);
                newSelfData.push(x.data);
                //onRefreshNewDatasource(newTaskData, conditions);    // put this because use effect not reading

                // setStatus(newStatus);       // Filter Status with ds
                // setStatus(status);          // Change back to remaining status
                message.success(GetTranslation(userlang, "Update successful"));

                if (displaymode == 'self') {
                    onGetselftaskdeadline()
                    // let _editid = x.data._id;
                    // let newSelftaskdata = selfrawdatasource
                    // newSelftaskdata = newSelftaskdata.filter(y => y._id != _editid);
                    // newSelftaskdata.push(x.data);

                }

                return data;

            })
            .then(data => {

                if (isEdit == 2) {
                    data._id = data.taskid
                    // data.filepath = ""
                    var oldtaskdata = editdata

                    var msg = `Task title and description updated at ${moment().format("DD/M ddd h:mm a")}\n 
                               Previous info : \n ${oldtaskdata.description}`


                    onSendMessage(data, msg)

                    setEditdata(null)
                    setIsEdit(0)
                    //onReload()
                }
                else {
                    onSendMessage(data)
                }

                setBtnDisable(false)

            });
    }

    const onUpdateStatus = (data, status, currentstatus, taskcondition) => {
        //===== UPDATE DEADLINES ======
        let obj = {};
        const id = data._id; //MONGO ID DATA

        obj = {
            taskid: id,
            currentstatus: currentstatus,
            actendate: moment().unix(),
            status: status,
            completedate: moment().unix(),
        }



        onUpdateTasks(obj)
            .then(x => {
                //  onSendMessage(data,`Approved at ${moment().format("DD/M ddd h:mm a")}`)
                data.status = status;
                data.currentstatus = currentstatus

                if (status == 3 || status == 9) {
                    console.log("delete reminder !!!")
                    DeleteDeadlineReminder(id)
                }

                let _editid = x.data._id;
                let editData = datasource[conditions].filter(x => x._id == _editid);
                let newTaskData = datasource
                newTaskData[conditions] = newTaskData[conditions].filter(y => y._id != _editid);

                newTaskData[conditions].push(x.data);
                setDataSource(newTaskData);
                // onRefreshNewDatasource(newTaskData, conditions);    // put this because use effect not reading

                // setStatus(newStatus);       // Filter Status with ds
                // setStatus(status);          // Change back to remaining status
                message.success(GetTranslation(userlang, "Update successful"));

                return data;

            })
            .then(data => {
                var msgconent = ""
                // if(taskcondition = 'sub')
                // {
                //     if(data.status == 3 )
                //     {
                //         msgconent = "Parent Task Approve"
                //     }
                //     else if(data.status ==9)
                //     {
                //         msgconent = "Parent Task Cancel"
                //     }
                // }
                // else
                // {
                if (data.status == 3) {
                    msgconent = "Approve"
                }
                else if (data.status == 9) {
                    msgconent = "Cancel"
                }
                //  }


                var msg = `${msgconent} at ${moment().format("DD/M ddd h:mm a")}`
                onSendMessage(data, msg)
            });
    }



    const onUpdateActiveStatus = (data, tempdeadline) => {
        //===== UPDATE DEADLINES ======
        let obj = {};
        const id = data._id; //MONGO ID DATA

        obj = {
            taskid: id,
            currentstatus: "Not Planned",
            status: 0,
        }


        onUpdateTasks(obj)
            .then(x => {
                //  onSendMessage(data,`Approved at ${moment().format("DD/M ddd h:mm a")}`)
                data.status = 0;
                data.currentstatus = "Not Planned"

                let _editid = x.data._id;
                // let editData    = datasource[conditions].filter(x => x._id == _editid);
                let newTaskData = datasource
                newTaskData[conditions] = newTaskData[conditions].filter(y => y._id != _editid);

                newTaskData[conditions].push(x.data);
                setDataSource(newTaskData);
                // onRefreshNewDatasource(newTaskData, conditions);    // put this because use effect not reading

                // setStatus(newStatus);       // Filter Status with ds
                // setStatus(status);          // Change back to remaining status
                //   message.success(GetTranslation(userlang, "Update successful"));

                return data;

            })
            .then(data => {
                var msg = `Re-Open at ${moment().format("DD/M ddd h:mm a")}`
                onSendMessage(data, msg)
            });
    }
    const onClear = () => {
        form.resetFields();
        setChatList([]);
        setCollapse([]);
        setChatmsg("");
        setFileList([]);
    }

    const onChatClear = () => {
        setChatmsg("");
        setFileList([]);
        textform.resetFields();
        setBtnDisable(false);
    }

    const onCheckExist = (array, list, conditions) => {
        if (conditions != "") {
            //===== LIST IS { "KEY" : "VALUE" } AND GOT CONDITIONS ====
            if (Object.keys(array).length > 0) {
                array.forEach(x => {
                    let exist = list[conditions].find(y => y._id == x._id);
                    if (exist == undefined || Object.keys(exist).length == 0) {
                        list[conditions].push(x);
                    }
                });
            }

            return list;
        }
        else {
            //===== IF NO ANY CONDITIONS AND LIST IS [] ======
            if (Object.keys(array).length > 0) {
                array.forEach(x => {
                    let exist = list.find(y => y._id == x._id);
                    if (exist == undefined || Object.keys(exist).length == 0) {
                        list.push(x);
                    }
                });
            }

            return list;
        }
    }

    //===== SORT TABLE =======
    const onSort = (table) => {
        table = table.sort(function (a, b) {
            return (a.updatedte > b.updatedte) ? -1 : 1;
        });

        return table;
    }

    //==== BUTTON CLICK =======
    const onClick = (val, data) => {
        let array = [];
        let newStatus;
        switch (val) {
            case "main":
                setConditions("all");
                setlistdata(data);
                //==== GET FILTERED ======
                setTaskLoading(true);
                onGetRelatedTasks({ conditions: val, mainthreadid: data.mainthread })
                    .then(val => {
                        if (Object.keys(val.data).length > 0) {
                            newStatus = val.data[0]["status"];
                            setNewDatasource(val.data);
                            //  setStatus(newStatus)
                            // setFilteredDs(array);
                            //20210803 remove loading button on click main

                        }
                        else {
                            setNewDatasource([]);
                        }
                    })
                setTaskLoading(false);
                break;
            case "sub":
                setConditions("all");
                setlistdata(data);
                setcurrentask("sub")
                setTaskLoading(true)
                if (data.subtaskmsg != undefined) {
                    if (data.subtaskmsg == 1) {
                        onUpdateSubTaskMsg({ taskid: data._id })
                    }
                }

                //=== GET FILTERED ======
                onGetRelatedTasks({ conditions: val, mainthreadid: data._id, userid: userid })
                    .then(val => {
                        if (Object.keys(val.data).length > 0) {
                            // newStatus = val.data[0]["status"];
                            setNewDatasource(val.data);
                            // setStatus(newStatus);
                            //20210803 remove loading button on click sub

                        }
                        else {
                            setNewDatasource([]);
                        }
                    });
                setTaskLoading(false)
                break;
            case "approve":
                setNewStatus(3);
                setChatmsg(`${GetTranslation(userlang, "Approved at")} ${moment().format("DD/M ddd h:mm a")}`)
                // data.status = 3;    //3 is completed
                setModalTitle("Approve Task");
                setCurrentstatus("Complete Task")
                setModalVisible(true);
                setlistdata(data);
                break;
            case "reject":
                setNewStatus(0);
                setChatmsg(`Incomplete at ${moment().format("DD/M ddd h:mm a")}`)
                // data.status = 0;    //0 is progress
                setModalTitle("Incomplete Task");
                setCurrentstatus("Reject Task")
                setModalVisible(true);
                setlistdata(data);
                break;
            case "completed":
                // 20210731 If self assign job complete and no report to no need verify
                //if((data.assignto == userid && data.createdby == userid) && data.reportto == ""){
                if ((data.assignto == userid && data.createdby == userid)) {
                    setNewStatus(3);
                    setCurrentstatus("Complete Task")
                }
                else {
                    setNewStatus(1);
                    setCurrentstatus("Submited Task")
                }

                // data.status = 1;
                setModalTitle("Complete Task");

                // setChatmsg(`${GetTranslation(userlang, "Completed at")} ${moment().format("DD/M ddd h:mm a")}`)
                setChatmsg(`${GetTranslation(userlang, "Completed at")} ${moment().format("DD/M ddd h:mm a")}`)
                setModalVisible(true);
                setlistdata(data);
                break;
            case "cancel":
                setNewStatus(9);
                setChatmsg(`${GetTranslation(userlang, "Cancelled at")} ${moment().format("DD/M ddd h:mm a")}`)
                // data.status = 9;    //9 is cancel
                setModalTitle("Cancel Task");
                setCurrentstatus("Cancel Task")
                setModalVisible(true);
                setlistdata(data);

                break;
            case "assign":
                if (data.tagdate != '' && data.tagname != '') {
                    //console.log("include checking  >>> ",data.taskname.includes(':'))

                    if (data.taskname.includes(':')) {
                        var splitvar = data.taskname.split(":")[0]

                        data.taskname = splitvar
                    }

                }
                //  setdayjsdate(dayjs(data.deadline))

                if (data.deadline) {
                    var monthdateFormat = "YYYY/MM/DD HH:mm"

                    setdayjsdate(dayjs(moment.unix(data.deadline).format(monthdateFormat), monthdateFormat))

                }

                console.log("Assign Data >>>", data)
                setTaskData(data);
                setCollapse(["1"]);
                setIsEdit(1)
                break;

            case "startnow":
                setNewStatus(0)
                setChatmsg(`Started at ${moment().format("DD/M ddd h:mm a")}`)
                setCurrentstatus("In Progress")
                setModalVisible(true);
                setlistdata(data);
                break;
            case "extend":

                setNewStatus(0);

                setCurrentstatus("Request Extend")

                setModalVisible(true);
                setlistdata(data);
                break

            case "onhold":
                // 20210731 If self request onhold , no report to no need verify

                setNewStatus(2); //status 2 is ON HOLD
                setChatmsg(`${GetTranslation(userlang, 'On Hold at')} ${moment().format("DD/M ddd h:mm a")}`)
                setCurrentstatus("On Hold")


                setModalVisible(true);
                setlistdata(data);
                break
            case "activate":
                setNewStatus(0)
                setChatmsg(`${GetTranslation(userlang, "Activate at")} ${moment().format("DD/M ddd h:mm a")}`)
                setCurrentstatus("Not Planned")
                setModalVisible(true);
                setlistdata(data);
                break
        }
    }



    const onTaskChange = (taskid) => {
        //===== GET CHAT =======
        console.log("taskid >>>", taskid)

        //setDisplayLimit(1)
        //setDisplayLimitChecklist(5)
        setnewchecklisttitle("")
        var panelHeaderId = `${taskid}`;

        if (displaymode == "self") {
            if (taskid != undefined) {
                var temptaskid11 = taskid

                if (displaymode === "self" && ['S', 'E'].includes(taskid.charAt(0))) {

                    setTemptaskid(taskid)
                    setCollapse(temptaskid11)

                    taskid = taskid.slice(1); // This removes the first character if it's 'S' or 'E'

                    panelHeaderId = temptaskid11
                }
                else {
                    setCollapse(temptaskid)
                    panelHeaderId = temptaskid
                }



            }
            else {
                setCollapse(taskid)
            }


        }
        else {
            setCollapse(taskid);

        }

        // // Use a timeout to allow the panel to finish expanding
        // setTimeout(() => {
        //     const panelElement = document.getElementById(panelHeaderId);
        //     if (panelElement) {
        //         panelElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        //     }
        // }, 300); // Adjust timeout as necessary


        // Clear existing interval whenever the task changes or the same task is reselected.
        clearInterval(intervalIdRef.current);

        clearReply()
        clearEdit()
        let previouschatdata = []


        let tempdatasource = newdatasource.filter(x => x._id === taskid)[0];
        let temppermission = 'public';
        let tempuserid = FULLuserLists.find(x => x._id === userid)?.userid || "Unknown user"
        if (tempdatasource !== undefined) {
            if (tempdatasource.createdby !== userid && tempdatasource.assignto !== userid) {
                if (tempdatasource.taguser !== undefined && tempdatasource.taguser.length > 0) {
                    tempdatasource.taguser.forEach(tagUser => {
                        if (tagUser.userid === userid) {
                            temppermission = tagUser.permission;
                        }
                    });
                }
            }
        }

        console.log("temppermission >>>", temppermission);
        //console.log("Updated tempdatasource >>>", tempdatasource);

        setSnackvisible(false)
        console.log("open chat", taskid)
        var originalcbunread = 0
        var originalatunread = 0
        if (taskid != undefined) {
            setFileList([]);
            setdayjsdate()
            setdayjsstartdate()

            let data = newdatasource.filter(x => x._id == taskid)[0];

            if (displaymode == "self") {
                data = selfrawdatasource.filter(x => x._id == taskid)[0]
            }
            //console.log("data >>>",data)

            setCurrentData(data)


            // if(data.mainthread != "")
            // {
            //     if(data.status != 3 && data.status != 9)
            //     {
            //         checkmainthread(data.mainthread).then((val) =>  {

            //             if(data.status != val)
            //             {

            //                     if(val == 3)
            //                     {

            //                         onUpdateStatus(data,3,"Complete Task",'sub')
            //                     }
            //                     else if(val ==9)
            //                     {

            //                         onUpdateStatus(data,9,"Cancel Task",'sub')
            //                     }


            //             }
            //            })
            //     }


            // }

            // if (data.currentstatus == "Request Extend") {
            //     setextenddiable(true)
            // }
            // else {
            //     setextenddiable(false)
            // }




            //==== IF CONDITIONS IS NOT EMPTY =====
            if (conditions != "") {
                //====== CHECK IF ATUNREAD IS 1 AND ASSIGN TO IS YOU =====
                if (data.atunread == 1 && data.assignto == userid && data.createdby != userid) {
                    return Promise.all([onUpdateUnreadTasks({ taskid: taskid, atunread: 0, cbunread: data.cbunread, tasktype: "taskchange" }), onGetChat({ taskid: taskid, permission: temppermission, userid: tempuserid, userobjid: userid })])
                        .then(([val, valb]) => {
                            //REFRESH
                            let newds = newdatasource;
                            let newindex = newdatasource.findIndex(x => x._id == taskid);

                            if (newds[newindex].atunread != undefined) {
                                newds[newindex].atunread = 0;
                                newds[newindex].countunread = 0;

                                if (displaymode == "self") {
                                    let newds2 = selfrawdatasource;
                                    let newindex2 = selfrawdatasource.findIndex(x => x._id == taskid);


                                    if (newds2[newindex2].atunread != undefined) {
                                        newds2[newindex2].atunread = 0;
                                        newds2[newindex2].countunread = 0;
                                    }


                                }


                            }
                            setNewDatasource(newds);
                            // onRefreshNewDatasource(newds, conditions);
                            setChatData(valb.data);
                            setInitLoading(false);
                            onGetChatData(valb.data, false);
                            return val;
                        })
                }
                //===== CHECK IF CBUNREAD IS 1 AND CREADTED BY IS YOU =======
                else if (data.cbunread == 1 && data.createdby == userid && data.assignto != userid) {
                    //20210715 Update CBunread = 0
                    return Promise.all([onUpdateUnreadTasks({ taskid: taskid, atunread: data.atunread, cbunread: 0, tasktype: "taskchange" }), onGetChat({ taskid: taskid, permission: temppermission, userid: tempuserid, userobjid: userid })])
                        .then(([val, valb]) => {
                            //REFRESH
                            let newds = newdatasource;
                            let newindex = newdatasource.findIndex(x => x._id == taskid);

                            if (newds[newindex].cbunread != undefined) {
                                newds[newindex].cbunread = 0;
                                newds[newindex].countunread = 0;

                                if (displaymode == "self") {
                                    let newds2 = selfrawdatasource;
                                    let newindex2 = selfrawdatasource.findIndex(x => x._id == taskid);


                                    if (newds2[newindex2].cbunread != undefined) {
                                        newds2[newindex2].cbunread = 0;
                                        newds2[newindex2].countunread = 0;
                                    }


                                }

                            }
                            setNewDatasource(newds);

                            //  onRefreshNewDatasource(newds, conditions);
                            setChatData(valb.data);
                            setInitLoading(false);
                            onGetChatData(valb.data, false);
                            return val;
                        });
                }
                else if (data.createdby == userid && data.assignto == userid && (data.atunread == 1 || data.cbunread == 1)) {
                    return Promise.all([onUpdateUnreadTasks({ taskid: taskid, atunread: 0, cbunread: 0, tasktype: "taskchange" }), onGetChat({ taskid: taskid, permission: temppermission, userid: tempuserid, userobjid: userid })])
                        .then(([val, valb]) => {
                            //REFRESH
                            let newds = newdatasource;
                            let newindex = newdatasource.findIndex(x => x._id == taskid);

                            if (newds[newindex].cbunread != undefined) {
                                newds[newindex].cbunread = 0;
                                newds[newindex].countunread = 0;
                            }
                            if (newds[newindex].atunread != undefined) {
                                newds[newindex].atunread = 0;
                                newds[newindex].countunread = 0;
                            }

                            if (data.deadline != "") {
                                if (displaymode == "self") {
                                    let newds2 = selfrawdatasource;
                                    let newindex2 = selfrawdatasource.findIndex(x => x._id == taskid);


                                    if (newds2[newindex2].cbunread != undefined) {
                                        newds2[newindex2].cbunread = 0;
                                    }
                                    if (newds2[newindex2].atunread != undefined) {
                                        newds2[newindex2].atunread = 0;
                                    }

                                }


                            }
                            setNewDatasource(newds);

                            //  onRefreshNewDatasource(newds, conditions);
                            setChatData(valb.data);
                            setInitLoading(false);
                            onGetChatData(valb.data, false);
                            return val;
                        });
                }
                else if (data.taguser != undefined) {
                    var taguserresult = data.taguser.filter(x => x.userid == userid)[0];

                    if (taguserresult != undefined && taguserresult != null) {

                        if (taguserresult.unread == 1) {
                            return Promise.all([onUpdateUnreadTasks({ taskid: taskid, tasktype: "tagread", userid: userid }), onGetChat({ taskid: taskid, permission: temppermission, userid: tempuserid, userobjid: userid })])
                                .then(([val, valb]) => {
                                    let newds = newdatasource;

                                    if (taguserresult != undefined && taguserresult != null) {
                                        let newindex = newdatasource.findIndex(x => x._id == taskid);
                                        let tagindex = newdatasource[newindex].taguser.findIndex(x => x.userid == userid);
                                        if (newds[newindex].taguser != undefined) {
                                            newds[newindex].taguser[tagindex].unread = 0;
                                            newds[newindex].taguser[tagindex].countunread = 0;

                                        }

                                        if (displaymode == "self") {
                                            let newds2 = selfrawdatasource

                                            let newindex2 = selfrawdatasource.findIndex(x => x._id == taskid);
                                            let tagindex2 = selfrawdatasource[newindex2].taguser.findIndex(x => x.userid == userid);
                                            if (newds2[newindex2].taguser != undefined) {
                                                newds2[newindex2].taguser[tagindex2].unread = 0;
                                                newds2[newindex2].taguser[tagindex2].countunread = 0;

                                            }

                                        }

                                    }
                                    setNewDatasource(newds);

                                    //  onRefreshNewDatasource(newds, conditions);
                                    setChatData(valb.data);
                                    setInitLoading(false);
                                    onGetChatData(valb.data, false);
                                });
                        }
                    }


                }
            }

            //console.log("test2",chatdata)

            //===== IF BOTH CONDITIONS IS NOT HIT ======
            //====== GET CHAT =====
            // return onGetChat({ taskid: taskid })
            //     .then(val => {

            //         setChatData(val.data);
            //         setInitLoading(false);
            //         onGetChatData(val.data, false);


            //         return;
            //     })
            //     .catch(err => {
            //         return err;
            //     });



            // Define a function to fetch chat data and reset countdown
            const fetchChatData = () => {

                onGetChat({ taskid: taskid, permission: temppermission, userid: tempuserid, userobjid: userid })
                    .then(val => {
                        setChatData(val.data);

                        previouschatdata = val.data
                        setInitLoading(false);
                        onGetChatData(val.data, false);

                    })
                    .catch(err => {
                        console.error('Error fetching chat data:', err);
                    });
            };


            // Execute fetch immediately for the task change.
            fetchChatData();


            // Define a function to fetch chat data and reset countdown
            const fetchChatDataLIVE = () => {

                console.log('Fetching chat data for task:', taskid);

                onGetChat({ taskid: taskid, permission: temppermission, userid: tempuserid, userobjid: userid })
                    .then(val => {
                        console.log("previouschatdata >>>", previouschatdata.length)
                        console.log("latestdata >>>", val.data.length)
                       
                        setInitLoading(false);
                     
                        // console.log("chatlist >>>",chatlist)
                        // console.log("chatdata >>>",chatdata)

                        if (previouschatdata.length < val.data.length) {
                            const updatedChatList = val.data.map(item => {
                                // Check if the item exists in previouschatdata by comparing a unique identifier
                                const existsInPrevious = previouschatdata.some(prevItem => prevItem._id === item._id);

                                // Add 'newmessage' property based on existence in previous data
                                return {
                                    ...item,
                                    newmessage: !existsInPrevious,
                                };
                            });

                            //onGetChatData(updatedChatList, 'live');
                            // setChatList(updatedChatList);
                           
                            previouschatdata = updatedChatList
                            setChatData(updatedChatList);
                        }
                    })
                    .catch(err => {
                        console.error('Error fetching chat data:', err);
                    });
            };

            // // Setup an interval to repeatedly fetch chat data every 5 seconds.
            intervalIdRef.current = setInterval(fetchChatDataLIVE, 5000);

            setSnackvisible(true)
            // Debug: Log to verify the interval reset behavior.
            console.log(`Interval set for task ${taskid}`);

            // // Setup an interval to repeatedly fetch chat data every 10 seconds.
            // intervalIdRef.current = setInterval(fetchChatDataLIVE, 10000);

            // setSnackvisible(true)
            // // Debug: Log to verify the interval reset behavior.
            // console.log(`Interval set for task ${taskid}`);
        }
        else {
            onClear();

        }


    }

    async function checkmainthread(param) {
        var result = await onGetTaskByID({ taskid: param })
        return result.data.status
    }

    const onCollapse = (val) => {
        //==== IF THE VAL INSIDE ARRAY MORE THAN 1 ====
        if (val.length > 1) {
            val.splice(0, 1);
        }


        setCollapse(val);
        setTaskData("");
        setIsEdit(0);
        setFileList([]);
        form.resetFields()
    }

    async function fetchBlobFromURL(audioURL) {
        const response = await fetch(audioURL);
        const blob = await response.blob();
        return blob;
    }

    function createFileFromBlob(blob, filename, mimeType) {
        const file = new File([blob], filename, { type: mimeType, lastModified: new Date().getTime() });
        return file;
    }


    const onSendMessage = async (data, tempmsg, manualmsg) => {

        setBtnDisable(true);
        //====== CHECK HAS FILE =======
        let taskid = data._id;
        let from = userid;
        let to = data.assignto != userid ? data.assignto : data.createdby;
        let maintaskid = data.mainthread
        let refrom, remessage, refilepath, reid, chatid
        let msgtype = 'system';


        if (replyTo != null) {
            reid = replyTo._id
            refrom = replyTo.from;
            remessage = replyTo.message;
            refilepath = replyTo.filepath;
        }
        if (editBy != null) {
            chatid = editBy._id
        }

        let taskdata = {
            taskid: "",
            from: "",
            to: "",
            message: "",
            mainthread: '',
            status: 1,
            reid: "",
            refrom: "",
            remessage: "",
            refilepath: "",
            chatid: chatid,
            msgtype: ""
        }
        if (manualmsg) {
            if (manualmsg != "") {

                msgtype = 'manual'
                if (data.status != 0) {

                    onUpdateActiveStatus(data)

                }
            }
        }
        if (tempmsg) {
            if (tempmsg != "") {
                taskdata = {
                    taskid: taskid,
                    from: from,
                    to: to,
                    message: tempmsg,
                    mainthread: maintaskid,
                    reid: reid,
                    refrom: refrom,
                    remessage: remessage,
                    refilepath: refilepath,
                    chatid: chatid,
                    msgtype: msgtype
                }
            }
        }
        else {
            taskdata = {
                taskid: taskid,
                from: from,
                to: to,
                message: chatmsg,
                mainthread: maintaskid,
                reid: reid,
                refrom: refrom,
                remessage: remessage,
                refilepath: refilepath,
                chatid: chatid,
                msgtype: msgtype
            }
        }

        let currenttagusetlist = []

        if (data.taguser != undefined) {
            currenttagusetlist = data.taguser
        }
        let temptaguserlist = taguserlist
        let updtaguser = []

        // if (temptaguserlist != undefined) {
        //     if (temptaguserlist.length > 0) {
        //         temptaguserlist.forEach(function (items) {

        //             let tempuserid = FULLuserLists.filter(col => col.userid == items)[0]._id

        //             updtaguser.push({ "userid": tempuserid, "unread": 1, "countunread": 0 })

        //         })
        //         currenttagusetlist.forEach(function (items) {
        //             if (currenttagusetlist != undefined && currenttagusetlist != null) {
        //                 updtaguser.push({ "userid": items.userid, "unread": items.unread, "countunread": items.countunread })
        //             }

        //         })


        //         var GLeaguehelper1 = {};
        //         var resulttaguser = updtaguser.reduce(function (r, o) {
        //             var key = o.userid;

        //             if (!GLeaguehelper1[key]) {
        //                 GLeaguehelper1[key] = Object.assign({}, o); // create a copy of o
        //                 r.push(GLeaguehelper1[key]);
        //             } else {
        //                 GLeaguehelper1[key].countunread += o.countunread;
        //                 GLeaguehelper1[key].unread = 1;
        //             }
        //             return r;
        //         }, []);

        //         if (data != undefined) {
        //             resulttaguser = resulttaguser.filter(col => col.userid != data.createdby)
        //             resulttaguser = resulttaguser.filter(col => col.userid != data.assignto)
        //         }
        //         else {
        //             resulttaguser = updtaguser
        //         }

        //         let taguserdataobj = {
        //             taskid: taskid,
        //             taguser: resulttaguser
        //         }

        //         let newds1 = newdatasource;
        //         let newindex1 = newdatasource.findIndex(x => x._id == taskid);
        //         newds1[newindex1].taguser = resulttaguser

        //         onUpdateTasks(taguserdataobj)
        //     }
        // }

        settaguserlist("")

        console.log("chat data filelist >>>>", filelist)
        console.log("chat data >>>>", taskdata)

        if (taskdata.message != "" && filelist.length == 0) {

            if (editBy != null) {
                onUpdateChat(taskdata)
                    .then(val => {
                        // console.log("taskdata >>>",taskdata)
                        // console.log("message update !!!")
                        onTaskChange(taskid);
                        onChatClear();
                        setBtnDisable(false);
                        message.success("Message Edited !!!")

                    })
                    .catch(err => {
                        message.error("Failed to update chat message ");
                        setBtnDisable(false);
                    });
            }
            else {
                //==== IF GOT CHAT AND WITHOUT FILE ======
                onCreateChat(taskdata)
                    .then(val => {
                        //===== UPDATE TASKS =========
                        //====== 20210802 ASSIGN TO IS YOU FOR CHATTING ======
                        if (data.assignto == userid) {
                            //update cbunread
                            onUpdateUnreadTasks({
                                taskid: taskid,
                                cbunread: 1,
                                to: to,
                                from: from,
                                tasktype: "sendmessage",
                                mainthread: maintaskid
                            })
                                .then(val => {
                                    onTaskChange(taskid);
                                    //REFRESH
                                    let newds = datasource;
                                    let newcond = conditions != "" ? conditions : "all";
                                    let newindex = datasource[newcond].findIndex(x => x._id == taskid);
                                    // newds[newcond][newindex].cbunread    = 1;

                                    let newds1 = newdatasource;
                                    let newindex1 = newdatasource.findIndex(x => x._id == taskid);
                                    newds1[newindex1].lastmsgtime = moment().unix();
                                    if (data.createdby != userid) {
                                        if (newds1[newindex1].cbunread != undefined) {
                                            newds1[newindex1].cbunread = 1;
                                        }
                                    }

                                    if (data.deadline != "") {
                                        if (displaymode == "self") {
                                            let newds2 = selfrawdatasource;
                                            let newindex2 = selfrawdatasource.findIndex(x => x._id == taskid);
                                            newds2[newindex2].lastmsgtime = moment().unix();
                                            if (data.createdby != userid) {
                                                if (newds2[newindex2].cbunread != undefined) {
                                                    newds2[newindex2].cbunread = 1;

                                                    setSelfrawdatasource(newds2)
                                                }
                                            }
                                        }


                                    }

                                    setNewDatasource(newds1);
                                    setDataSource(newds);
                                    onChatClear();
                                    setBtnDisable(false);
                                })
                        }
                        //====== 20210802 CREATED BY IS YOU FOR CHATTING ======
                        else if (data.createdby == userid) {
                            // Update atunread
                            onUpdateUnreadTasks({
                                taskid: taskid,
                                atunread: 1,
                                to: to,
                                from: from,
                                tasktype: "sendmessage",
                                mainthread: maintaskid
                            })
                                .then(val => {
                                    onTaskChange(taskid);
                                    //REFRESH
                                    let newds = datasource;
                                    let newcond = conditions != "" ? conditions : "all";
                                    let newindex = datasource[newcond].findIndex(x => x._id == taskid);
                                    // newds[newcond][newindex].atunread    = 1;

                                    let newds1 = newdatasource;
                                    let newindex1 = newdatasource.findIndex(x => x._id == taskid);

                                    newds1[newindex1].lastmsgtime = moment().unix();
                                    if (data.assignto != userid) {

                                        if (newds1[newindex1].atunread != undefined) {
                                            newds1[newindex1].atunread = 1;

                                        }

                                    }

                                    if (data.deadline != "") {
                                        if (displaymode == "self") {
                                            let newds2 = selfrawdatasource;
                                            let newindex2 = selfrawdatasource.findIndex(x => x._id == taskid);
                                            newds2[newindex2].lastmsgtime = moment().unix();
                                            if (data.assignto != userid) {
                                                if (newds2[newindex2].atunread != undefined) {
                                                    newds2[newindex2].atunread = 1;

                                                    setSelfrawdatasource(newds2)
                                                }
                                            }
                                        }


                                    }
                                    setNewDatasource(newds1);
                                    setDataSource(newds);
                                    onChatClear();
                                    setBtnDisable(false);
                                })
                        }
                        //====== 20210802 REPORT TO IS YOU FOR CHATTING ======
                        // else if(data.reportto == userid){
                        //     onUpdateUnreadTasks({taskid : taskid, atunread: 1, cbunread : 1, to : to,from : from, 
                        //         tasktype    :   "sendmessage"})
                        //     .then(val => {
                        //         onTaskChange(taskid);
                        //         //REFRESH
                        //         let newds                               = datasource;
                        //         let newcond                             = conditions != "" ? conditions : "subordinary";   
                        //         let newindex                            = datasource[newcond].findIndex(x => x._id == taskid);
                        //         newds[newcond][newindex].atunread    = 1;
                        //         newds[newcond][newindex].cbunread    = 1;

                        //         setDataSource(newds);
                        //         onChatClear();
                        //     })
                        // }
                        else if (data.taguser != undefined) {
                            var taguserresult = data.taguser.filter(x => x.userid == userid)[0];

                            if (taguserresult != undefined && taguserresult != null) {
                                // Update atunread
                                onUpdateUnreadTasks({
                                    taskid: taskid,
                                    atunread: 1,
                                    cbunread: 1,
                                    to: to,
                                    from: from,
                                    tasktype: "sendmessage",
                                    mainthread: maintaskid
                                })
                                    .then(val => {
                                        onTaskChange(taskid);
                                        //REFRESH
                                        let newds = datasource;
                                        let newcond = conditions != "" ? conditions : "all";
                                        let newindex = datasource[newcond].findIndex(x => x._id == taskid);
                                        //  newds[newcond][newindex].atunread    = 1;
                                        //  newds[newcond][newindex].cbunread    = 1;

                                        let newds1 = newdatasource;
                                        let newindex1 = newdatasource.findIndex(x => x._id == taskid);

                                        newds1[newindex1].lastmsgtime = moment().unix();
                                        if (newds1[newindex1].atunread != undefined) {
                                            newds1[newindex1].atunread = 1;

                                        }
                                        if (newds1[newindex1].cbunread != undefined) {
                                            newds1[newindex1].cbunread = 1;

                                        }


                                        if (data.deadline != "") {
                                            if (displaymode == "self") {
                                                let newds2 = selfrawdatasource;
                                                let newindex2 = selfrawdatasource.findIndex(x => x._id == taskid);
                                                newds2[newindex2].lastmsgtime = moment().unix();

                                                if (newds2[newindex2].atunread != undefined) {
                                                    newds2[newindex2].atunread = 1;


                                                }

                                                if (newds2[newindex2].cbunread != undefined) {
                                                    newds2[newindex2].cbunread = 1;


                                                }

                                                setSelfrawdatasource(newds2)

                                            }


                                        }

                                        setNewDatasource(newds1);
                                        setDataSource(newds);
                                        onChatClear();
                                        setBtnDisable(false);
                                    })
                            }


                        }


                        if (isEdit == 2) {
                            onReload()
                        }
                        else {
                            setnewindex(1);
                        }

                    })
                    .catch(err => {
                        message.error("Message Error");
                        setBtnDisable(false);
                    });;
            }


        }
        else if (audioURL != "" || audioURL) {
            // Fetch the blob from the blob URL
            const audioBlob = await fetchBlobFromURL(audioURL);
            const mimeType = audioBlob.type; // Assuming the type is set correctly in the blob metadata
            const fileExtension = mimeType.split('/')[1]; // Extracts 'webm' or 'mp3'

            // Generate a filename based on taskid, from, and current timestamp
            const timestamp = new Date().toISOString().replace(/[-:.]/g, ''); // Create a safe timestamp string
            const filename = `recording_${taskid}_${from}_${timestamp}.${fileExtension}`;

            // Create a file from the blob with the generated name
            const audioFile = createFileFromBlob(audioBlob, filename, mimeType);

            console.log("audioFile >>>", audioFile)
            onCreateAudio(audioFile)
                .then(val => {
                    taskdata.message = val.data[0].filepath
                    taskdata.msgtype = "audio"
                    deleteRecording()
                    //==== VALIDATION =======
                    onCreateChat(taskdata)
                        .then(val => {
                            //===== UPDATE TASKS =========
                            //====== 20210802 ASSIGN TO IS YOU FOR CHATTING ======
                            if (data.assignto == userid) {
                                //update cbunread
                                onUpdateUnreadTasks({
                                    taskid: taskid,
                                    cbunread: 1,
                                    to: to,
                                    from: from,
                                    tasktype: "sendmessage",
                                    mainthread: maintaskid
                                })
                                    .then(val => {
                                        onTaskChange(taskid);

                                        //REFRESH
                                        let newds = datasource;
                                        let newindex = datasource["all"].findIndex(x => x._id == taskid);
                                        newds["all"][newindex].cbunread = 1;


                                        let newds1 = newdatasource;
                                        let newindex1 = newdatasource.findIndex(x => x._id == taskid);
                                        newds1[newindex1].lastmsgtime = moment().unix();
                                        if (data.createdby != userid) {
                                            if (newds1[newindex1].cbunread != undefined) {
                                                newds1[newindex1].cbunread = 1;

                                            }
                                        }

                                        setNewDatasource(newds1);
                                        setDataSource(newds);
                                        onChatClear();
                                        setBtnDisable(false);
                                    })
                            }
                            else if (data.createdby == userid) {
                                // Update atunread
                                onUpdateUnreadTasks({
                                    taskid: taskid,
                                    atunread: 1,
                                    to: to,
                                    from: from,
                                    tasktype: "sendmessage",
                                    mainthread: maintaskid
                                })
                                    .then(val => {
                                        onTaskChange(taskid);
                                        //REFRESH
                                        let newds = datasource;
                                        let newindex = datasource["all"].findIndex(x => x._id == taskid);


                                        if (data.assignto != userid) {

                                            if (newds["all"][newindex].atunread != undefined) {
                                                newds["all"][newindex].atunread = 1;

                                            }

                                        }
                                        let newds1 = newdatasource;
                                        let newindex1 = newdatasource.findIndex(x => x._id == taskid);

                                        newds1[newindex1].lastmsgtime = moment().unix();
                                        if (data.assignto != userid) {

                                            if (newds1[newindex1].atunread != undefined) {
                                                newds1[newindex1].atunread = 1;

                                            }

                                        }
                                        setNewDatasource(newds1);
                                        setDataSource(newds);
                                        onChatClear();
                                        setBtnDisable(false);
                                    })
                            }
                            else if (data.taguser != undefined) {
                                var taguserresult = data.taguser.filter(x => x.userid == userid)[0];

                                if (taguserresult != undefined && taguserresult != null) {
                                    // Update atunread
                                    onUpdateUnreadTasks({
                                        taskid: taskid,
                                        atunread: 1,
                                        cbunread: 1,
                                        to: to,
                                        from: from,
                                        tasktype: "sendmessage",
                                        mainthread: maintaskid
                                    })
                                        .then(val => {
                                            onTaskChange(taskid);
                                            //REFRESH
                                            let newds = datasource;
                                            let newcond = conditions != "" ? conditions : "all";
                                            let newindex = datasource[newcond].findIndex(x => x._id == taskid);
                                            //  newds[newcond][newindex].atunread    = 1;
                                            //  newds[newcond][newindex].cbunread    = 1;

                                            let newds1 = newdatasource;
                                            let newindex1 = newdatasource.findIndex(x => x._id == taskid);

                                            newds1[newindex1].lastmsgtime = moment().unix();
                                            if (newds1[newindex1].atunread != undefined) {
                                                newds1[newindex1].atunread = 1;

                                            }
                                            if (newds1[newindex1].cbunread != undefined) {
                                                newds1[newindex1].cbunread = 1;

                                            }


                                            setNewDatasource(newds1);
                                            setDataSource(newds);
                                            onChatClear();
                                            setBtnDisable(false);
                                        })
                                }


                            }
                        })
                        .catch(err => {
                            message.error("Message Error");
                            setBtnDisable(false);
                        });

                }).catch(err => {
                    message.error("Failed to send audio");
                    setBtnDisable(false);
                });
        }
        else {
            //===== IF GOT FILE ======
            if (filelist.length > 0) {

                if (editBy != null) {
                    onCreateAttachment(filelist)
                        .then(response => {
                            let path = response.data;
                            taskdata.filepath = path.map(x => x.filepath).toString();

                            onUpdateChat(taskdata)
                                .then(val => {
                                    // console.log("taskdata >>>",taskdata)
                                    // console.log("message update !!!")
                                    onTaskChange(taskid);
                                    onChatClear();
                                    setBtnDisable(false);
                                    message.success("Message Edited !!!")
                                })


                        })
                        .catch(err => {
                            message.error("Failed to upload attachments");
                            setBtnDisable(false);
                        });
                }
                else {
                    onCreateAttachment(filelist)
                        .then(response => {
                            let path = response.data;
                            taskdata.filepath = path.map(x => x.filepath).toString();

                            //==== VALIDATION =======
                            onCreateChat(taskdata)
                                .then(val => {
                                    //===== UPDATE TASKS =========
                                    //====== 20210802 ASSIGN TO IS YOU FOR CHATTING ======
                                    if (data.assignto == userid) {
                                        //update cbunread
                                        onUpdateUnreadTasks({
                                            taskid: taskid,
                                            cbunread: 1,
                                            to: to,
                                            from: from,
                                            tasktype: "sendmessage",
                                            mainthread: maintaskid
                                        })
                                            .then(val => {
                                                onTaskChange(taskid);

                                                //REFRESH
                                                let newds = datasource;
                                                let newindex = datasource["all"].findIndex(x => x._id == taskid);
                                                newds["all"][newindex].cbunread = 1;


                                                let newds1 = newdatasource;
                                                let newindex1 = newdatasource.findIndex(x => x._id == taskid);
                                                newds1[newindex1].lastmsgtime = moment().unix();
                                                if (data.createdby != userid) {
                                                    if (newds1[newindex1].cbunread != undefined) {
                                                        newds1[newindex1].cbunread = 1;

                                                    }
                                                }

                                                setNewDatasource(newds1);
                                                setDataSource(newds);
                                                onChatClear();
                                                setBtnDisable(false);
                                            })
                                    }
                                    else if (data.createdby == userid) {
                                        // Update atunread
                                        onUpdateUnreadTasks({
                                            taskid: taskid,
                                            atunread: 1,
                                            to: to,
                                            from: from,
                                            tasktype: "sendmessage",
                                            mainthread: maintaskid
                                        })
                                            .then(val => {
                                                onTaskChange(taskid);
                                                //REFRESH
                                                let newds = datasource;
                                                let newindex = datasource["all"].findIndex(x => x._id == taskid);


                                                if (data.assignto != userid) {

                                                    if (newds["all"][newindex].atunread != undefined) {
                                                        newds["all"][newindex].atunread = 1;

                                                    }

                                                }
                                                let newds1 = newdatasource;
                                                let newindex1 = newdatasource.findIndex(x => x._id == taskid);

                                                newds1[newindex1].lastmsgtime = moment().unix();
                                                if (data.assignto != userid) {

                                                    if (newds1[newindex1].atunread != undefined) {
                                                        newds1[newindex1].atunread = 1;

                                                    }

                                                }
                                                setNewDatasource(newds1);
                                                setDataSource(newds);
                                                onChatClear();
                                                setBtnDisable(false);
                                            })
                                    }
                                    else if (data.taguser != undefined) {
                                        var taguserresult = data.taguser.filter(x => x.userid == userid)[0];

                                        if (taguserresult != undefined && taguserresult != null) {
                                            // Update atunread
                                            onUpdateUnreadTasks({
                                                taskid: taskid,
                                                atunread: 1,
                                                cbunread: 1,
                                                to: to,
                                                from: from,
                                                tasktype: "sendmessage",
                                                mainthread: maintaskid
                                            })
                                                .then(val => {
                                                    onTaskChange(taskid);
                                                    //REFRESH
                                                    let newds = datasource;
                                                    let newcond = conditions != "" ? conditions : "all";
                                                    let newindex = datasource[newcond].findIndex(x => x._id == taskid);
                                                    //  newds[newcond][newindex].atunread    = 1;
                                                    //  newds[newcond][newindex].cbunread    = 1;

                                                    let newds1 = newdatasource;
                                                    let newindex1 = newdatasource.findIndex(x => x._id == taskid);

                                                    newds1[newindex1].lastmsgtime = moment().unix();
                                                    if (newds1[newindex1].atunread != undefined) {
                                                        newds1[newindex1].atunread = 1;

                                                    }
                                                    if (newds1[newindex1].cbunread != undefined) {
                                                        newds1[newindex1].cbunread = 1;

                                                    }


                                                    setNewDatasource(newds1);
                                                    setDataSource(newds);
                                                    onChatClear();
                                                    setBtnDisable(false);
                                                })
                                        }


                                    }
                                })
                                .catch(err => {
                                    message.error("Message Error");
                                    setBtnDisable(false);
                                });




                        })
                        .catch(err => {
                            message.error("Failed to upload attachments");
                            setBtnDisable(false);
                        });
                }

            }
        }

        //setBtnDisable(false)
    }

    const onSearch = (key, value) => {
        switch (key) {
            case "condition":
                break;
            case "status":
                if (value.includes("progress")) {
                    setStatus(0);
                }
                else if (value.includes("cancelled")) {
                    setStatus(9)
                }
                else if (value.includes("wait")) {
                    setStatus(1);
                }
                else if (value.includes("unverified")) {
                    setStatus(1.1);
                }
                else if (value.includes("complete")) {
                    setStatus(3);
                }
                break;
        }
    }

    const onTaskSearch = (value) => {
        setTaskName(value);
        console.log("value >>>", value)
        if (value == undefined || value == "") {
            //===== WITHOUT TASK NAME =====
            // setConddisable(false);
            // setStatdisable(false);
            setConditions("all");
            setStatus(0);
        }
        else {
            //===== GOT TASK NAME =====
            // setConddisable(true);
            // setStatdisable(true);
            onTaskNameDatasource({
                conditions: "all",
                taskname: value,
                isSearch: 1,
                searchUser: searchUser,
                index: 1
            })

        }
    }

    //====== ON USER SEARCH ======
    const onSearchUser = (user) => {
        let assignto = userLists.find(x => x.userid == user)?._id
        setSearchUser(assignto);

        if (taskName != "") {
            onTaskNameDatasource({
                conditions: "all",
                taskname: taskName,
                searchUser: assignto,
                isSearch: 1,
                index: 1
            })
        }
        else {
            //==== WITHOUT TASK NAME ======
            var val = {
                conditions: conditions,
                taskname: taskName,
                searchUser: assignto,
                isSearch: 1,
                index: 1
            }
            onRefresh(val);
        }
    }

    //===== DEAD LINE =======    
    const onDeadlineChange = (val, result) => {
        if (val != null) {

            setdayjsdate(val)

            // var monthdateFormat = "YYYY/MM/DD HH:mm"
            var tempval = moment(val.$d)
            // setdayjsdate(dayjs(moment.unix(result.deadline).format(monthdateFormat),monthdateFormat))

            //  val                     = val.set({"seconds": 59});
            let rechangeDateline = result.deadline || "";   // This must have value unless ""
            // 20210723 : Set chat message from user
            let msg = `${GetTranslation(userlang, "User updated the deadline")} ${GetTranslation(userlang, "from")} 
            ${result.deadline == "" ? GetTranslation(userlang, "no deadline") :
                    moment.unix(result.deadline).format("DD/M ddd h:mm a") ?? ""} 
            ${GetTranslation(userlang, "to")} 
            ${moment.unix(tempval.unix()).format("DD/M ddd h:mm a")}`;
            if (rechangeDateline != "") {
                msg = `${GetTranslation(userlang, "Dead line changed")} 
                ${GetTranslation(userlang, "from")} ${result.deadline == "" ? GetTranslation(userlang, "no deadline") : moment.unix(result.deadline).format("DD/M ddd h:mm a") ?? ""} ${GetTranslation(userlang, "to")} ${moment.unix(tempval.unix()).format("DD/M ddd h:mm a")}`;
            }

            //  setdayjsdate("")
            setChatmsg(msg);
            setdeadline(tempval);
            setlistdata(result);
            //  setModalVisible(true);

            var answer = window.confirm(msg)


            if (answer == true) {
                if (val != "") {
                    if (result.assignto == userid) {
                        CreateDeadlineReminder(result._id, result.taskname, moment(tempval).unix(), userid, result.assignto)
                    }
                    else {
                        CreateDeadlineReminder(result._id, result.taskname, moment(tempval).unix(), userid, result.assignto)

                        CreateDeadlineReminder(result._id, result.taskname, moment(tempval).unix(), userid, result.createdby)
                    }

                }



                onUpdate(result, tempval);
                onSendMessage(result, msg)
                //  setModalVisible(false);

            }

            setlistdata("");
            setdeadline("");
            setChatmsg("")
            setNewStatus(-1);
            setCurrentstatus("");
        }
        else {
            setdeadline("");
            setlistdata("");
            setChatmsg("");
        }
    }

    //===== DEAD LINE =======    
    const onStartDateChange = (val, result) => {
        if (val != null) {

            setdayjsstartdate(val)

            // var monthdateFormat = "YYYY/MM/DD HH:mm"
            var tempval = moment(val.$d)
            // setdayjsdate(dayjs(moment.unix(result.deadline).format(monthdateFormat),monthdateFormat))

            //  val                     = val.set({"seconds": 59});
            let rechangeStartdate = result.startdate || "";   // This must have value unless ""
            // 20210723 : Set chat message from user
            let msg = `${GetTranslation(userlang, "User updated the start date")} ${GetTranslation(userlang, "from")} 
            ${result.startdate == "" ? GetTranslation(userlang, "no start date") :
                    moment.unix(result.startdate).format("DD/M ddd h:mm a") ?? ""} 
            ${GetTranslation(userlang, "to")} 
            ${moment.unix(tempval.unix()).format("DD/M ddd h:mm a")}`;
            if (rechangeStartdate != "") {
                msg = `${GetTranslation(userlang, "Start date changed")} 
                ${GetTranslation(userlang, "from")} ${result.startdate == "" ? GetTranslation(userlang, "no start date") : moment.unix(result.startdate).format("DD/M ddd h:mm a") ?? ""} ${GetTranslation(userlang, "to")} ${moment.unix(tempval.unix()).format("DD/M ddd h:mm a")}`;
            }

            //  setdayjsdate("")
            setChatmsg(msg);
            setstartdate(tempval);
            setlistdata(result);
            //  setModalVisible(true);

            var answer = window.confirm(msg)


            if (answer == true) {
                // if (val != "") {
                //     if (result.assignto == userid) {
                //         CreateDeadlineReminder(result._id, result.taskname, moment(tempval).unix(), userid, result.assignto)
                //     }
                //     else {
                //         CreateDeadlineReminder(result._id, result.taskname, moment(tempval).unix(), userid, result.assignto)

                //         CreateDeadlineReminder(result._id, result.taskname, moment(tempval).unix(), userid, result.createdby)
                //     }

                // }



                onUpdate(result, null, null, null, tempval);
                onSendMessage(result, msg)
                //  setModalVisible(false);

            }

            setlistdata("");
            setstartdate("");
            setChatmsg("")
            setNewStatus(-1);
            setCurrentstatus("");
        }
        else {
            setstartdate("");
            setlistdata("");
            setChatmsg("");
        }
    }

    const panelHeader = (data, userid) => {
        let { createdby, assignto, checklist = [], status, taskpriority, tasktype, currentstatus, deadline, extenddeadline, pinmsg, taguser = [], createdte, lastmsgtime } = data;

        data.deadline = ""; // No more deadline for task, 2024/05/10
        data.alertdeadline = checklist.some(item => item.status !== true && new Date(item.deadline).getTime() < Date.now());

        const findUser = (id) => userLists.find(user => user._id === id && user.userid !== userid);

        const assigntoUser = findUser(assignto);
        const createdbyUser = findUser(createdby);

        let assigned = `${createdby === userid ? `${assignto === userid ? '' : `${assigntoUser?.userid}(${assigntoUser?.markingcode || assigntoUser?.username})`}` : `${createdbyUser?.userid}(${createdbyUser?.markingcode || createdbyUser?.username})`}`;

        let totaltaguser = data.taguser ? data.taguser.length : "";
        const progress = checklist.length ? Math.round((checklist.filter(item => item.status).length / checklist.length) * 100 * 100) / 100 : 0;
        if (checklist.length) assigned += ` - ${GetTranslation(userlang, "Task List")}:${checklist.filter(item => item.status).length}/${checklist.length}`;

        const getStatusElement = () => {
            const tempcompletedata = moment.unix(data.completedate || moment().unix()).format("MM/DD HH:mm");
            const statusText = status === 0 ? `` :
                status === 1 ? `${assigned} - ${GetTranslation(userlang, "Completed at")} ${tempcompletedata}` :
                    status === 2 ? `${assigned} - ${GetTranslation(userlang, "On Hold at")} ${moment.unix(data.updatedte).format("MM/DD HH:mm")}` :
                        status === 3 ? `${assigned} - ${GetTranslation(userlang, "Completed at")} ${tempcompletedata}` :
                            status === 9 ? `${assigned} - ${GetTranslation(userlang, "Canceled at")} ${tempcompletedata}` : ``;
            return <small style={{ fontSize: "9px", display: "inline-block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100%" }}>{statusText}</small>;
        };

        const titleFirstLetter = data.taskname.charAt(0).toUpperCase();

        const avatar = (
            <Avatar style={{ backgroundColor: "lightgray", color: "white", marginRight: "8px", width: "32px", height: "32px", fontSize: "16px", lineHeight: "32px" }}>
                {titleFirstLetter}
            </Avatar>
        );

        const ele2 = (
            <small style={{ display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontWeight: "bold", fontSize: "14px" }}>
                {data.taskname}
            </small>
        );

        const getPinMessageElement = (pinmsg) => {
            return (
                <small style={{ display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "calc(100% - 40px)", color: "#666", fontSize: "12px" }}>
                    <PushPinIcon style={{ display: "inline-block", fontSize: "12px", verticalAlign: "middle", marginRight: "5px" }} />
                    {pinmsg}
                </small>
            );
        };

        let read = "isread";
        let pplread = "isread";

        let countunread = data.countunread;
        let timemsgdisplay = "none";

        if (data.assignto == userid) {
            if (data.atunread == 1) {
                read = "isunread";
                timemsgdisplay = "inline-block";
            } else if (data.cbunread == 1) {
                pplread = "isunread";
            }
        } else if (data.createdby == userid) {
            if (data.cbunread == 1) {
                read = "isunread";
                timemsgdisplay = "inline-block";
            } else if (data.atunread == 1) {
                pplread = "isunread";
            }
        } else if (data.taguser != undefined) {
            var taguserresult = data.taguser.filter(x => x.userid == userid)[0];
            if (taguserresult != undefined && taguserresult != null) {
                if (taguserresult.unread == 1) {
                    read = "isunread";
                    countunread = taguserresult.countunread;
                    if (countunread > 0) {
                        timemsgdisplay = "inline-block";
                    }
                }
            }
        }

        let daydiff = "";
        let hoursdiff = "";
        let minutesdiff = "";

        if (data.lastmsgtime != undefined && data.lastmsgtime != null) {
            daydiff = moment().diff(moment.unix(data.lastmsgtime), 'days');
            hoursdiff = moment().diff(moment.unix(data.lastmsgtime), 'hours');
            minutesdiff = moment().diff(moment.unix(data.lastmsgtime), 'minutes');
            if (parseInt(minutesdiff) < 0) {
                if (parseInt(hoursdiff) < 0) {
                    if (parseInt(daydiff) < 0) {
                        lastmsgtime = moment.unix(data.lastmsgtime).format("DD MMM");
                    } else {
                        lastmsgtime = hoursdiff == "" ? "" : `${`${hoursdiff * -1} ${hoursdiff * -1 == 1 ? GetTranslation(userlang, "hour ago") : GetTranslation(userlang, "hours ago")}`}`;
                    }
                } else {
                    lastmsgtime = minutesdiff == "" ? "" : `${`${minutesdiff * -1} ${minutesdiff * -1 == 1 ? GetTranslation(userlang, "minute ago") : GetTranslation(userlang, "minutes ago")}`}`;
                }
            } else {
                if (parseInt(hoursdiff) > 0) {
                    if (parseInt(daydiff) > 0) {
                        lastmsgtime = moment.unix(data.lastmsgtime).format("DD MMM");
                    } else {
                        lastmsgtime = hoursdiff == "" ? "" : `${`${hoursdiff} ${hoursdiff == 1 ? GetTranslation(userlang, "hour ago") : GetTranslation(userlang, "hours ago")}`}`;
                    }
                } else {
                    lastmsgtime = minutesdiff == "" ? "" : `${`${minutesdiff} ${minutesdiff == 1 ? GetTranslation(userlang, "minute ago") : GetTranslation(userlang, "minutes ago")}`}`;
                }
            }
            if (parseInt(minutesdiff) == 0) {
                lastmsgtime = "Now";
            }
        }

        return (
            <div style={{ display: "flex", alignItems: "center", width: "100%", borderLeft: tasktype === 'start' ? "4px solid limegreen" : tasktype === 'end' ? "4px solid tomato" : "none" }}>
                <div style={{ display: "flex", alignItems: "center", width: "100%", overflow: "hidden" }}>
                    {avatar}
                    <div style={{ display: "flex", flexDirection: "column", width: "100%", overflow: "hidden" }}>
                        {ele2}
                        {pinmsg ? getPinMessageElement(pinmsg) : null}
                    </div>
                </div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", width: "20%", textAlign: "right" }}>
                    <small style={{ display: "block", fontSize: "8px" }}>{lastmsgtime}</small>
                    <div style={{ position: 'relative', width: '20px', height: '20px' }}>
                        <small style={{ display: `${timemsgdisplay}`, backgroundColor: '#5cb85c', color: 'white', fontSize: '10px', borderRadius: '50%', width: '100%', height: '100%', textAlign: 'center', lineHeight: '20px' }}>
                            {countunread}
                        </small>
                    </div>
                </div>
            </div>
        );
    };

    // const genExtra = (data) => {
    //     var read = "isread";
    //     var pplread = "isread";

    //     let daydiff = "";
    //     let hoursdiff = "";
    //     let minutesdiff = "";

    //     let lastmsgtime
    //     let countunread = data.countunread

    //     let timemsgdisplay = "none"
    //     // 20210802 Logic Fixed
    //     if (data.assignto == userid) {
    //         if (data.atunread == 1) {
    //             read = "isunread";
    //             timemsgdisplay = "inline-block"
    //         }

    //         //Check 3rd person see or not
    //         else if (data.cbunread == 1) {
    //             pplread = "isunread";
    //         }
    //     }
    //     else if (data.createdby == userid) {
    //         if (data.cbunread == 1) {
    //             read = "isunread";
    //             timemsgdisplay = "inline-block"
    //         }

    //         //Check 3rd person see or not
    //         else if (data.atunread == 1) {
    //             pplread = "isunread";
    //         }
    //     }
    //     // else if (data.reportto == userid) {
    //     //     if (data.atunread == 1) {
    //     //         if (data.assignto != userid) {
    //     //             read = "isunread";
    //     //         }
    //     //     }

    //     //     if (data.cbunread == 1) {
    //     //         if (data.createdby != userid) {
    //     //             pplread = "isunread";
    //     //         }
    //     //     }
    //     // }
    //     else if (data.taguser != undefined) {
    //         var taguserresult = data.taguser.filter(x => x.userid == userid)[0];

    //         if (taguserresult != undefined && taguserresult != null) {
    //             if (taguserresult.unread == 1) {
    //                 read = "isunread"
    //                 countunread = taguserresult.countunread
    //                 if (countunread > 0) {
    //                     timemsgdisplay = "inline-block"
    //                 }
    //             }
    //         }
    //     }



    //     //===== DIFFERENCE BETWEEN DAY ======
    //     if (data.lastmsgtime != undefined && data.lastmsgtime != null) {
    //         daydiff = moment().diff(moment.unix(data.lastmsgtime), 'days');
    //         hoursdiff = moment().diff(moment.unix(data.lastmsgtime), 'hours');
    //         minutesdiff = moment().diff(moment.unix(data.lastmsgtime), 'minutes');
    //         if (parseInt(minutesdiff) < 0) {
    //             if (parseInt(hoursdiff) < 0) {
    //                 if (parseInt(daydiff) < 0) {
    //                     lastmsgtime = moment.unix(data.lastmsgtime).format("DD MMM");
    //                 }
    //                 else {
    //                     lastmsgtime = hoursdiff == "" ? "" : `${`${hoursdiff * -1} ${hoursdiff * -1 == 1 ? GetTranslation(userlang, "hour ago") : GetTranslation(userlang, "hours ago")}`}`;
    //                 }
    //             }
    //             else {
    //                 lastmsgtime = minutesdiff == "" ? "" : `${`${minutesdiff * -1} ${minutesdiff * -1 == 1 ? GetTranslation(userlang, "minute ago") : GetTranslation(userlang, "minutes ago")}`}`;
    //             }
    //         }
    //         else {
    //             daydiff = moment().diff(moment.unix(data.lastmsgtime), 'days');
    //             hoursdiff = moment().diff(moment.unix(data.lastmsgtime), 'hours');
    //             minutesdiff = moment().diff(moment.unix(data.lastmsgtime), 'minutes');
    //             if (parseInt(hoursdiff) > 0) {
    //                 if (parseInt(daydiff) > 0) {
    //                     lastmsgtime = moment.unix(data.lastmsgtime).format("DD MMM");
    //                 }
    //                 else {
    //                     lastmsgtime = hoursdiff == "" ? "" : `${`${hoursdiff} ${hoursdiff == 1 ? GetTranslation(userlang, "hour ago") : GetTranslation(userlang, "hours ago")}`}`;
    //                 }
    //             }
    //             else {
    //                 lastmsgtime = minutesdiff == "" ? "" : `${`${minutesdiff} ${minutesdiff == 1 ? GetTranslation(userlang, "minute ago") : GetTranslation(userlang, "minutes ago")}`}`;
    //             }

    //         }
    //         if (parseInt(minutesdiff) == 0) {
    //             lastmsgtime = "Now";
    //         }
    //     }


    //     return (
    //         <>

    //             <div>
    //                 {/* YOU */}

    //                 {/* <small style={{ display: "block", fontSize: "8px" ,textAlign: "right" }}>{moment.unix(data.createdte).format("YYYY/MMM/DD")}</small> */}

    //                 <div style={{ textAlign: "right" }}>
    //                     <span className={read}></span>
    //                     {/* 3RD PARTY */}
    //                     <span className={pplread}></span>
    //                 </div>

    //                 <small style={{ display: "block", fontSize: "8px" }}>{lastmsgtime}</small>

    //                 <div
    //                     style={{
    //                         position: 'relative',
    //                         textAlign: 'right',
    //                         marginLeft: "auto",
    //                         width: '20px', // Adjust the width to your preference
    //                         height: '20px', // Keep the height the same as the width for a perfect circle
    //                     }}
    //                 >
    //                     <small
    //                         style={{
    //                             display: `${timemsgdisplay}`,
    //                             backgroundColor: '#5cb85c',
    //                             color: 'white',
    //                             fontSize: '10px',
    //                             borderRadius: '50%', // Make it circular
    //                             //padding: '4px',
    //                             width: '100%', // Ensure the width and height are the same for a perfect circle
    //                             height: '100%',
    //                             textAlign: 'center',
    //                             lineHeight: '20px', // Set line height to center the text vertically
    //                         }}
    //                     >
    //                         {countunread}
    //                     </small>
    //                 </div>

    //                 {/* <div style={{ textAlign: "right" }}>
    //                     <small style={{ display: `${timemsgdisplay}`, color: "rgb(41,144,64)", fontSize: "8px" }}>{countunread}</small>
    //                 </div> */}

    //             </div>

    //         </>
    //     )
    // }

    const onStatusLoad = (value, table) => {
        if (value != undefined) {
            var filteredDS;

            filteredDS = table


            return filteredDS;
        }
        else {
            return table;
        }
    }

    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 4 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 20 },
        },
    };
    const formItemLayoutWithOutLabel = {
        wrapperCol: {
            xs: { span: 24, offset: 0 },
            sm: { span: 20, offset: 4 },
        },
    };

    const onFinish = (val, result) => {



        console.log("val", val.checklist)

        console.log("CurrentData", CurrentData)
        // setchecklist(val.checklist)
        // setlistdata(result)
        onUpdate(CurrentData, null, val.checklist)
        var msg = `Check List Updated at ${moment().format("DD/M ddd h:mm a")}`
        onSendMessage(CurrentData, msg)
        setModalVisible2(false);

        //onTaskChange(CurrentData._id);

        onReload()
        //REFRESH
        let newds = datasource;
        let newindex = datasource["all"].findIndex(x => x._id == CurrentData._id);

        newds["all"][newindex].checklist = val.checklist;


        let newds1 = newdatasource;
        let newindex1 = newdatasource.findIndex(x => x._id == CurrentData._id);
        newds1[newindex1].lastmsgtime = moment().unix();

        newds1[newindex1].checklist = val.checklist;

        setNewDatasource(newds1);
        setDataSource(newds);

        setBtnDisable(false)
        // message.success(GetTranslation(userlang, "Update successful"));

    };

    const showModal2 = (val, result) => {


        if (result.assignto == userid) {
            setbtnchecklist(false)
        }
        else {
            setbtnchecklist(true)
        }

        if (result.checklist != undefined) {
            setTaskItems(result.checklist)
        }
        else {
            setTaskItems([{ items: "", status: "" }])
        }


        //console.log('task',result)
        setlistdata(result)
        // console.log('taskitems',result.checklist)

        setModalVisible2(true);

    };

    const handleOk2 = (val) => {

        //onUpdate(listdata)
        setModalVisible2(false);

        setTaskItems([{ items: "", status: "" }])

    };

    const handleCancel2 = (val, result) => {

        // if(checklist.length>0)
        // {
        //     setModalVisible2(false);

        //     onUpdate(listdata)
        //     setchecklist("")

        //   //  window.location.reload();
        // }
        // else
        // {
        //     setModalVisible2(false);
        //     setchecklist("")
        // }

        setModalVisible2(false);

        setTaskItems([{ items: "", status: "" }])
    };

    //==== TASK =====
    const taskrenderItem = (item) => {
        let tooltipchecklist = []
        //let modalchecklist = []
        //var obj = {};
        var iconcolor = "grey"

        if (reminderdatasource) {
            var result22 = reminderdatasource.filter(x => x.taskid == item._id && x.chatid == "");


            if (result22.length > 0) {
                if (result22[0].rtype == "repeat") {
                    iconcolor = "green"
                }
                else if (result22[0].rtype == "once") {
                    if (result22[0].rdate > moment().unix()) {
                        iconcolor = "blue"
                    }
                    else {
                        iconcolor = "red"
                    }
                }

            }
            else {
                iconcolor = "grey"
            }
            if (item.checklist != undefined) {
                if (item.checklist.length > 0) {
                    for (var i = 0; i < item.checklist.length; i++) {
                        //  obj = {}
                        tooltipchecklist.push(`${item.checklist[i].status ? "☑" : "☐"} - ${item.checklist[i].items}  \n`)
                        tooltipchecklist.push(<br></br>)



                        // obj["items"] = item.checklist[i].items.toString().trim()
                        // obj["status"] = item.checklist[i].status 
                        // modalchecklist.push(obj)
                    }

                }
            }

        }

        const showModal3 = (val, result) => {

            setonceperiodview("hidden")
            setrepeatperiodview("hidden")
            setremindertaskid(result._id)
            setreminderchatid("")



            var result11 = reminderdatasource.filter(x => x.taskid == result._id && x.chatid == "");

            if (result11[0]) {
                setremindertaskname(result11[0].taskname)
                setremindermessage(result11[0].message)
                setrepeatperiod(result11[0].rperiod)
                setreminderdate(result11[0].rdate)
                setremindertime(result11[0].rtime)
                setreminderweek(result11[0].rweek)
                setremindermonth(result11[0].rmonth)
                setremindertype(result11[0].rtype)

                setreminderobjectid(result11[0]._id)
                setreminderdeletebutton(true)

                if (result11[0].rtype == "once") {
                    setonceperiodview("visible")
                    setremindertype("once")

                    setrepeatperiodview("hidden")
                }

                else {
                    setonceperiodview("hidden")
                    setremindertype("repeat")
                    setrepeatperiodview("visible")
                }
            }

            else {
                setremindertaskname(result.taskname)
                setremindermessage("")
                setreminderdeletebutton(false)
            }

            setModalVisible3(true);




        };

        const handleCancel3 = (val, result) => {


            setModalVisible3(false);

            setonceperiodview("hidden")
            setrepeatperiodview("hidden")
            setremindertaskid("")
            setrepeatperiod("")
            setreminderdate("")
            setremindertime("")
            setreminderweek([])
            setremindermonth("")
            setremindertype("")
        };

        function typechange(e) {


            if (e == "once") {
                setonceperiodview("visible")
                setremindertype("once")

                setrepeatperiodview("hidden")
            }
            else {
                setonceperiodview("hidden")
                setremindertype("repeat")
                setrepeatperiodview("visible")
            }


            setreminderdate("")
            setremindertime("")
            setreminderweek([])
            setremindermonth("")
        }

        function periodchange(e) {

            if (e == "weekly") {
                setrepeatperiod("weekly")
            }
            else if (e == "monthly") {
                setrepeatperiod("monthly")
            }
            else if (e == "yearly") {
                setrepeatperiod("yearly")
            }

            //   setreminderdate("")
            //   setremindertime("")
            //   setreminderweek([])
            //   setremindermonth("")
        }

        function datechange(e) {
            setreminderdate(moment(e).format("YYYYMMDD"))
        }

        function timechange(e) {

            //  setremindertime(moment(e).format("HH:mm"))
            if (e != null) {
                setremindertime(e.$H.toString().padStart(2, "0") + ":" + e.$m.toString().padStart(2, "0"))
                setremindertime1(e)
            }
        }


        const ReminderForm = () => {

            if (onceperiodview == "visible") {

                return (
                    <div>


                        <Form >
                            <br />
                            <Form.Item>
                                <DatePicker style={{ width: "60%" }}
                                    format="YYYY-MM-DD"
                                    onChange={datechange}
                                    defaultValue={reminderdate ? moment.unix(reminderdate) : null}>

                                </DatePicker>

                            </Form.Item>
                            <Form.Item>
                                <TimePicker format={"HH:mm"} style={{ width: "60%" }} inputReadOnly defaultValue={remindertime ? moment(remindertime, "HH:mm") : null} minuteStep={10} onChange={timechange}>

                                </TimePicker>
                            </Form.Item>
                        </Form>
                    </div>
                )

            }

            else if (repeatperiodview == "visible") {
                return (
                    <div>
                        <Form>
                            <br />
                            <Form.Item>
                                <Select style={{ width: "60%" }} placeholder={"Select Period"} defaultValue={repeatperiod ? repeatperiod : null} onChange={periodchange}  >
                                    <Option value={"weekly"}>{"Weekly"}</Option>
                                    <Option value={"monthly"}>{"Monthly"}</Option>
                                    <Option value={"yearly"}>{"Yearly"}</Option>
                                </Select>
                            </Form.Item>

                            {RepeatForm()}

                            <Form.Item>
                                <TimePicker format={"HH:mm"} style={{ width: "60%" }}
                                    defaultValue={remindertime ? moment(remindertime, "HH:mm") : null} minuteStep={10} onChange={timechange}
                                    inputReadOnly>

                                </TimePicker>
                            </Form.Item>
                        </Form>
                    </div>
                )
            }
        }

        const weekdaychange = (checkedValues) => {

            setreminderweek(checkedValues)

        };

        const monthchange = (Values) => {

            setremindermonth(Values)


        };
        const tasknamechange = (Values) => {


            setremindertaskname(Values)


        };
        const messagechange = (Values) => {


            setremindermessage(Values)


        };
        const RepeatForm = () => {

            const weekdayslist = [

                {
                    label: 'Monday',
                    value: 'Monday',
                },
                {
                    label: 'Tuesday',
                    value: 'Tuesday',
                },
                {
                    label: 'Wednesday',
                    value: 'Wednesday',
                },
                {
                    label: 'Thursday',
                    value: 'Thursday',
                },
                {
                    label: 'Friday',
                    value: 'Friday',
                },
                {
                    label: 'Saturday',
                    value: 'Saturday',
                },
                {
                    label: 'Sunday',
                    value: 'Sunday',
                },
            ]
            if (repeatperiod == "weekly") {
                return (
                    <Form.Item>
                        <Checkbox.Group className="ant-checkbox-group"
                            style={{ display: "inline-grid" }} options={weekdayslist} defaultValue={reminderweek ? reminderweek : null} onChange={weekdaychange} />

                        <div>
                            <br />
                        </div>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Stack>
                                <TimePicker
                                    label="Weekly Time"
                                    value={remindertime1 ? remindertime1 : null}
                                    onChange={timechange}
                                    inputFormat="hh:mm a"
                                    renderInput={(params) => <TextField {...params} />}
                                >

                                </TimePicker>
                            </Stack>

                        </LocalizationProvider>
                    </Form.Item>
                )
            }
            else if (repeatperiod == "monthly") {
                return (
                    <Form.Item>
                        <Select style={{ width: "60%" }} placeholder={"Select Date"} defaultValue={remindermonth ? remindermonth : null} onChange={monthchange} allowClear showSearch >
                            <Option value={"1"}>{"1"}</Option>
                            <Option value={"2"}>{"2"}</Option>
                            <Option value={"3"}>{"3"}</Option>
                            <Option value={"4"}>{"4"}</Option>
                            <Option value={"5"}>{"5"}</Option>
                            <Option value={"6"}>{"6"}</Option>
                            <Option value={"7"}>{"7"}</Option>
                            <Option value={"8"}>{"8"}</Option>
                            <Option value={"9"}>{"9"}</Option>
                            <Option value={"10"}>{"10"}</Option>
                            <Option value={"11"}>{"11"}</Option>
                            <Option value={"12"}>{"12"}</Option>
                            <Option value={"13"}>{"13"}</Option>
                            <Option value={"14"}>{"14"}</Option>
                            <Option value={"15"}>{"15"}</Option>
                            <Option value={"16"}>{"16"}</Option>
                            <Option value={"17"}>{"17"}</Option>
                            <Option value={"18"}>{"18"}</Option>
                            <Option value={"19"}>{"19"}</Option>
                            <Option value={"20"}>{"20"}</Option>
                            <Option value={"21"}>{"21"}</Option>
                            <Option value={"22"}>{"22"}</Option>
                            <Option value={"23"}>{"23"}</Option>
                            <Option value={"24"}>{"24"}</Option>
                            <Option value={"25"}>{"25"}</Option>
                            <Option value={"26"}>{"26"}</Option>
                            <Option value={"27"}>{"27"}</Option>
                            <Option value={"28"}>{"28"}</Option>
                        </Select>
                        <div>
                            <br />
                        </div>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Stack>
                                <TimePicker
                                    label="Monthly Time"
                                    value={remindertime1 ? remindertime1 : null}
                                    onChange={timechange}
                                    inputFormat="hh:mm a"
                                    renderInput={(params) => <TextField {...params} />}
                                >

                                </TimePicker>
                            </Stack>

                        </LocalizationProvider>
                    </Form.Item>
                )
            }
            else if (repeatperiod == "yearly") {
                return (
                    <Form.Item>
                        {/* <DatePicker style={{width: "60%"}}
                     defaultValue={reminderdate ? moment.unix(reminderdate): null}
                    format="MM-DD"
                    onChange={datechange}>
          
                   </DatePicker> */}
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Stack>
                                <DateTimePicker
                                    label="Yearly Date Time"
                                    value={reminderdate1 ? reminderdate1 : null}
                                    onChange={datechange}
                                    minDate={dayjs()}
                                    inputFormat="MM/DD hh:mm a"
                                    renderInput={(params) => <TextField {...params} />}
                                >

                                </DateTimePicker>
                            </Stack>

                        </LocalizationProvider>

                    </Form.Item>
                )
            }

        }

        const handleOk3 = (val) => {

            // console.log("task id >>>>", remindertaskid)
            // console.log("remindertype >>>",remindertype)
            // console.log("repeatperiod >>>",repeatperiod)
            // console.log("reminderdate >>>",reminderdate)
            //  console.log("remindertime >>>", remindertime)
            //  console.log("reminderweek >>>",reminderweek)
            // console.log("remindermonth >>>",remindermonth)
            var tempreminderdate = reminderdate
            if (Number.isInteger(tempreminderdate) == true) {
                tempreminderdate = moment.unix(tempreminderdate).format("YYYYMMDD").toString()
                console.log("tempreminderdate >>>>", tempreminderdate)
            }
            var currentdate = tempreminderdate + " " + remindertime
            // console.log("reminder currentdate1 >>", currentdate)
            var currentdate1 = moment(currentdate, "YYYYMMDD, HH:mm").format()
            // console.log("reminder currentdate5 >>", moment(currentdate1).unix())
            //  console.log("remindertaskname >>>",remindertaskname)
            //  console.log("remindermessage >>>",remindermessage)

            // console.log("tempreminderdate >>>>",tempreminderdate)
            var crontab = ""
            var splitvar = remindertime.split(":")
            // console.log("splitvar >>>",splitvar)
            if (remindertype == "once") {


                crontab = splitvar[1].toString() + " " +
                    splitvar[0].toString() + " " +
                    moment(tempreminderdate).format("DD").toString() + " " +
                    moment(tempreminderdate).format("MM").toString() + " " +
                    "*"
            }
            else {
                if (repeatperiod == "weekly") {
                    var weekstring = ''
                    if (reminderweek) {
                        for (var x = 0; x < reminderweek.length; x++) {
                            if (reminderweek[x] == "Monday") {
                                if (weekstring.length == 0) {
                                    weekstring = "1"
                                }
                                else {
                                    weekstring = weekstring + ",1"
                                }

                            }
                            else if (reminderweek[x] == "Tuesday") {
                                if (weekstring.length == 0) {
                                    weekstring = "2"
                                }
                                else {
                                    weekstring = weekstring + ",2"
                                }
                            }
                            else if (reminderweek[x] == "Wednesday") {
                                if (weekstring.length == 0) {
                                    weekstring = "3"
                                }
                                else {
                                    weekstring = weekstring + ",3"
                                }
                            }
                            else if (reminderweek[x] == "Thursday") {
                                if (weekstring.length == 0) {
                                    weekstring = "4"
                                }
                                else {
                                    weekstring = weekstring + ",4"
                                }
                            }
                            else if (reminderweek[x] == "Friday") {
                                if (weekstring.length == 0) {
                                    weekstring = "5"
                                }
                                else {
                                    weekstring = weekstring + ",5"
                                }
                            }
                            else if (reminderweek[x] == "Saturday") {
                                if (weekstring.length == 0) {
                                    weekstring = "6"
                                }
                                else {
                                    weekstring = weekstring + ",6"
                                }
                            }
                            else if (reminderweek[x] == "Sunday") {
                                if (weekstring.length == 0) {
                                    weekstring = "7"
                                }
                                else {
                                    weekstring = weekstring + ",7"
                                }
                            }
                        }
                    }

                    crontab = splitvar[1].toString() + " " +
                        splitvar[0].toString() + " " +
                        "*" + " " +
                        "*" + " " +
                        weekstring
                }
                if (repeatperiod == "monthly") {
                    crontab = splitvar[1].toString() + " " +
                        splitvar[0].toString() + " " +
                        remindermonth + " " +
                        "*" + " " +
                        "*"
                }
                if (repeatperiod == "yearly") {
                    crontab = splitvar[1].toString() + " " +
                        splitvar[0].toString() + " " +
                        moment(tempreminderdate).format("DD").toString() + " " +
                        moment(tempreminderdate).format("MM").toString() + " " +
                        "*"
                }
            }

            // console.log("crontab >>>>",crontab)
            var data =
            {
                taskid: remindertaskid,
                chatid: reminderchatid,
                taskname: remindertaskname,
                message: remindermessage,
                rgroup: "task",
                rtype: remindertype,
                rperiod: repeatperiod,
                rdate: moment(currentdate1).unix(),
                rtime: remindertime,
                rweek: reminderweek,
                rmonth: remindermonth,
                rstatus: 1,
                createdby: userid,
                crontab: crontab
            }

            if (remindertype) {
                if (remindertype == "once") {
                    if (reminderdate) {
                        if (remindertime) {
                            const result = updateReminder(data);
                        }
                        else {
                            message.error("Please Select Reminder Time");
                        }
                    }
                    else {
                        message.error("Please Select Reminder Date");
                    }
                }
                else {
                    if (repeatperiod == "weekly") {
                        if (reminderweek.length > 0) {
                            if (remindertime) {
                                const result = updateReminder(data);
                            }

                            else {
                                message.error("Please Select Reminder Time");
                            }
                        }
                        else {
                            message.error("Please Tick atleast 1 day");
                        }
                    }
                    else if (repeatperiod == "monthly") {
                        if (remindermonth) {
                            if (remindertime) {
                                const result = updateReminder(data);
                            }

                            else {
                                message.error("Please Select Reminder Time");
                            }
                        }
                        else {
                            message.error("Please Select Reminder Month");
                        }
                    }
                    else if (repeatperiod == "yearly") {
                        if (reminderdate) {
                            if (remindertime) {
                                const result = updateReminder(data);
                            }
                            else {
                                message.error("Please Select Reminder Time");
                            }
                        }
                        else {
                            message.error("Please Select Reminder Date");
                        }
                    }

                    else {
                        message.error("Please Select Reminder Repeat Period");
                    }
                }
            }
            else {
                message.error("Please Select Reminder Type");
            }

            //  const result = updateReminder(data);


        }
        async function updateReminder(data) {
            const result = await onUpdateTasksReminder(data);
            if (result && result.status === "ok") {
                message.success(result.msg);

                setModalVisible3(false);

                setonceperiodview("hidden")
                setrepeatperiodview("hidden")
                setremindertaskid("")
                setreminderchatid("")
                setrepeatperiod("")
                setreminderdate("")
                setremindertime("")
                setreminderweek([])
                setremindermonth("")
                setremindertype("")
                setremindertaskname("")
                setremindermessage("")

                onGetReminderLists({ createdby: userid })
            }
            else {
                message.error(result.msg);

            }
        };
        const handleDelete3 = (val) => {



            var answer = window.confirm("Are you sure want to delete this Reminder?")


            if (answer == true) {
                const result = deleteReminder();
            }



        }

        async function deleteReminder(data) {
            const result = await onRemoveTasksReminder({ _id: reminderobjectid });
            if (result && result.status === "ok") {
                message.success(result.msg);

                setModalVisible3(false);

                setonceperiodview("hidden")
                setrepeatperiodview("hidden")
                setremindertaskid("")
                setreminderchatid("")
                setrepeatperiod("")
                setreminderdate("")
                setremindertime("")
                setreminderweek([])
                setremindermonth("")
                setremindertype("")
                setremindertaskname("")
                setremindermessage("")

                onGetReminderLists({ createdby: userid })
            }
            else {
                message.error(result.msg);

            }
        };




        var find_users = userLists.find(x => x._id == item.assignto);

        var assignto_username = find_users?.userid;

        // Ensure that item.checklist is an array; if not, default to an empty array
        const checklist = item.checklist || [];

        // Total number of records is the length of the checklist array
        const totalRecords = checklist.length;

        // Counting how many items have a status of true
        // The callback function increments the count only if the status property exists and is true
        const trueStatusCount = checklist.reduce((count, obj) => {
            return count + (obj.status === true ? 1 : 0);
        }, 0);

        // console.log(`Total records: ${totalRecords}`);
        // console.log(`Records with status true: ${trueStatusCount}`);

        const showChecklistModal = (val, item) => {

            setChecklistmodalvisible(true);
            if (item.checklist != undefined) {
                setchecklist(item.checklist)
            }
            else {
                setchecklist([{ items: "", status: "" }])
            }
        };

        var tempmentionvalue = [...mentionvalue]

        var createduserid = tempmentionvalue.filter(x => x._id == item.createdby)
        var assigntouserid = tempmentionvalue.filter(x => x._id == item.assignto)

        var filteredMentionvalue = tempmentionvalue

        //if (item.createdby != userid) {
        if (Array.isArray(item.taguser) && item.taguser.length > 0) {
            filteredMentionvalue = tempmentionvalue.filter(mv => item.taguser.some(tu => tu.userid === mv._id));
        }
        else {
            filteredMentionvalue = []
        }
        //}


        //if (item.createdby != userid) {
        // Combine and deduplicate the arrays only if needed
        // Since we're combining arrays, ensure no duplicates if necessary
        // This example assumes the items are objects and distinct by _id

        // Merge and deduplicate based on _id
        let combinedIds = [...filteredMentionvalue, ...createduserid, ...assigntouserid];
        filteredMentionvalue = combinedIds.reduce((acc, current) => {
            const x = acc.find(item => item._id === current._id);
            if (!x) {
                return acc.concat([current]);
            } else {
                return acc;
            }
        }, []);

        //}

        const loadMoreNotes = () => {
            setDisplayLimit((prevLimit) => Math.min(prevLimit + 5, item.notelist.length));
        };



        return (

            <>
                <Collapse
                    className="custom-collapse"
                    expandIcon={() => null}
                    // expandIconPosition={'right'}
                    // accordion
                    onChange={onTaskChange}
                    // activeKey={collapse}

                    activeKey={ChatRoomActiveKey}
                //onChange={setChatRoomActiveKey}
                //style={{}}
                >

                    <Panel
                        header={panelHeader(item, userid)}
                        key={displaymode === "self" ? item.newtaskid : item._id}
                        id={displaymode === "self" ? item.newtaskid : item._id} // Assigning ID here
                        style={{
                            marginTop: "5px",
                            backgroundColor: (item.status === 1 || item.status === 3 ? "#e9f7ef" : item.alertdeadline ? "#fdecec" : ""),
                            fontWeight: (item.createdby === userid
                                ? item.acbunread === 1
                                    ? "bold"
                                    : ""
                                : item.assignto === userid
                                    ? item.atunread === 1
                                        ? "bold"
                                        : ""
                                    : item.taguser !== undefined
                                        ? item.taguser.filter(x => x.userid === userid)[0] !== undefined
                                            ? item.taguser.filter(x => x.userid === userid)[0].unread > 0
                                                ? "bold"
                                                : ""
                                            : ""
                                        : ""),
                            boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                            transition: 'box-shadow 0.3s ease-in-out'
                        }}
                        onClick={() => handlePanelClick(item)}
                    >


                        {/* ATTACHMENTS */}
                        <div>
                            {showAttachmentList(item)}
                        </div>
                        <div>
                            {
                                item.createdby == userid ?
                                    <>

                                        <Paragraph className="textparagraph">
                                            <IconButton sx={{ color: 'dimgrey' }} onClick={(val) => {
                                                if (item.deadline) {
                                                    var monthdateFormat = "YYYY/MM/DD HH:mm"

                                                    setdayjsdate(dayjs(moment.unix(item.deadline).format(monthdateFormat), monthdateFormat))

                                                }


                                                console.log("Edit Task >>>", item)
                                                clearInterval(intervalIdRef.current);

                                                setTaskData(item);
                                                setEditdata(item);
                                                setCollapse(["1"]);
                                                setIsEdit(2)
                                            }}>
                                                <EditIcon fontSize='small'></EditIcon>
                                            </IconButton>
                                            {item.description}</Paragraph>
                                    </>
                                    :
                                    <>
                                        <Paragraph className="textparagraph">{item.description}</Paragraph>
                                    </>
                            }





                        </div>



                        <div id={`C${item._id}`}><Checklist checklist={item.checklist} taskdata={item} /></div>

                        {

                            item.notelist != undefined && item.notelist.length > 0 ?

                                <>
                                    <div>
                                        Note Listing
                                        {item.notelist
                                            .slice() // Create a shallow copy of the array to avoid mutating the original state
                                            .sort((a, b) => b.notecreatedte - a.notecreatedte) // Sort descending by createdte
                                            .slice(0, displayLimit) // Limit the displayed items
                                            .map((msg, index) => (
                                                <Message
                                                    key={index}
                                                    from={FULLuserLists.find(x => x._id === msg.from)?.userid || "Unknown user"}
                                                    message1={msg.message}
                                                    createDate={msg.createdte}
                                                    index={index}
                                                    item={msg}
                                                />
                                            ))}
                                        {displayLimit < item.notelist.length && (
                                            <Button onClick={loadMoreNotes} style={{ marginTop: '10px' }}>
                                                Load More ({item.notelist.length - displayLimit})
                                            </Button>
                                        )}
                                        {displayLimit >= 2 && (
                                            <Button onClick={hideNotes} style={{ marginTop: '10px' }}>
                                                Hide
                                            </Button>
                                        )}
                                    </div>
                                </>
                                :
                                <>
                                </>
                        }

                        <div />
                        <br />

                        <Modal
                            destroyOnClose={true}
                            title={GetTranslation(userlang, "Check List")}
                            visible={modalVisible2}
                            //onOk={handleOk2}
                            onCancel={(val) => { handleCancel2(val, item) }}

                            footer={[
                                <Button key="back" onClick={(val) => { handleCancel2(val, item) }}>
                                    {GetTranslation(userlang, "Close")}
                                </Button>
                            ]}
                        >
                            <Form name="dynamic_form_nest_item" onFinish={(val) => { onFinish(val, item) }} autoComplete="off"
                                initialValues={{ checklist: taskitems }}>
                                <Form.List name="checklist">
                                    {(fields, { add, remove }) => (
                                        <>
                                            {fields.map(({ key, name, ...restField }) => (
                                                <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">

                                                    <Form.Item

                                                        {...restField}
                                                        name={[name, 'items']}
                                                        rules={[{ required: true, message: 'Missing Item' }]}
                                                    >
                                                        <Input style={{
                                                            width:
                                                                isMobile == true ? Screenwidth * 0.7 : Screenwidth * 0.25
                                                        }} placeholder="Items" />
                                                    </Form.Item>
                                                    <Form.Item
                                                        {...restField}
                                                        name={[name, 'status']}
                                                        valuePropName="checked"
                                                    >
                                                        <Checkbox></Checkbox>
                                                    </Form.Item>
                                                    <MinusCircleOutlined style={{ color: 'red' }} onClick={() => remove(name)} />
                                                </Space>
                                            ))}
                                            <Form.Item>
                                                <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                                    {GetTranslation(userlang, "Add Field")}
                                                </Button>
                                            </Form.Item>
                                        </>
                                    )}
                                </Form.List>
                                <Form.Item>
                                    <Button type="primary" htmlType="submit">
                                        {GetTranslation(userlang, "Save")}
                                    </Button>
                                </Form.Item>
                            </Form>

                        </Modal>

                        <div style={{ display: "flex", margin: "10 0", float: "right" }}>
                            {/* START NOW  */}
                            {startnowBtn(item)}
                            {/* ON HOLD   */}
                            {onholdBtn(item)}
                            {/* Active */}
                            {activeBtn(item)}
                            {/* EXTENDED  */}
                            {/* {extendedBtn(item)} */}
                            {/* MAIN */}
                            {mainBtn(item)}
                            {/* SUB */}
                            {/* {subBtn(item)} */}
                            {/* ASSIGN */}
                            {/* {assignBtn(item)} */}
                            {/* APPROVE */}
                            {approveBtn(item)}
                            {/* REJECT */}
                            {/* {rejectBtn(item)} */}
                            <a style={{ color: "rgba(0, 0, 0, 0.85)", display: item.status != 1 ? "none" : item.createdby == userid ? "" : "none" }}>
                                {assignto_username} has completed this task <Button onClick={() => onUpdateStatus(item, 3, "Complete Task", 'main')}>Close</Button>
                            </a>
                            {/* COMPLETED */}
                            {completeBtn(item)}
                            {/* CANCEL */}
                            {cancelBtn(item)}
                        </div>

                        <br />
                        <Divider style={{ marginBottom: "5px" }}></Divider>
                        {/* MESSAGE BOX */}

                        {/* <div style={{width: "100%"}}>
             <Form form={textform}>
                 <Form.Item name="chatmsg">
                     <TextArea autoSize={{ minRows: 1, maxRows: 6 }} onChange={(e) => setChatmsg(e.target.value)} />
                 </Form.Item>
             </Form>
         </div> */}
                        {replyTo && (
                            <div id={`reply${item._id}`} ref={mentionsInputRef} style={{ marginBottom: '10px', padding: '5px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div style={{
                                    background: 'rgba(247, 247, 247, 0.8)', // Making the background more transparent
                                    padding: '5px',
                                    border: '1px solid rgba(204, 204, 204, 0.8)', // Softening the border with transparency
                                    borderRadius: '5px',
                                    flexGrow: 1
                                }}>

                                    {showAttachmentList(replyTo)}

                                    <p style={{ margin: 0, opacity: 0.9 }}>{FULLuserLists.find(x => x._id === replyTo.from)?.userid || "Unknown User"}:</p>
                                    <span style={{ opacity: 0.9 }}>{replyTo.message}</span>
                                </div>
                                <Button
                                    type="text"
                                    onClick={clearReply}
                                    style={{
                                        marginLeft: '10px',
                                        color: "rgba(255, 0, 0, 0.8)", // Making the button color slightly transparent
                                        border: 'none',
                                        padding: '0',
                                        minWidth: 'auto'
                                    }}>
                                    X
                                </Button>
                            </div>

                        )}

                        {editBy && (
                            <div style={{ marginBottom: '10px', padding: '5px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div style={{
                                    background: 'rgba(247, 247, 247, 0.8)', // Making the background more transparent
                                    padding: '5px',
                                    border: '1px solid rgba(204, 204, 204, 0.8)', // Softening the border with transparency
                                    borderRadius: '5px',
                                    flexGrow: 1
                                }}>
                                    <p style={{ margin: 0, opacity: 0.9 }}>Edit Message :</p>
                                    <span style={{ opacity: 0.9 }}>{editBy.message}</span>
                                </div>
                                <Button
                                    type="text"
                                    onClick={clearEdit}
                                    style={{
                                        marginLeft: '10px',
                                        color: "rgba(255, 0, 0, 0.8)", // Making the button color slightly transparent
                                        border: 'none',
                                        padding: '0',
                                        minWidth: 'auto'
                                    }}>
                                    X
                                </Button>
                            </div>

                        )}

                        <div>
                            <Upload {...hiddenfileProps} ><Button hidden><PictureOutlined /></Button></Upload>
                        </div>
                        {audioURL ?
                            <>
                                <div className="audio-controls-container">
                                    <audio src={audioURL} controls />
                                    <Button onClick={deleteRecording} style={{ marginLeft: '10px' }}>
                                        <DeleteOutlined style={{ fontSize: '16px', color: 'red' }} />
                                    </Button>
                                </div>
                                <br />

                            </>
                            :
                            recording ?
                                <>
                                    <div className="audio-controls-container1">
                                        <span className="pulsating-circle"></span> {/* Visual indicator */}
                                        <span> Recording in progress...</span>
                                        <br />
                                    </div>
                                </>
                                :
                                <>
                                    <div>
                                        <MentionsInput id={`input${item._id}`} value={chatmsg} onChange={(e) => changeMentionMsg(e.target.value)}
                                            a11ySuggestionsListLabel={"Suggested mentions"}
                                            style={defaultStyle}
                                            onClick={(e) => {
                                                if (chatmsg.length === 0) {
                                                    scrollToAndFocusChecklist(`input${item._id}`);
                                                }
                                            }}
                                        >
                                            <Mention
                                                markup="@[__id__]"
                                                trigger="@"
                                                data={filteredMentionvalue}
                                                renderSuggestion={(
                                                    suggestion,
                                                    search,
                                                    highlightedDisplay,
                                                    index,
                                                    focused
                                                ) => (
                                                    <div className={`user ${focused ? 'focused' : ''}`}>
                                                        {highlightedDisplay}
                                                    </div>
                                                )}
                                                style={defaultMentionStyle}
                                            />
                                        </MentionsInput>
                                    </div>
                                </>
                        }

                        <div style={{ float: "left", display: "flex" }}>
                            {
                                item.createdby == userid ?
                                    <>

                                    </>
                                    :
                                    <>
                                    </>

                            }
                        </div>
                        <div style={{ float: "right", display: "flex" }}>


                            {
                                audioURL ?
                                    <>

                                    </>
                                    :
                                    <>
                                        <Upload {...fileProps} ><Button><PictureOutlined /></Button></Upload>
                                    </>
                            }

                            {

                                <div>
                                    {!audioURL ?
                                        <>
                                            <Button
                                                onClick={recording ? stopRecording : startRecording}
                                                className={`record-btn ${recording ? 'blinking' : ''}`}
                                                disabled={chatmsg.length != 0 || filelist.length != 0}
                                                style={{
                                                    touchAction: 'none', // Prevents default touch behaviors like scrolling and zooming
                                                    userSelect: 'none', // Prevents text selection
                                                    MozUserSelect: 'none', // Firefox prefix for user-select
                                                    WebkitUserSelect: 'none', // Chrome and Safari prefix for user-select
                                                    msUserSelect: 'none', // IE and Edge prefix for user-select
                                                    WebkitTouchCallout: 'none', // iOS Safari - disable the default callout shown when you touch and hold a touch target
                                                    WebkitTapHighlightColor: 'transparent' // Remove tap highlight in mobile Safari
                                                }}
                                            >
                                                <AudioOutlined />
                                            </Button>
                                        </>


                                        :

                                        null
                                    }
                                </div>



                            }
                            {
                                chatmsg.length != 0 || filelist.length != 0 || audioURL ?
                                    <>
                                        <Button disabled={btndisable} onClick={() => onSendMessage(item, "", "manual msg")}>
                                            {btndisable ? <Spin /> : <SendOutlined />}
                                        </Button>
                                    </>
                                    :
                                    <>
                                        <Button disabled={true} onClick={() => onSendMessage(item, "", "manual msg")}>
                                            {btndisable ? <Spin /> : <SendOutlined />}
                                        </Button>
                                    </>
                            }
                            {/* <Button  disabled={btndisable} onClick={() => onSendMessage(item, "", "manual msg")}>
             {btndisable ? <Spin /> : <SendOutlined />}
         </Button> */}


                        </div>
                        {/* {
         userid == "60eba6f748c6fe1a99ce6994" || userid == "61d25883cddb0fb407663477" || userid == "60ebde816d150ba31d16a879" || userid == "60ebf31ce0741b107ce0d886" ?

             <>
                 <div>
                     {!audioURL && (
                         isMobile ? (
                             <Button
                                 onMouseDown={handleMouseDown}
                                 onMouseUp={handleMouseUp}
                                 onTouchStart={handleTouchStart}
                                 onTouchEnd={handleTouchEnd}
                                 className="record-btn"
                                 style={{
                                     touchAction: 'none', // Prevents default touch behaviors like scrolling and zooming
                                     userSelect: 'none', // Prevents text selection
                                     MozUserSelect: 'none', // Firefox prefix for user-select
                                     WebkitUserSelect: 'none', // Chrome and Safari prefix for user-select
                                     msUserSelect: 'none', // IE and Edge prefix for user-select
                                     WebkitTouchCallout: 'none', // iOS Safari - disable the default callout shown when you touch and hold a touch target
                                     WebkitTapHighlightColor: 'transparent' // Remove tap highlight in mobile Safari
                                 }}
                             >
                                 {recording ? <StopOutlined /> : <AudioOutlined />}
                             </Button>
                         ) : (
                             <Button onClick={recording ? stopRecording : startRecording} className="record-btn">
                                 {recording ? <StopOutlined /> : <AudioOutlined />}
                             </Button>
                         )
                     )}
                     {audioURL && (
                         <>
                             <audio src={audioURL} controls />
                             <Button onClick={deleteRecording}>
                                 <DeleteOutlined style={{ fontSize: '16px', color: 'red' }} />
                             </Button>
                         </>
                     )}
                 </div>
             </>
             :
             <>
             </>
     } */}

                        <br />

                        {/* MESSAGES */}
                        {onChatForm()}
                    </Panel>
                </Collapse>
            </>

        );

    }

    const onTaskLoadmore = () => {

        if (taskName != "") {
            onTaskNameDatasource({ conditions: "all", taskname: taskName, index: newIndex, searchUser: searchUser })

        }
        else {
            onRefresh({ taskname: taskName, conditions: conditions, searchUser: searchUser, index: newIndex });

        }

    }

    //==== CHAT ====    
    const onGetChatData = (data, isloading) => {

        if (isloading) {
            //=== IF LIST LENGTH IS SAME WITH DATA LENGTH =====
            if (chatlist.length == data.length) {
                setLoading(true);
            }

            //===== IF PRESS LOAD MORE =======
            let array = chatlist;
            let array1 = data.slice(chatlist.length, chatlist.length + count);
            setChatList(array.concat(array1));

        }
        else {
            //==== IF NOT PRESS LOAD MORE ======
            if (data.length < count) {
                setLoading(true)
            }
            else {
                setLoading(false);
            }

            setChatList(data.slice(0, count));
        }
    }

    const onChatLoadMore = () => {
        onGetChatData(chatdata, true);
    }

    //====== DATEPICKER CONTROL ====
    const range = (start, end) => {
        const result = [];
        for (let i = start; i < end; i++) {
            result.push(i);
        }
        return result;
    }

    const disabledDate = (current) => {
        // Can not select days before today and today
        return current < moment().startOf('day');
    }

    const disabledDateTime = () => {

        return {
            disabledSeconds: () => range(0, 60),
            disabledHours: () => [1, 2, 3, 4, 5, 6, 7, 8, 19, 20, 21, 22, 23]
        };

    }

    const disabledDateTimeUser = () => {

        return {
            disabledSeconds: () => range(0, 60),
            disabledHours: () => disablehour
        };

    }

    const onPlansdateChange = (val, result) => {


        if (val != null) {
            val = val.set({ "minute": 0, "seconds": 0 });

            setplansdate(val)
            setlistdata(result)

            let msg = `Updated Plan date at ${moment().format("DD/M ddd h:mm a")}`

            setChatmsg(msg)

        }

    }
    const onPlanedateChange = (val, result) => {


        if (val != null) {
            val = val.set({ "minute": 0, "seconds": 0 });

            setplanedate(val)
            setlistdata(result)

            let msg = `Updated Plan date at ${moment().format("DD/M ddd h:mm a")}`

            setChatmsg(msg)

        }

    }

    const workmanhourscalcu = () => {

        var plansdate1 = plansdate
        var dateObj = new Date(plansdate1);
        var plansdate1 = moment(dateObj);
        var workmanhous1 = workmanhours
        var planedate1 = ""
        var currentstarthour = parseInt(plansdate1.format("HH"))

        // console.log("plansdate1",currentstarthour)
        // console.log("plansdate2",worketime)
        if (workmantype == "Days") {
            planedate1 = moment(plansdate1, "YYYY-MM-DD HH:00").add(workmanhous1, "days")
            console.log("Add Days")

        }
        else if (workmantype == "Hours") {
            if (workmanhours > (worketime - currentstarthour)) {
                var adddays1 = parseInt(workmanhours - (worketime - currentstarthour))
                var adddays = parseInt(adddays1 / (workduration))
                adddays += 1

                var addhours = parseInt((workmanhours - (worketime - currentstarthour)) % workduration)



                console.log("adddays", adddays)
                console.log("addhours", addhours)

                planedate1 = moment(plansdate1, "YYYY-MM-DD HH:00").add(adddays, "days")

                planedate1 = moment(planedate1).set('hour', workstime);
                planedate1 = moment(planedate1, "YYYY-MM-DD HH:00").add(addhours, "hours")
                console.log("planedate1", moment(planedate1.format("YYYY-MM-DD HH:00")))
                setplanedate(moment(planedate1.format("YYYY-MM-DD HH:00")))

            }
            else {
                planedate1 = moment(plansdate1, "YYYY-MM-DD HH:00").add(workmanhous1, "hours")
                console.log("planedate1", moment(planedate1.format("YYYY-MM-DD HH:00")))
                setplanedate(moment(planedate1.format("YYYY-MM-DD HH:00")))
            }

        }


        return (
            <div>
                <p>{` Estimate End Work : ${planedate}`}</p>
            </div>
        )
    }

    const onChangeWorkType = e => {
        //console.log('radio checked', e.target.value);
        setworkmantype(e.target.value);
    };



    const [visible, setVisible] = React.useState(false);
    //const [confirmLoading, setConfirmLoading] = React.useState(false);
    //const [modalText1, setModalText1] = React.useState('Content of the modal');

    const showModal1 = () => {
        setVisible(true);
    };

    const handleOk1 = () => {
        //  setModalText1('The modal will be closed after two seconds');

        // let msg = `Updated Plan date at ${moment().format("DD/M ddd h:mm a")} ,
        // Start : ${moment.unix(plansdate).format("DD/M ddd h:mm a") ?? ""}, 
        // Hours : Start : ${workmanhours ?? ""}`

        if (plansdate != "" && plansdate != undefined && plansdate != null) {
            if (planedate != "" && planedate != undefined && planedate != null) {
                onUpdate(listdata);
                setplansdate("")
                setworkmanhours("")
                setCurrentstatus("")
                setVisible(false);
            }
            else {
                message.error("End Date Must Select");
            }
        }
        else {
            message.error("Start Date Must Select");
        }


    };

    const handleCancel1 = () => {
        console.log('Clicked cancel button');
        setplansdate("")
        setworkmanhours("")
        setCurrentstatus("")
        setVisible(false);

    };



    const onRefreshDatepicker = (data) => {
        var monthdateFormat = "YYYY/MM/DD HH:mm"
        var tempdeadline = ""
        var tempstartdate = ""

        if (data.deadline) {
            tempdeadline = dayjs(moment.unix(data.deadline).format(monthdateFormat), monthdateFormat)
        }
        if (data.startdate) {
            tempstartdate = dayjs(moment.unix(data.startdate).format(monthdateFormat), monthdateFormat)
        }
        if (status == 0)
        //((data.deadline == "")  &&
        //((data.plansdate !="") || (data.plansdate != "undefined")) || (data.deadline != "" && data.createdby == userid))) 
        {
            return (
                <Form form={form}>
                    <Form.Item name="startdate"
                        style={{ width: "100%" }}>
                        <div style={{ marginTop: "5px", width: "100%" }}>
                            <Row>
                                {/* <Col >Deadline</Col> */}
                                <Col style={{ width: "100%" }}>

                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <Stack>
                                            <DateTimePicker
                                                label="Start Date"

                                                value={dayjsstartdate ? dayjsstartdate : tempstartdate}
                                                onChange={(val) => { dayjsstartdatechange(val) }}
                                                onAccept={(val1) => { onStartDateChange(val1, data) }}
                                                onClose={(val2) => { setdayjsstartdate("") }}
                                                minDate={dayjs()}
                                                maxDate={tempdeadline ? tempdeadline : dayjsdate}
                                                inputFormat="YYYY/MM/DD hh:mm a"
                                                renderInput={(params) => <TextField {...params} />}
                                            >

                                            </DateTimePicker>
                                        </Stack>
                                    </LocalizationProvider>

                                    {/* <DatePicker 
                                style={{width:"100%"}}
                                    onChange={(val) => { onDeadlineChange(val ,data)}}
                                    format="YYYY-MM-DD HH:mm"
                                    showTime={{ format: 'HH:mm' }} 
                                    placeholder={GetTranslation(userlang, "Deadline")} 
                                    disabledTime={disabledDateTime}
                                    disabledDate={disabledDate}
                                    defaultValue={data.deadline == "" ? null : moment.unix(data.deadline)}
                                      minuteStep={30}
                                /> */}
                                </Col>
                                {/* <Col offset={3}>
                                    {
                                        extenddisable ?
                                            <ExclamationCircleOutlined style={{ color: 'red' }} />
                                            : <></>
                                    } </Col> */}
                                {/* <Col>{ `${GetTranslation(userlang, "Plan Date ")} : `}</Col>
                            <Col>{data.plansdate == "" ? GetTranslation(userlang, "Not yet plan")  : `${moment.unix(data.plansdate).format("DD/M ddd h a")} ,`?? ""}</Col> */}
                            </Row>
                            <Row>
                                {/* <Col offset={10}/>
                            <Col>{ `${GetTranslation(userlang, "End Date ")} : `}</Col>
                            <Col>{data.planedate == "" ? GetTranslation(userlang, "")  : moment.unix(data.planedate).format("DD/M ddd h a") ?? ""}</Col> */}
                            </Row>
                        </div>
                    </Form.Item>
                    <Form.Item name="deadline"
                        style={{ width: "100%" }}>
                        <div style={{ marginTop: "5px", width: "100%" }}>
                            <Row>
                                {/* <Col >Deadline</Col> */}
                                <Col style={{ width: "100%" }}>

                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <Stack>
                                            <DateTimePicker
                                                label="Deadline"

                                                value={dayjsdate ? dayjsdate : tempdeadline}
                                                onChange={(val) => { dayjsdatechange(val) }}
                                                onAccept={(val1) => { onDeadlineChange(val1, data) }}
                                                onClose={(val2) => { setdayjsdate("") }}
                                                minDate={tempstartdate ? tempstartdate : dayjs()}
                                                inputFormat="YYYY/MM/DD hh:mm a"
                                                renderInput={(params) => <TextField {...params} />}
                                            >

                                            </DateTimePicker>
                                        </Stack>
                                    </LocalizationProvider>

                                    {/* <DatePicker 
                                style={{width:"100%"}}
                                    onChange={(val) => { onDeadlineChange(val ,data)}}
                                    format="YYYY-MM-DD HH:mm"
                                    showTime={{ format: 'HH:mm' }} 
                                    placeholder={GetTranslation(userlang, "Deadline")} 
                                    disabledTime={disabledDateTime}
                                    disabledDate={disabledDate}
                                    defaultValue={data.deadline == "" ? null : moment.unix(data.deadline)}
                                      minuteStep={30}
                                /> */}
                                </Col>
                                {/* <Col offset={3}>
                                    {
                                        extenddisable ?
                                            <ExclamationCircleOutlined style={{ color: 'red' }} />
                                            : <></>
                                    } </Col> */}
                                {/* <Col>{ `${GetTranslation(userlang, "Plan Date ")} : `}</Col>
                            <Col>{data.plansdate == "" ? GetTranslation(userlang, "Not yet plan")  : `${moment.unix(data.plansdate).format("DD/M ddd h a")} ,`?? ""}</Col> */}
                            </Row>
                            <Row>
                                {/* <Col offset={10}/>
                            <Col>{ `${GetTranslation(userlang, "End Date ")} : `}</Col>
                            <Col>{data.planedate == "" ? GetTranslation(userlang, "")  : moment.unix(data.planedate).format("DD/M ddd h a") ?? ""}</Col> */}
                            </Row>
                        </div>
                    </Form.Item>
                </Form>
            )
        }
        //console.log("tempdeadline >>>>>",tempdeadline)
        // if (status == 0 && data.createdby == userid && (data.extenddeadline != "" && data.extenddeadline != undefined))
        // //((data.deadline == "")  &&
        // //((data.plansdate !="") || (data.plansdate != "undefined")) || (data.deadline != "" && data.createdby == userid))) 
        // {
        //     return (
        //         <Form form={form}>
        //             <Form.Item name="deadline"
        //                 style={{ width: "100%" }}>
        //                 <div style={{ marginTop: "5px", width: "100%" }}>
        //                     <Row>
        //                         {/* <Col >Deadline</Col> */}
        //                         <Col style={{ width: "100%" }} >


        //                             <LocalizationProvider dateAdapter={AdapterDayjs}>
        //                                 <Stack>
        //                                     <DateTimePicker
        //                                         label="Deadline"

        //                                         value={dayjsdate ? dayjsdate : tempdeadline}
        //                                         onChange={(val) => { dayjsdatechange(val) }}
        //                                         onAccept={(val1) => { onDeadlineChange(val1, data) }}
        //                                         onClose={(val2) => { setdayjsdate("") }}
        //                                         minDate={dayjs()}
        //                                         inputFormat="YYYY/MM/DD hh:mm a"
        //                                         renderInput={(params) => <TextField {...params} />}
        //                                     >

        //                                     </DateTimePicker>
        //                                 </Stack>
        //                             </LocalizationProvider>

        //                             {/* <DatePicker 
        //                              style={{width:"100%"}}
        //                                 onChange={(val) => { onDeadlineChange(val ,data)}}
        //                                 format="YYYY-MM-DD HH:mm"
        //                                 showTime={{ format: 'HH:mm' }} 
        //                                 placeholder={GetTranslation(userlang, "Deadline")} 
        //                                 disabledTime={disabledDateTime}
        //                                 disabledDate={disabledDate}
        //                                 defaultValue={data.extenddeadline == "" ? null : moment.unix(data.extenddeadline)}
        //                                 minuteStep={30}
        //                             /> */}
        //                             <a> </a>
        //                             {
        //                                 extenddisable ?
        //                                     <ExclamationCircleOutlined style={{ color: 'red' }} />
        //                                     : <></>
        //                             }
        //                         </Col>
        //                         <Col offset={3}>
        //                         </Col>
        //                         {/* <Col>{ `${GetTranslation(userlang, "Plan Date ")} : `}</Col>
        //                         <Col>{data.plansdate == "" ? GetTranslation(userlang, "Not yet plan")  : `${moment.unix(data.plansdate).format("DD/M ddd h a")} ,`?? ""}</Col> */}
        //                     </Row>
        //                     <Row>
        //                         {/* <Col offset={10}/>
        //                         <Col>{ `${GetTranslation(userlang, "End Date ")} : `}</Col>
        //                         <Col>{data.planedate == "" ? GetTranslation(userlang, "")  : moment.unix(data.planedate).format("DD/M ddd h a") ?? ""}</Col> */}
        //                     </Row>
        //                 </div>
        //             </Form.Item>
        //         </Form>
        //     )
        // }
        // else if (status == 0 && data.createdby == userid)
        // //((data.deadline == "")  &&
        // //((data.plansdate !="") || (data.plansdate != "undefined")) || (data.deadline != "" && data.createdby == userid))) 
        // {
        //     return (
        //         <Form form={form}>
        //             <Form.Item name="deadline"
        //                 style={{ width: "100%" }}>
        //                 <div style={{ marginTop: "5px", width: "100%" }}>
        //                     <Row>
        //                         {/* <Col >Deadline</Col> */}
        //                         <Col style={{ width: "100%" }}>

        //                             <LocalizationProvider dateAdapter={AdapterDayjs}>
        //                                 <Stack>
        //                                     <DateTimePicker
        //                                         label="Deadline"

        //                                         value={dayjsdate ? dayjsdate : tempdeadline}
        //                                         onChange={(val) => { dayjsdatechange(val) }}
        //                                         onAccept={(val1) => { onDeadlineChange(val1, data) }}
        //                                         onClose={(val2) => { setdayjsdate("") }}
        //                                         minDate={dayjs()}
        //                                         inputFormat="YYYY/MM/DD hh:mm a"
        //                                         renderInput={(params) => <TextField {...params} />}
        //                                     >

        //                                     </DateTimePicker>
        //                                 </Stack>
        //                             </LocalizationProvider>

        //                             {/* <DatePicker 
        //                         style={{width:"100%"}}
        //                             onChange={(val) => { onDeadlineChange(val ,data)}}
        //                             format="YYYY-MM-DD HH:mm"
        //                             showTime={{ format: 'HH:mm' }} 
        //                             placeholder={GetTranslation(userlang, "Deadline")} 
        //                             disabledTime={disabledDateTime}
        //                             disabledDate={disabledDate}
        //                             defaultValue={data.deadline == "" ? null : moment.unix(data.deadline)}
        //                               minuteStep={30}
        //                         /> */}
        //                         </Col>
        //                         <Col offset={3}>
        //                             {
        //                                 extenddisable ?
        //                                     <ExclamationCircleOutlined style={{ color: 'red' }} />
        //                                     : <></>
        //                             } </Col>
        //                         {/* <Col>{ `${GetTranslation(userlang, "Plan Date ")} : `}</Col>
        //                     <Col>{data.plansdate == "" ? GetTranslation(userlang, "Not yet plan")  : `${moment.unix(data.plansdate).format("DD/M ddd h a")} ,`?? ""}</Col> */}
        //                     </Row>
        //                     <Row>
        //                         {/* <Col offset={10}/>
        //                     <Col>{ `${GetTranslation(userlang, "End Date ")} : `}</Col>
        //                     <Col>{data.planedate == "" ? GetTranslation(userlang, "")  : moment.unix(data.planedate).format("DD/M ddd h a") ?? ""}</Col> */}
        //                     </Row>
        //                 </div>
        //             </Form.Item>
        //         </Form>
        //     )
        // }
        // else if (status == 0 &&
        //     (data.plansdate == undefined || data.plansdate == "") &&
        //     data.assignto == userid &&
        //     (data.extenddeadline == "" || data.extenddeadline == undefined)) {
        //     return (

        //         <Form form={form}>
        //             <div style={{ marginTop: "5px", width: "100%" }}>
        //                 <Row>
        //                     <Col style={{ width: "100%" }}>{ }
        //                         {/* {data.deadline == "" ? `${GetTranslation(userlang, "Deadline")} :`GetTranslation(userlang, "no deadline")  : moment.unix(data.deadline).format("DD/M ddd h:mm a") ?? ""}</Col> */}
        //                         {data.deadline == "" ? "" : `${GetTranslation(userlang, "Deadline")} :` + moment.unix(data.deadline).format("DD/M ddd h:mm a") ?? ""}</Col>

        //                     <Col offset={3}>

        //                         {/* TEST PLAN START TIME END TIME */}
        //                         {/* <Button  onClick={showModal1}>
        //                             Planning Date
        //                         </Button> */}
        //                         <Modal
        //                             title="Planning Date"
        //                             visible={visible}
        //                             onOk={handleOk1}
        //                             onCancel={handleCancel1}
        //                         >
        //                             <p>
        //                                 <Form.Item name="plansdate">
        //                                     Start Date :
        //                                     <DatePicker
        //                                         onChange={(val) => { onPlansdateChange(val, data) }}
        //                                         format="YYYY-MM-DD HH"
        //                                         showTime={{ format: 'HH' }}
        //                                         placeholder={GetTranslation(userlang, "Plan Start Date")}

        //                                         disabledTime={disabledDateTimeUser}
        //                                         disabledDate={disabledDate}
        //                                     //disabledTime={disabledDateTime1}

        //                                     />
        //                                 </Form.Item>
        //                             </p>
        //                             <p>
        //                                 <Form.Item name="planedate">
        //                                     End Date :
        //                                     <DatePicker
        //                                         onChange={(val) => { onPlanedateChange(val, data) }}
        //                                         format="YYYY-MM-DD HH"
        //                                         showTime={{ format: 'HH' }}
        //                                         placeholder={GetTranslation(userlang, "Plan End Date")}

        //                                         disabledTime={disabledDateTimeUser}
        //                                         disabledDate={disabledDate}
        //                                     //disabledTime={disabledDateTime1}

        //                                     />
        //                                 </Form.Item>
        //                             </p>

        //                         </Modal>
        //                     </Col>
        //                 </Row>
        //             </div>
        //         </Form>
        //     )
        // }
        // else if (status == 0 &&
        //     ((data.plansdate == undefined || data.plansdate == "") && data.assignto == userid)) {
        //     return (

        //         <Form form={form}>
        //             <div style={{ marginTop: "5px", width: "100%" }}>
        //                 <Row>
        //                     <Col style={{ width: "100%" }}>{ }
        //                         {/* {data.deadline == "" ? `${GetTranslation(userlang, "Deadline")} :`GetTranslation(userlang, "no deadline")  : moment.unix(data.deadline).format("DD/M ddd h:mm a") ?? ""}</Col> */}
        //                         {data.deadline == "" ? "" : `${GetTranslation(userlang, "Deadline")} :` + moment.unix(data.deadline).format("DD/M ddd h:mm a") ?? ""}</Col>

        //                     <Col offset={3}>

        //                         {/* TEST PLAN START TIME END TIME */}
        //                         {/* <Button  onClick={showModal1}>
        //                                 Planning Date
        //                             </Button> */}
        //                         <Modal
        //                             title="Planning Date"
        //                             visible={visible}
        //                             onOk={handleOk1}
        //                             onCancel={handleCancel1}
        //                         >
        //                             <p>
        //                                 <Form.Item name="plansdate">
        //                                     Start Date :
        //                                     <DatePicker
        //                                         onChange={(val) => { onPlansdateChange(val, data) }}
        //                                         format="YYYY-MM-DD HH"
        //                                         showTime={{ format: 'HH' }}
        //                                         placeholder={GetTranslation(userlang, "Plan Start Date")}

        //                                         disabledTime={disabledDateTimeUser}
        //                                         disabledDate={disabledDate}
        //                                     //disabledTime={disabledDateTime1}

        //                                     />
        //                                 </Form.Item>
        //                             </p>
        //                             <p>
        //                                 <Form.Item name="planedate">
        //                                     End Date :
        //                                     <DatePicker
        //                                         onChange={(val) => { onPlanedateChange(val, data) }}
        //                                         format="YYYY-MM-DD HH"
        //                                         showTime={{ format: 'HH' }}
        //                                         placeholder={GetTranslation(userlang, "Plan End Date")}

        //                                         disabledTime={disabledDateTimeUser}
        //                                         disabledDate={disabledDate}
        //                                     //disabledTime={disabledDateTime1}

        //                                     />
        //                                 </Form.Item>
        //                             </p>

        //                         </Modal>
        //                     </Col>
        //                 </Row>
        //             </div>
        //         </Form>
        //     )
        // }
        // else {
        //     return (
        //         <Form form={form}>
        //             <div style={{ marginTop: "5px" }}>
        //                 <Row>
        //                     {/* <Col style={{width:"100%"}}>{ `${GetTranslation(userlang, "Deadline")} :`}</Col> */}
        //                     {/* <Col >{data.deadline == "" ? GetTranslation(userlang, "no deadline")  : moment.unix(data.deadline).format("DD/M ddd h:mm a") ?? ""}</Col>
        //             <Col offset={3}>{ `${GetTranslation(userlang, "Plan Date ")} : `}</Col>
        //             <Col>{data.plansdate == "" ? GetTranslation(userlang, "Not yet plan")  : `${moment.unix(data.plansdate).format("DD/M ddd h a")} ,`?? ""}</Col> */}
        //                 </Row>
        //                 {/* <Row>
        //             <Col />
        //             <Col offset={7}>{ `${GetTranslation(userlang, "End Date ")} : `}</Col>
        //             <Col>{data.planedate == "" ? GetTranslation(userlang, "")  : moment.unix(data.planedate).format("DD/M ddd h a") ?? ""}</Col>
        //         </Row> */}
        //             </div>
        //         </Form>
        //     )
        // }


    }

    const handleChange = (valueMeta, actionMeta) => {

        form.setFieldsValue({ "tagname": { value: "addsds" } })

    }

    //======= FORM  ========
    const onCreateForm = () => {
        var department = userdepartment
        var formdisplay = "none"
        // if(department == "FINANCE / ADMIN" || department == "" || userid == "stevent")
        // {
        //     formdisplay =""
        // }
        var tasksuserid = localStorage.getItem("taskuserid")

        if (isEdit == 1) {
            let data = taskdata;
            form.setFieldsValue({
                "taskpriority": data.taskpriority,
                "taskname": data.taskname,
                "description": data.description,
                "deadline": data.deadline == "" ? "" : moment.unix(data.deadline),
                "mainthread": data._id,
                "tasktype": data.tasktype,
                "keyuser": data.keyuser,
                "tagname": data.tagname == "" || data.tagname == undefined ? "" : [{ value: data.tagname.toString().trim(), label: data.tagname.toString().trim() }],
                "tagdate": data.tagdate == "" || data.tagdate == undefined ? "" : moment.unix(data.tagdate)
            });

            return (
                <div>
                    <Form form={form}>
                        <Row>
                            <Col span={18}>
                                {GetTranslation(userlang, "Created Task")}
                            </Col>
                        </Row>
                        {/* MAIN THREAD ID */}
                        <Form.Item name="mainthread" hidden={true}>
                            <Text>{data._id}</Text>
                        </Form.Item>

                        {/* ===== DEADLINES ===== */}
                        <Input.Group compact>
                            <Form.Item
                                style={{ width: "100%" }}
                                name="deadline"
                            >
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <Stack>
                                        <DateTimePicker
                                            label={GetTranslation(userlang, "Deadline")}
                                            value={dayjsdate ? dayjsdate : null}
                                            onChange={dayjsdatechange}
                                            minDate={dayjs()}
                                            inputFormat="YYYY/MM/DD hh:mm a"
                                            renderInput={(params) => <TextField {...params} />}
                                        >

                                        </DateTimePicker>
                                    </Stack>
                                </LocalizationProvider>
                                {/* <DatePicker 
                               style={{width: '100%'}}
                                format="YYYY-MM-DD HH:mm"
                                showTime={{ format: 'HH:mm' }} 
                                placeholder={GetTranslation(userlang, "Deadline")}
                                disabledTime={disabledDateTime}
                                disabledDate={disabledDate}
                                minuteStep={30}
                            /> */}
                            </Form.Item>
                            {/* ===== ASSIGN TO ===== */}
                            {/* <Form.Item
                                style={{ width: "100%" }}
                                name="assignto"
                                rules={[
                                    {
                                        required: true,
                                        message: GetTranslation(userlang, "User assigned is required")
                                    }]
                                }
                            >
                                <Select placeholder={GetTranslation(userlang, "Assign To")} showSearch>

                                    {

                                        userLists.map(function (data) {
                                            return (
                                                <Option value={data.userid}>{`${data.userid} (${data.markingcode})`}</Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Form.Item> */}
                            {/* <Form.Item
                            name="keyuser"
                            style={{ width: "37%"}}
                            
                        >
                            <Select placeholder={GetTranslation(userlang, "Key User")} showSearch mode="multiple" allowClear>
                                {
                                    userLists.map(function(data){
                                        return (
                                            <Option value={data.userid}>{data.userid}</Option>
                                        )
                                    })
                                }
                            </Select>
                        </Form.Item> */}

                        </Input.Group>

                        {/* DESCRIPTION */}
                        <Form.Item
                            name="description"
                            rules={[
                                {
                                    required: true,
                                    message: GetTranslation(userlang, "Description is required")
                                }]
                            }>
                            <TextArea autoSize={{ minRows: 4, maxRows: 6 }} size="large" placeholder={GetTranslation(userlang, "Description (User Requirement)")} />
                        </Form.Item>
                        {/* TEST ===== TASK TYPE ===== */}
                        <Input.Group compact>
                            {/* <Form.Item
                                name="taskpriority"
                                style={{ width: "15%"}}
                            >
                            <Select placeholder="Select type" defaultValue={"P0"}>
                                    <Option value="P0">P0</Option>
                                    <Option value="P1">P1</Option>
                                    <Option value="P2">P2</Option>
                                    <Option value="P3">P3</Option>
                                 
                            </Select>
                            </Form.Item> */}

                            {/* <Form.Item
                                name="tasktype"
                                style={{ width: "90%"}}
                            >
                            <Select placeholder="Select type" defaultValue={"Others"}>
                                    <Option value="Others">Others</Option>
                                    {TaskTypeListing()}
                            </Select>
                            </Form.Item> */}
                            <Form.Item
                                name="tagdate"
                                style={{ width: "15%", display: formdisplay }}
                            >
                                <DatePicker disabled style={{ width: "100%" }} placeholder='Select Year Month' picker="month" />
                            </Form.Item>

                            <Form.Item
                                name="tagname"
                                style={{ width: "75%", display: formdisplay }}>
                                <CreatableSelect
                                    isClearable
                                    // placeholder={form.getFieldValue('tagname')}
                                    // onChange={handleChange}
                                    options={tagnamelist}
                                    isDisabled
                                >

                                </CreatableSelect>
                            </Form.Item>


                            {/* <br></br> */}

                            {/* TASK NAME */}
                            {/* <Form.Item
                        style={{ width: "100%"}}
                            name="taskname"
                            rules={[
                                {
                                    required: true,
                                    message: GetTranslation(userlang, "Task Name is required")
                                }]
                            }>
                            <Input size="large" placeholder={GetTranslation(userlang, "Task Name")} />
                        </Form.Item> */}
                        </Input.Group>
                        {/* ==== ATTACHMENTS ======  */}
                        {/* <Form.Item
                            name="attachment"
                            rules={[
                                {
                                    required: false,
                                    message: "Attachment is required"
                                }
                            ]}
                        >
                            <Upload {...taskAttProps} ><Button><PictureOutlined />{GetTranslation(userlang, "Upload")}</Button></Upload>
                        </Form.Item> */}
                        <Form.Item>
                            <div style={{ display: "flex", float: "right" }}>
                                <div style={{ paddingRight: "5px" }}>
                                    <Spin spinning={taskloading}>
                                        <Button onClick={onCreate}>{GetTranslation(userlang, "Confirm")}</Button>
                                    </Spin>
                                </div>
                            </div>
                        </Form.Item>
                    </Form>
                </div>
            )
        }
        else if (isEdit == 2) {
            let data = taskdata;
            form.setFieldsValue({
                "taskid": data._id,
                "taskpriority": data.taskpriority,
                "taskname": data.taskname,
                "description": data.description,
                "deadline": data.deadline == "" ? "" : moment.unix(data.deadline),
                "mainthread": data.mainthread,
                "tasktype": data.tasktype,
                "keyuser": data.keyuser,
                "tagname": data.tagname == "" || data.tagname == undefined ? "" : [{ value: data.tagname.toString().trim(), label: data.tagname.toString().trim() }],
                "tagdate": data.tagdate == "" || data.tagdate == undefined ? "" : moment.unix(data.tagdate),
                "assignto": FULLuserLists.filter(x => x._id == data.assignto)[0].userid
            });

            return (
                <div>
                    <Form form={form}>
                        <Row>
                            <Col span={18}>
                                {GetTranslation(userlang, "Edit Task")}
                            </Col>
                        </Row>
                        {/* MAIN THREAD ID */}
                        <Form.Item name="mainthread" hidden={true}>
                            <Text>{data.mainthread}</Text>
                        </Form.Item>
                        <Form.Item name="taskid" hidden={true}>
                            <Text>{data._id}</Text>
                        </Form.Item>


                        {/* ===== DEADLINES ===== */}
                        <Input.Group compact>
                            {/* <Form.Item
                                style={{ width: "100%" }}
                                name="deadline"
                            >
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <Stack>
                                        <DateTimePicker
                                            label={GetTranslation(userlang, "Deadline")}
                                            value={dayjsdate ? dayjsdate : null}
                                            onChange={dayjsdatechange}
                                            minDate={dayjs()}
                                            inputFormat="YYYY/MM/DD hh:mm a"
                                            renderInput={(params) => <TextField {...params} />}
                                        >

                                        </DateTimePicker>
                                    </Stack>
                                </LocalizationProvider>
                            
                            </Form.Item> */}
                            {/* ===== ASSIGN TO ===== */}
                            {/* <Form.Item
                                style={{ width: "100%" }}
                                name="assignto"
                                rules={[
                                    {
                                        required: true,
                                        message: GetTranslation(userlang, "User assigned is required")
                                    }]
                                }
                            >
                                <Select placeholder={GetTranslation(userlang, "Assign To")} showSearch>

                                    {

                                        userLists.map(function (data) {
                                            return (
                                                <Option value={data.userid}>{`${data.userid} (${data.markingcode})`}</Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Form.Item> */}
                            {/* <Form.Item
                            name="keyuser"
                            style={{ width: "37%"}}
                            
                        >
                            <Select placeholder={GetTranslation(userlang, "Key User")} showSearch mode="multiple" allowClear>
                                {
                                    userLists.map(function(data){
                                        return (
                                            <Option value={data.userid}>{data.userid}</Option>
                                        )
                                    })
                                }
                            </Select>
                        </Form.Item> */}

                        </Input.Group>

                        {/* DESCRIPTION */}
                        <Form.Item
                            name="description"
                            rules={[
                                {
                                    required: true,
                                    message: GetTranslation(userlang, "Description is required")
                                }]
                            }>
                            <TextArea autoSize={{ minRows: 4, maxRows: 6 }} size="large" placeholder={GetTranslation(userlang, "Description (User Requirement)")} />
                        </Form.Item>
                        {/* TEST ===== TASK TYPE ===== */}
                        <Input.Group compact>
                            {/* <Form.Item
                                name="taskpriority"
                                style={{ width: "15%"}}
                            >
                            <Select placeholder="Select type" defaultValue={"P0"}>
                                    <Option value="P0">P0</Option>
                                    <Option value="P1">P1</Option>
                                    <Option value="P2">P2</Option>
                                    <Option value="P3">P3</Option>
                                 
                            </Select>
                            </Form.Item> */}

                            {/* <Form.Item
                                name="tasktype"
                                style={{ width: "90%"}}
                            >
                            <Select placeholder="Select type" defaultValue={"Others"}>
                                    <Option value="Others">Others</Option>
                                    {TaskTypeListing()}
                            </Select>
                            </Form.Item> */}
                            <Form.Item
                                name="tagdate"
                                style={{ width: "15%", display: formdisplay }}
                            >
                                <DatePicker disabled style={{ width: "100%" }} placeholder='Select Year Month' picker="month" />
                            </Form.Item>

                            <Form.Item
                                name="tagname"
                                style={{ width: "75%", display: formdisplay }}>
                                <CreatableSelect
                                    isClearable
                                    // placeholder={form.getFieldValue('tagname')}
                                    // onChange={handleChange}
                                    options={tagnamelist}
                                    isDisabled
                                >

                                </CreatableSelect>
                            </Form.Item>


                            {/* <br></br> */}

                            {/* TASK NAME */}
                            {/* <Form.Item
                        style={{ width: "100%"}}
                            name="taskname"
                            rules={[
                                {
                                    required: true,
                                    message: GetTranslation(userlang, "Task Name is required")
                                }]
                            }>
                            <Input size="large" placeholder={GetTranslation(userlang, "Task Name")} />
                        </Form.Item> */}
                        </Input.Group>
                        {/* ==== ATTACHMENTS ======  */}
                        {/* <Form.Item
                            name="attachment"
                            rules={[
                                {
                                    required: false,
                                    message: "Attachment is required"
                                }
                            ]}
                        >
                            <Upload {...taskAttProps} ><Button><PictureOutlined />{GetTranslation(userlang, "Upload")}</Button></Upload>
                        </Form.Item> */}
                        <Form.Item>
                            <div style={{ display: "flex", float: "right" }}>
                                <div style={{ paddingRight: "5px" }}>
                                    <Spin spinning={taskloading}>
                                        <Button onClick={onCreate}>{GetTranslation(userlang, "Update")}</Button>
                                    </Spin>
                                </div>
                            </div>
                        </Form.Item>
                    </Form>
                </div>
            )
        }
        else {
            return (
                <div>
                    <Form form={form}>
                        <Row>
                            <Col span={18}>
                                {GetTranslation(userlang, "Created Task")}
                            </Col>
                        </Row>
                        {/* ===== DEADLINES ===== */}
                        <Input.Group compact>

                            {/* <Form.Item
                                name="startdate"
                                style={{ width: "100%" }}
                            >
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <Stack>
                                        <DateTimePicker
                                            label={GetTranslation(userlang, "Start Date")}
                                            value={dayjsstartdate ? dayjsstartdate : null}
                                            onChange={dayjsstartdatechange}
                                            minDate={dayjs()}
                                            inputFormat="YYYY/MM/DD hh:mm a"
                                            renderInput={(params) => <TextField {...params} />}
                                        >

                                        </DateTimePicker>
                                    </Stack>
                                </LocalizationProvider>

                            </Form.Item>

                            <Form.Item
                                name="deadline"
                                style={{ width: "100%" }}
                            >
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <Stack>
                                        <DateTimePicker
                                            label={GetTranslation(userlang, "Deadline")}
                                            value={dayjsdate ? dayjsdate : null}
                                            onChange={dayjsdatechange}
                                            minDate={dayjsstartdate ? dayjsstartdate : dayjs()}
                                            inputFormat="YYYY/MM/DD hh:mm a"
                                            renderInput={(params) => <TextField {...params} />}
                                        >

                                        </DateTimePicker>
                                    </Stack>
                                </LocalizationProvider>

                            </Form.Item> */}
                            {/* ===== ASSIGN TO ===== */}
                            <span style={{ color: "red" }}>Default self task, if need tag users select from below (Permission : Public).</span>
                            <Form.Item
                                name="assignto"
                                style={{ width: "100%" }}
                            >

                                <Select mode='multiple' placeholder={GetTranslation(userlang, "Tag")} showSearch>
                                    {
                                        userLists.filter(data => data._id != userid).map(function (data) {
                                            return (
                                                <Option value={data.userid}>{`${data.userid} (${data.markingcode})`}</Option>
                                            );
                                        })
                                    }
                                </Select>
                            </Form.Item>

                            {/* <Form.Item
                            name="keyuser"
                            style={{ width: "37%"}}
                            
                        >
                            <Select placeholder={GetTranslation(userlang, "Key User")} showSearch mode="multiple" allowClear>
                                {
                                    userLists.map(function(data){
                                        return (
                                            <Option value={data.userid}>{data.userid}</Option>
                                        )
                                    })
                                }
                            </Select>
                        </Form.Item> */}

                        </Input.Group>

                        {/* DESCRIPTION */}
                        <Form.Item
                            name="description"
                            rules={[
                                {
                                    required: true,
                                    message: GetTranslation(userlang, "Description is required")
                                }]
                            }>
                            <TextArea autoSize={{ minRows: 4, maxRows: 6 }} size="large" placeholder={GetTranslation(userlang, "Description (User Requirement)")} />
                        </Form.Item>
                        {/* TEST ===== TASK TYPE ===== */}
                        <Input.Group compact>
                            {/* <Form.Item
                                name="taskpriority"
                                style={{ width: "20%"}}
                            >
                            <Select placeholder="Select Priority" defaultValue={"P0"}>
                                    <Option value="P0">P0</Option>
                                    <Option value="P1">P1</Option>
                                    <Option value="P2">P2</Option>
                                    <Option value="P3">P3</Option>
                                 
                            </Select>
                            </Form.Item> */}
                            {/* <Form.Item
                                name="tasktype"
                                style={{ width: "90%"}}
                            >
                            <Select placeholder="Select type" defaultValue={"Others"}>
                                    <Option value="Others">Others</Option>
                                  {TaskTypeListing()}
                            </Select>
                            </Form.Item> */}


                            <Form.Item

                                name="tagdate"
                                style={{ width: "20%", display: formdisplay }}
                            >
                                <DatePicker style={{ width: "100%" }} placeholder='Tag Year Month' picker="month" />
                            </Form.Item>
                            <Form.Item
                                name="tagname"
                                style={{ width: "70%", display: formdisplay }}>
                                <CreatableSelect
                                    options={tagnamelist}
                                    placeholder={"Tag Name"}>

                                </CreatableSelect>
                            </Form.Item>

                            {/* <br></br> */}
                            {/* TASK NAME */}
                            {/* <Form.Item 
                        style={{ width: "100%"}}
                            name="taskname"
                            rules={[
                                {
                                    required: true,
                                    message: GetTranslation(userlang, "Task Name is required")
                                }]
                            }>
                            <Input size="default size" placeholder={GetTranslation(userlang, "Task Name")}  />
                        </Form.Item> */}

                        </Input.Group>

                        {/* ==== ATTACHMENTS ====== 
                        <Form.Item
                            name="attachment"
                            rules={[
                                {
                                    required: false,
                                    message: "Attachment is required"
                                }
                            ]}
                        >
                            <Upload {...taskAttProps} ><Button><PictureOutlined /> {GetTranslation(userlang, "Upload")}</Button></Upload>
                        </Form.Item> */}
                        <Form.Item>
                            <div style={{ display: "flex", float: "right" }}>
                                <div style={{ paddingRight: "5px" }}>
                                    <Spin spinning={taskloading}>
                                        <Button onClick={onCreate}>{GetTranslation(userlang, "Create")}</Button>
                                    </Spin>

                                </div>
                            </div>
                        </Form.Item>
                    </Form>
                </div>
            )
        }


    }

    const onFilterForm = () => {
        return (
            <>

                <Row gutter={[8, 8]} style={{ padding: "3px" }}>
                    {/* <Col span={6}>
                        <Select value={conditions} style={{width: "100%"}} onChange={onConditionChange} onSearch={(val) => { onSearch("condition", val)}} showSearch disabled={conddisable}>
                            <Option value={"self"}>{GetTranslation(userlang, "Self")}</Option>
                            <Option value={"unread"}>{GetTranslation(userlang, "Unread")}</Option>
                            <Option value={"requested"}>{GetTranslation(userlang, "Requested")}</Option>
                            <Option value={"instructed"}>{GetTranslation(userlang, "Instructed")}</Option>
                            <Option value={"subordinary"}>{GetTranslation(userlang, "Subordinate")}</Option>
                            <Option value={"all"} >{GetTranslation(userlang, "All")}</Option>
                        </Select>
                    </Col>
                     */}

                    <Col span={24}>
                        <Select value={status} style={{ width: "100%" }} onChange={onStatusChange} onSearch={(val) => { onSearch("status", val) }} showSearch disabled={statdisable}>
                            <Option value={0}>{GetTranslation(userlang, "Active")}</Option>
                            <Option value={1}>{GetTranslation(userlang, "Self")}</Option>
                            <Option value={3}>{GetTranslation(userlang, "Completed")}</Option>
                            <Option value={9}>{GetTranslation(userlang, "Cancelled")}</Option>
                            {/* <Option value={1}>{GetTranslation(userlang, "Waiting for Approval")}</Option>
                            <Option value={1.1}>{GetTranslation(userlang, "Unverified")}</Option>
                            <Option value={3}>{GetTranslation(userlang, "Complete")}</Option>
                            <Option value={2}>{GetTranslation(userlang, "On Hold")}</Option> */}
                        </Select>
                    </Col>
                </Row>
                <Row gutter={[8, 8]} style={{ padding: "3px" }}>
                    <Col span={24}>
                        <Select style={{ width: "100%" }} placeholder={GetTranslation(userlang, "Search User")} onChange={onSearchUser} allowClear showSearch>
                            {
                                userLists.map(function (data) {
                                    return (
                                        <Option value={data.userid}>{`${data.userid} (${data.markingcode})`}</Option>
                                    )
                                })}
                        </Select>
                    </Col>
                </Row>

                {/* <Col span={6}>
                        <Select style={{width: "100%"}} disabled>
                            <Option value={"oldest"}>{ GetTranslation(userlang,"Oldest")}</Option>
                            <Option value={"newest"}>{ GetTranslation(userlang, "Newest")}</Option>
                        </Select>
                    </Col> */}

            </>
        )
    }


    // //====== ATTACHMENT ======
    // const showAttachmentList = (item) => {

    //     if (item.filepath != undefined && item.filepath != "") {
    //         const imgExtensions = ["png", "jpeg", "jpg"];

    //         const fileExtension = item.filepath.split('.').pop().toLowerCase();
    //         if (imgExtensions.includes(fileExtension)) {
    //             const imageUrls = item.filepath.split(',').map(filepath => ({
    //                 src: `https://qc9sk2.naxgo.online${filepath}`,
    //                 width: 1, // You can adjust the width
    //                 height: 1, // You can adjust the height
    //             }));

    //             // const openLightbox = (event, obj) => {
    //             //     setCurrentImage(obj.index);
    //             //     setLightboxIsOpen(true);
    //             // };

    //             return (
    //                 <>
    //                     {/* <div>
    //                         <Gallery photos={imageUrls} onClick={openLightbox} />
    //                         {lightboxIsOpen && (
    //                             <Lightbox
    //                                 images={imageUrls.map(photo => ({
    //                                     ...photo,
    //                                     src: photo.src.replace('https://qc9sk2.naxgo.online', ''),
    //                                 }))}
    //                                 currentIndex={currentImage}
    //                                 isOpen={lightboxIsOpen}
    //                                 onClose={() => setLightboxIsOpen(false)}
    //                             />
    //                         )}
    //                     </div> */}
    //                 </>

    //             );
    //         }
    //         else {
    //             // Render file link
    //             let filename = item.filepath.split('/');
    //             return (
    //                 <div>
    //                     <FileOutlined /> {filename[filename.length - 1]}
    //                     <Button style={{ marginLeft: "10px" }}>
    //                         <a href={`https://qc9sk2.naxgo.online${item.filepath}`} target="_blank">
    //                             {GetTranslation(userlang, "Open")}
    //                         </a>
    //                     </Button>
    //                 </div>
    //             );
    //         }
    //     }
    //     else {
    //         return (
    //             <>
    //             </>
    //         )
    //     }
    // }

    //======== TASK LIST ========
    //====== LOAD MORE BUTTON =======
    const taskloadMore = !taskinitLoading && !taskloading ? (
        <div
            style={{
                textAlign: 'center',
                marginTop: 12,
                height: 32,
                lineHeight: '32px',
            }}
        >
            <Button onClick={onTaskLoadmore}>{GetTranslation(userlang, "Load More")}</Button>
        </div>
    ) : null;

    //======== CHAT LIST ========
    //====== LOAD MORE BUTTON =======
    const loadMore = !initLoading && !loading ? (
        <div
            style={{
                textAlign: 'center',
                marginTop: 12,
                height: 32,
                lineHeight: '32px',
            }}
        >
            <Button onClick={onChatLoadMore}>{GetTranslation(userlang, "Load More")}</Button>
        </div>
    ) : null;


    const renderItem = (item) => {

        console.log("renderitem")
        var result22 = reminderdatasource.filter(x => x.taskid == item.taskid && x.chatid == item._id);

        var result33 = newdatasource.filter(x => x._id == item.taskid)[0];
        var iconcolor = "grey"

        var phoneNumber = ""; // This should be the full phone number in international format


        var useridfrom

        var tempuseridfrom
        // if (item.from != userid) {

        tempuseridfrom = FULLuserLists.filter(x => x._id == item.from);


        if (tempuseridfrom.length == 0) {
            useridfrom = item.from
        }
        else {
            useridfrom = tempuseridfrom[0].userid
            phoneNumber = tempuseridfrom[0].contactno
        }

        // console.log("useridfrom[0] >>",tempuseridfrom)

        // console.log("useridfrom[0].contactno >>",tempuseridfrom[0].contactno)
        // console.log("phoneNumber >>",phoneNumber)
        var whatsappLink = `https://wa.me/${phoneNumber}`;

        // }
        // else {
        //     useridfrom = username
        // }

        let rotate = 0
        let pinmsgcolor = "red"

        if (result33 != undefined) {
            if (result33.pinmsg != undefined) {
                if (item.message == result33.pinmsg) {
                    rotate = 315
                    pinmsgcolor = "grey"
                }
            }
        }



        if (result22.length > 0) {
            if (result22[0].rtype == "repeat") {
                iconcolor = "green"
            }
            else if (result22[0].rtype == "once") {
                if (result22[0].rdate > moment().unix()) {
                    iconcolor = "blue"
                }
                else {
                    iconcolor = "red"
                }
            }

        }
        else {
            iconcolor = "grey"
        }



        const showModal4 = (val, result) => {


            setonceperiodview("hidden")
            setrepeatperiodview("hidden")

            var tempresult = datasource["all"]

            tempresult = tempresult.filter(function (tempresult) {
                return tempresult._id == result.taskid;
            });



            setremindertaskid(result.taskid)
            setreminderchatid(result._id)

            var result11 = reminderdatasource.filter(x => x.taskid == result.taskid && x.chatid == result._id);

            if (result11[0]) {
                setreminderdeletebutton(true)
                setremindertaskname(result11[0].taskname)
                setremindermessage(result11[0].message)
                setrepeatperiod(result11[0].rperiod)
                setreminderdate(result11[0].rdate)
                setremindertime(result11[0].rtime)
                setreminderweek(result11[0].rweek)
                setremindermonth(result11[0].rmonth)
                setremindertype(result11[0].rtype)
                setremindertime1(dayjs(result11[0].rtime, "HH:mm"))


                var monthdateFormat = "MM/DD HH:mm"

                setreminderdate1(dayjs(moment.unix(result11[0].rdate).format(monthdateFormat), monthdateFormat))
                setreminderobjectid(result11[0]._id)

                if (result11[0].rtype == "once") {
                    setonceperiodview("visible")
                    setremindertype("once")

                    setrepeatperiodview("hidden")
                }

                else {
                    setonceperiodview("hidden")
                    setremindertype("repeat")
                    setrepeatperiodview("visible")
                }
            }

            else {
                setremindertaskname(tempresult[0].taskname)
                setremindermessage(result.message)
                setreminderdeletebutton(false)
            }



            setModalVisible4(true);


        };

        const handleCancel4 = (val, result) => {


            setModalVisible4(false);

            setonceperiodview("hidden")
            setrepeatperiodview("hidden")
            setremindertaskid("")
            setrepeatperiod("")
            setreminderdate("")
            setremindertime("")
            setreminderweek([])
            setremindermonth("")
            setremindertype("")

        };

        function typechange(e) {


            if (e == "once") {
                setonceperiodview("visible")
                setremindertype("once")

                setrepeatperiodview("hidden")
            }
            else {
                setonceperiodview("hidden")
                setremindertype("repeat")
                setrepeatperiodview("visible")
            }
            setreminderdate("")
            setremindertime("")
            setreminderweek([])
            setremindermonth("")
        }

        function periodchange(e) {

            if (e == "weekly") {
                setrepeatperiod("weekly")
            }
            else if (e == "monthly") {
                setrepeatperiod("monthly")
            }
            else if (e == "yearly") {
                setrepeatperiod("yearly")
            }
            setreminderdate("")
            setremindertime("")
            setreminderweek([])
            setremindermonth("")
        }

        function datechange(e) {
            if (e != null) {
                setremindertime(e.$H.toString().padStart(2, "0") + ":" + e.$m.toString().padStart(2, "0"))
                setreminderdate(moment(e.$d).format("YYYYMMDD"))
                setreminderdate1(e)
            }

        }

        function timechange(e) {

            //   setremindertime(moment(e).format("HH:mm"))
            if (e != null) {
                setremindertime(e.$H.toString().padStart(2, "0") + ":" + e.$m.toString().padStart(2, "0"))
                setremindertime1(e)
            }
        }

        const tasknamechange = (Values) => {


            setremindertaskname(Values)


        };
        const messagechange = (Values) => {


            setremindermessage(Values)


        };

        const ReminderForm = () => {

            if (onceperiodview == "visible") {

                return (
                    <div>


                        <Form >
                            <br />
                            <Form.Item>
                                {/* <DatePicker style={{width: "60%"}}
                                  format="YYYY-MM-DD"
                                  onChange={datechange}
                                  defaultValue={reminderdate ? moment.unix(reminderdate): null}>
    
                                 </DatePicker>
                                 
                             </Form.Item>
                             <Form.Item>
                             <TimePicker format={"HH:mm"} style={{width: "60%"}} defaultValue={remindertime ? moment(remindertime,"HH:mm"): null} minuteStep={10} 
                             inputReadOnly
                             onChange={timechange}>

                             </TimePicker> */}
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <Stack>
                                        <DateTimePicker
                                            label={GetTranslation(userlang, "Once Date Time")}
                                            value={reminderdate1 ? reminderdate1 : null}
                                            onChange={datechange}
                                            minDate={dayjs()}
                                            inputFormat="MM/DD hh:mm a"
                                            renderInput={(params) => <TextField {...params} />}
                                        >

                                        </DateTimePicker>
                                    </Stack>

                                </LocalizationProvider>
                            </Form.Item>
                        </Form>
                    </div>
                )

            }

            else if (repeatperiodview == "visible") {
                return (
                    <div>
                        <Form>
                            <br />
                            <Form.Item>
                                <Select style={{ width: "60%" }} placeholder={GetTranslation(userlang, "Select Period")} defaultValue={repeatperiod ? repeatperiod : null} onChange={periodchange}  >
                                    <Option value={"weekly"}>{GetTranslation(userlang, "Weekly")}</Option>
                                    <Option value={"monthly"}>{GetTranslation(userlang, "Monthly")}</Option>
                                    <Option value={"yearly"}>{GetTranslation(userlang, "Yearly")}</Option>
                                </Select>
                            </Form.Item>

                            {RepeatForm()}


                        </Form>
                    </div>
                )
            }
        }

        const weekdaychange = (checkedValues) => {

            setreminderweek(checkedValues)

        };

        const monthchange = (Values) => {

            setremindermonth(Values)

        };
        const RepeatForm = () => {

            const weekdayslist = [

                {
                    label: GetTranslation(userlang, 'Monday'),
                    value: 'Monday',
                },
                {
                    label: GetTranslation(userlang, 'Tuesday'),
                    value: 'Tuesday',
                },
                {
                    label: GetTranslation(userlang, 'Wednesday'),
                    value: 'Wednesday',
                },
                {
                    label: GetTranslation(userlang, 'Thursday'),
                    value: 'Thursday',
                },
                {
                    label: GetTranslation(userlang, 'Friday'),
                    value: 'Friday',
                },
                {
                    label: GetTranslation(userlang, 'Saturday'),
                    value: 'Saturday',
                },
                {
                    label: GetTranslation(userlang, 'Sunday'),
                    value: 'Sunday',
                },
            ]
            if (repeatperiod == "weekly") {
                return (
                    <Form.Item>
                        <Checkbox.Group className="ant-checkbox-group"
                            style={{ display: "inline-grid" }} options={weekdayslist} defaultValue={reminderweek ? reminderweek : null} onChange={weekdaychange} />

                        <div>
                            <br />
                        </div>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Stack>
                                <TimePicker
                                    label={GetTranslation(userlang, "Weekly Time")}
                                    value={remindertime1 ? remindertime1 : null}
                                    onChange={timechange}
                                    inputFormat="hh:mm a"
                                    renderInput={(params) => <TextField {...params} />}
                                >

                                </TimePicker>
                            </Stack>

                        </LocalizationProvider>
                    </Form.Item>
                )
            }
            else if (repeatperiod == "monthly") {
                return (
                    <Form.Item>
                        <Select style={{ width: "60%" }} placeholder={GetTranslation(userlang, "Select Date")} defaultValue={remindermonth ? remindermonth : null} onChange={monthchange} allowClear showSearch >
                            <Option value={"1"}>{"1"}</Option>
                            <Option value={"2"}>{"2"}</Option>
                            <Option value={"3"}>{"3"}</Option>
                            <Option value={"4"}>{"4"}</Option>
                            <Option value={"5"}>{"5"}</Option>
                            <Option value={"6"}>{"6"}</Option>
                            <Option value={"7"}>{"7"}</Option>
                            <Option value={"8"}>{"8"}</Option>
                            <Option value={"9"}>{"9"}</Option>
                            <Option value={"10"}>{"10"}</Option>
                            <Option value={"11"}>{"11"}</Option>
                            <Option value={"12"}>{"12"}</Option>
                            <Option value={"13"}>{"13"}</Option>
                            <Option value={"14"}>{"14"}</Option>
                            <Option value={"15"}>{"15"}</Option>
                            <Option value={"16"}>{"16"}</Option>
                            <Option value={"17"}>{"17"}</Option>
                            <Option value={"18"}>{"18"}</Option>
                            <Option value={"19"}>{"19"}</Option>
                            <Option value={"20"}>{"20"}</Option>
                            <Option value={"21"}>{"21"}</Option>
                            <Option value={"22"}>{"22"}</Option>
                            <Option value={"23"}>{"23"}</Option>
                            <Option value={"24"}>{"24"}</Option>
                            <Option value={"25"}>{"25"}</Option>
                            <Option value={"26"}>{"26"}</Option>
                            <Option value={"27"}>{"27"}</Option>
                            <Option value={"28"}>{"28"}</Option>
                        </Select>
                        <div>
                            <br />
                        </div>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Stack>
                                <TimePicker
                                    label={GetTranslation(userlang, "Monthly Time")}
                                    value={remindertime1 ? remindertime1 : null}
                                    onChange={timechange}
                                    inputFormat="hh:mm a"
                                    renderInput={(params) => <TextField {...params} />}
                                >

                                </TimePicker>
                            </Stack>

                        </LocalizationProvider>
                    </Form.Item>
                )
            }
            else if (repeatperiod == "yearly") {
                return (
                    <Form.Item>
                        {/* <DatePicker style={{width: "60%"}}
           defaultValue={reminderdate ? moment.unix(reminderdate): null}
          format="MM-DD"
          onChange={datechange}>

         </DatePicker> */}
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Stack>
                                <DateTimePicker
                                    label={GetTranslation(userlang, "Yearly Time")}
                                    value={reminderdate1 ? reminderdate1 : null}
                                    onChange={datechange}
                                    minDate={dayjs()}
                                    inputFormat="MM/DD hh:mm a"
                                    renderInput={(params) => <TextField {...params} />}
                                >

                                </DateTimePicker>
                            </Stack>

                        </LocalizationProvider>

                    </Form.Item>
                )
            }

        }

        const handleOk4 = (val) => {

            // console.log("task id >>>>", remindertaskid)
            // console.log("remindertype >>>",remindertype)
            // console.log("repeatperiod >>>",repeatperiod)
            //  console.log("reminderdate >>>",reminderdate)
            // console.log("remindertime >>>", remindertime)
            // console.log("reminderweek >>>",reminderweek)
            // console.log("remindermonth >>>",remindermonth)
            var tempreminderdate = reminderdate

            if (Number.isInteger(tempreminderdate) == true) {
                tempreminderdate = moment.unix(tempreminderdate).format("YYYYMMDD").toString()
                console.log("tempreminderdate >>>>", tempreminderdate)
            }
            var currentdate = tempreminderdate + " " + remindertime
            // console.log("reminder currentdate1 >>", currentdate)
            var currentdate1 = moment(currentdate, "YYYYMMDD, HH:mm").format()
            // console.log("reminder currentdate5 >>", moment(currentdate1).unix())
            //  console.log("remindertaskname >>>",remindertaskname)
            //  console.log("remindermessage >>>",remindermessage)
            var crontab = ""
            var splitvar = remindertime.split(":")
            // console.log("splitvar >>>",splitvar)
            if (remindertype == "once") {


                crontab = splitvar[1].toString() + " " +
                    splitvar[0].toString() + " " +
                    moment(tempreminderdate).format("DD").toString() + " " +
                    moment(tempreminderdate).format("MM").toString() + " " +
                    "*"
            }
            else {
                if (repeatperiod == "weekly") {
                    var weekstring = ''
                    if (reminderweek) {
                        for (var x = 0; x < reminderweek.length; x++) {
                            if (reminderweek[x] == "Monday") {
                                if (weekstring.length == 0) {
                                    weekstring = "0"
                                }
                                else {
                                    weekstring = weekstring + ",0"
                                }

                            }
                            else if (reminderweek[x] == "Tuesday") {
                                if (weekstring.length == 0) {
                                    weekstring = "1"
                                }
                                else {
                                    weekstring = weekstring + ",1"
                                }
                            }
                            else if (reminderweek[x] == "Wednesday") {
                                if (weekstring.length == 0) {
                                    weekstring = "2"
                                }
                                else {
                                    weekstring = weekstring + ",2"
                                }
                            }
                            else if (reminderweek[x] == "Thursday") {
                                if (weekstring.length == 0) {
                                    weekstring = "3"
                                }
                                else {
                                    weekstring = weekstring + ",3"
                                }
                            }
                            else if (reminderweek[x] == "Friday") {
                                if (weekstring.length == 0) {
                                    weekstring = "4"
                                }
                                else {
                                    weekstring = weekstring + ",4"
                                }
                            }
                            else if (reminderweek[x] == "Saturday") {
                                if (weekstring.length == 0) {
                                    weekstring = "5"
                                }
                                else {
                                    weekstring = weekstring + ",5"
                                }
                            }
                            else if (reminderweek[x] == "Sunday") {
                                if (weekstring.length == 0) {
                                    weekstring = "6"
                                }
                                else {
                                    weekstring = weekstring + ",6"
                                }
                            }
                        }
                    }

                    crontab = splitvar[1].toString() + " " +
                        splitvar[0].toString() + " " +
                        "*" + " " +
                        "*" + " " +
                        weekstring
                }
                if (repeatperiod == "monthly") {
                    crontab = splitvar[1].toString() + " " +
                        splitvar[0].toString() + " " +
                        remindermonth + " " +
                        "*" + " " +
                        "*"
                }
                if (repeatperiod == "yearly") {
                    crontab = splitvar[1].toString() + " " +
                        splitvar[0].toString() + " " +
                        moment(tempreminderdate).format("DD").toString() + " " +
                        moment(tempreminderdate).format("MM").toString() + " " +
                        "*"
                }
            }
            var data =
            {
                objid: reminderobjectid,
                taskid: remindertaskid,
                chatid: reminderchatid,
                taskname: remindertaskname,
                message: remindermessage,
                rgroup: "task",
                rtype: remindertype,
                rperiod: repeatperiod,
                rdate: moment(currentdate1).unix(),
                rtime: remindertime,
                rweek: reminderweek,
                rmonth: remindermonth,
                rstatus: 1,
                createdby: userid,
                crontab: crontab
            }

            if (remindertype) {
                if (remindertype == "once") {
                    if (reminderdate) {
                        if (remindertime) {
                            const result = updateReminder(data);
                        }
                        else {
                            message.error("Please Select Reminder Time");
                        }
                    }
                    else {
                        message.error("Please Select Reminder Date");
                    }
                }
                else {
                    if (repeatperiod == "weekly") {
                        if (reminderweek.length > 0) {
                            if (remindertime) {
                                const result = updateReminder(data);
                            }

                            else {
                                message.error("Please Select Reminder Time");
                            }
                        }
                        else {
                            message.error("Please Tick atleast 1 day");
                        }
                    }
                    else if (repeatperiod == "monthly") {
                        if (remindermonth) {
                            if (remindertime) {
                                const result = updateReminder(data);
                            }

                            else {
                                message.error("Please Select Reminder Time");
                            }
                        }
                        else {
                            message.error("Please Select Reminder Month");
                        }
                    }
                    else if (repeatperiod == "yearly") {
                        if (reminderdate) {
                            if (remindertime) {
                                const result = updateReminder(data);
                            }
                            else {
                                message.error("Please Select Reminder Time");
                            }
                        }
                        else {
                            message.error("Please Select Reminder Date");
                        }
                    }

                    else {
                        message.error("Please Select Reminder Repeat Period");
                    }
                }
            }
            else {
                message.error("Please Select Reminder Type");
            }

        }
        async function updateReminder(data) {
            const result = await onUpdateTasksReminder(data);
            if (result && result.status === "ok") {
                message.success(result.msg);

                setModalVisible4(false);

                setonceperiodview("hidden")
                setrepeatperiodview("hidden")
                setremindertaskid("")
                setreminderchatid("")
                setrepeatperiod("")
                setreminderdate("")
                setremindertime("")
                setreminderweek([])
                setremindermonth("")
                setremindertype("")
                setremindertaskname("")
                setremindermessage("")

                onGetReminderLists({ createdby: userid })
            }
            else {
                message.error(result.msg);

            }
        };

        const handleDelete4 = (val) => {



            var answer = window.confirm("Are you sure want to delete this Reminder?")


            if (answer == true) {
                const result = deleteReminder();
            }



        }

        async function deleteReminder(data) {
            const result = await onRemoveTasksReminder({ _id: reminderobjectid });
            if (result && result.status === "ok") {
                message.success(result.msg);

                setModalVisible4(false);

                setonceperiodview("hidden")
                setrepeatperiodview("hidden")
                setremindertaskid("")
                setreminderchatid("")
                setrepeatperiod("")
                setreminderdate("")
                setremindertime("")
                setreminderweek([])
                setremindermonth("")
                setremindertype("")
                setremindertaskname("")
                setremindermessage("")

                onGetReminderLists({ createdby: userid })
            }
            else {
                message.error(result.msg);

            }
        };






        const WhatsAppLinkConfirm = ({ useridfrom, phoneNumber }) => {
            const whatsappLink = phoneNumber ? `https://wa.me/${phoneNumber}` : '';

            // Use moment to get the current hour
            const currentHour = moment().hour();
            const currentDay = moment().day();

            // Define working hours
            const startOfWorkingHours = 9; // 9 AM
            const endOfWorkingHours = 19; // 7 PM

            // Check if today is Saturday (6) or Sunday (0)
            const isWeekend = currentDay === 0 || currentDay === 6;

            // Check if current time is within working hours and not a weekend
            const isWorkingHours = currentHour >= startOfWorkingHours && currentHour < endOfWorkingHours && !isWeekend;

            const title = isWorkingHours
                ? `Do you want to start a WhatsApp conversation with ${useridfrom}?`
                : `We are currently out of working hours. Do you want to start a WhatsApp conversation with ${useridfrom}?`;


            const handleLinkClick = (e) => {
                e.preventDefault();
                if (!phoneNumber) {
                    // If phoneNumber is missing, show an error message
                    message.error("User doesn't have a phone number recorded in the system.");
                    return;
                }
                // If phoneNumber exists, the Popconfirm will handle the confirmation
            };

            return (
                <Popconfirm
                    title={title}
                    onConfirm={() => window.open(whatsappLink, '_blank', 'noopener,noreferrer')}
                    okText="Yes"
                    cancelText="No"
                >
                    <a href="#" onClick={handleLinkClick}>{useridfrom}</a>
                </Popconfirm>
            );
        };





        return (
            <>
                <List.Item style={{ width: "100%", padding: "4px" }}>

                    <style>
                        {`
                                           
                                            .ant-comment-inner{
                                               padding : 0px
                                            }
                                            `}
                    </style>
                    <Comment
                        className={"ant-comment-inner", item.from == userid ? "itemRight" : "itemLeft"}
                        style={{ width: "100%", fontWeight: item.newmessage == true && item.from != userid ? "bold" : "" }}
                        author={item.from == userid ? useridfrom : <WhatsAppLinkConfirm useridfrom={useridfrom} phoneNumber={phoneNumber} />}
                        datetime={
                            <>
                                <Tooltip title={moment.unix(item.createdte).format("DD/M ddd h:mm a") ?? ""}>
                                    {moment.unix(item.createdte).fromNow()}&nbsp;&nbsp;

                                    <Modal
                                        destroyOnClose={true}
                                        title={GetTranslation(userlang, "Reminder")}
                                        visible={modalVisible4}
                                        onCancel={(val) => { handleCancel4(val, item) }}
                                        footer={reminderdeletebutton == false ? [

                                            <Button
                                                onClick={(val) => { handleCancel4(val, item) }}
                                            >
                                                Cancel
                                            </Button>,
                                            <Button
                                                type="primary"
                                                onClick={handleOk4}
                                            >
                                                OK
                                            </Button>]
                                            :
                                            [
                                                <Button
                                                    style={{ background: "red", color: "white" }}
                                                    onClick={handleDelete4}
                                                >
                                                    Delete
                                                </Button>,
                                                <Button
                                                    onClick={(val) => { handleCancel4(val, item) }}
                                                >
                                                    Cancel
                                                </Button>,
                                                <Button
                                                    type="primary"
                                                    onClick={handleOk4}
                                                >
                                                    OK
                                                </Button>]}
                                    >
                                        <div>
                                            <TextArea placeholder="Task Name" disabled defaultValue={remindertaskname} onChange={(e) => tasknamechange(e.target.value)} autoSize />
                                        </div>
                                        <br />
                                        <div>
                                            <TextArea placeholder="Message" defaultValue={remindermessage ? remindermessage : null} onChange={(e) => messagechange(e.target.value)} autoSize />

                                        </div>
                                        <br />
                                        <Select style={{ width: "60%" }} defaultValue={remindertype ? remindertype : null} placeholder={GetTranslation(userlang, "Select Type")} onChange={typechange}  >
                                            <Option value={"once"}>{GetTranslation(userlang, "Once")}</Option>
                                            <Option value={"repeat"}>{GetTranslation(userlang, "Repeat")}</Option>
                                        </Select>
                                        {ReminderForm()}
                                    </Modal>
                                </Tooltip>
                                {

                                    moment().diff(moment.unix(item.createdte), 'seconds') <= 300 && item.from == userid ?

                                        <>

                                            <Dropdown overlay={messageActionsMenuWithDelete(item)} trigger={['click']}>
                                                <a onClick={(e) => e.preventDefault()}>
                                                    <MoreOutlined style={{ fontSize: '16px', marginLeft: '10px' }} />
                                                </a>
                                            </Dropdown>
                                        </>
                                        :
                                        <>

                                            <Dropdown overlay={messageActionsMenuNoDelete(item)} trigger={['click']}>
                                                <a onClick={(e) => e.preventDefault()}>
                                                    <MoreOutlined style={{ fontSize: '16px', marginLeft: '10px' }} />
                                                </a>
                                            </Dropdown>
                                        </>
                                }
                            </>
                        }
                        content={
                            <div style={{ marginBottom: "2px" }}>
                                <div>

                                    {item.refrom && (
                                        <div style={{
                                            background: 'rgba(247, 247, 247, 0.5)', // Making the background more transparent
                                            padding: '5px',
                                            border: '1px solid rgba(204, 204, 204, 0.5)', // Softening the border with transparency
                                            borderRadius: '5px',
                                            flexGrow: 1
                                        }}>
                                            {showAttachmentListRE(item)}
                                            <p style={{ margin: 0, opacity: 0.9 }}>
                                                {FULLuserLists.find(x => x._id === item.refrom)?.userid || "Unknown user"}:
                                            </p>
                                            <p><StyledMessage message={item} msgtype={"reply"} /></p>

                                        </div>
                                    )}
                                    <style>
                                        {`
                                            @keyframes blink {
                                                0%, 100% {
                                                opacity: 1;
                                                }
                                                50% {
                                                opacity: 0;
                                                }
                                            }
                                            .blink-icon {
                                                animation: blink 1s linear infinite;
                                                color: lightgreen; /* Change color to signify unread/new message */
                                                font-size: 1.2em; /* Slightly larger to attract attention */
                                            }
                                            `}
                                    </style>
                                    {/* {
                                        item.newmessage == true && item.from != userid ?
                                            <NewReleasesIcon className="blink-icon" />
                                            :
                                            <></>
                                    } */}

                                    <div>
                                        {showAttachmentList(item)}
                                    </div>
                                    {/* <Text className="textparagraph">{item.message}</Text> */}
                                    {
                                        item.msgtype == "audio" ?
                                            <>
                                                <ReactAudioPlayer
                                                    src={`https://qc9sk2.naxgo.online${item.message}`}
                                                    // autoPlay
                                                    controls
                                                />
                                            </>
                                            :
                                            <>
                                                <StyledMessage message={item} msgtype={"message"} />
                                            </>
                                    }

                                </div>



                            </div>
                        }
                    >
                    </Comment>


                </List.Item>
            </>
        )


    }

    const onChatForm = () => {
        //====== MARKED WILL CHANGE TO LIST INSTEAD OF CARD =======
        if (chatdata.length > 0) {
            return (
                <>
                    <List {...chatProps}></List>
                </>
            )
        }
        else {
            return (<></>)
        }
    }

    //======= TASK BUTTON ======
    //====== MAIN =======
    const mainBtn = (data) => {
        let style = "none";
        if (data.mainthread != "" && data.createdby == userid) {
            style = "";
        }

        return (
            <div style={{ paddingLeft: "2px" }}>
                <Button onClick={() => { onClick("main", data) }} style={{ display: style }}>{GetTranslation(userlang, "Main")}</Button>
            </div>
        )

    }

    //====== SUB =======
    const subBtn = (data) => {
        let style = "none";

        if ((data.assignto == userid && data.ats == 1) || (data.createdby == userid && data.cbs == 1)) {
            style = ""; //To show
        }

        let bgcolor = "white"
        let txtcolor = "black"
        if (data.subtaskmsg != undefined) {
            if (data.subtaskmsg == 1) {
                bgcolor = "rgb(255, 51, 153)"
                txtcolor = "white"
            }

        }

        return (
            <div style={{ paddingLeft: "2px" }}>
                <Button onClick={() => { onClick("sub", data) }} style={{ display: style, backgroundColor: bgcolor, color: txtcolor }}>{GetTranslation(userlang, "Sub")}</Button>
            </div>
        )
    }

    //====== ASSIGN =======
    const assignBtn = (data) => {
        let style = "none";
        // 20210801 Anchor cold
        //console.log("assign data >>",data)
        //if(data.status == 0 && (data.createdby == userid || data.assignto == userid )){
        // if(status == 0 && data.mainthread == "" && (data.createdby == userid || data.assignto == userid )){
        if (data.status == 0 && data.createdby == userid && data.mainthread == "") {

            style = "";
        }

        if (data.status == 0 && data.assignto == userid) {

            style = "";
        }

        return (
            <div style={{ paddingLeft: "2px" }}>
                <Button onClick={() => { onClick("assign", data) }} style={{ display: style }}>{GetTranslation(userlang, "Assign")}</Button>
            </div>

        )

    }

    //====== APPROVE =======
    const approveBtn = (data) => {
        let style = "none";
        var displaytext = ""
        // if(data.status == 1)
        // {
        if (data.createdby == userid) {
            if (data.assignto != userid) {
                if (data.status == 0) {
                    style = ""
                }

            }

        }

        if (data.status == 1) {
            displaytext = "Approve"
        }
        else {
            displaytext = "Complete"
        }



        //  }

        return (
            <div style={{ paddingLeft: "2px" }}>
                <Button onClick={() => { onClick("approve", data) }} style={{ display: style }}>{GetTranslation(userlang, displaytext)}</Button>
            </div>
        )
    }

    //====== REJECT =======
    const rejectBtn = (data) => {
        let style = "none";
        if (data.status == 1) {
            if (data.createdby == userid) {
                if (data.assignto != userid) {
                    style = "";
                }

            }

        }

        return (
            <div style={{ paddingLeft: "2px" }}>
                <Button onClick={() => { onClick("reject", data) }} style={{ display: style }}>{GetTranslation(userlang, "Incomplete")}</Button>
            </div>
        )

    }

    //====== COMPLETE =======
    const completeBtn = (data) => {
        let style = "";
        if (((data.createdby == userid && data.assignto != userid) || data.status != 0 || data.reportto == userid)) {
            style = "none";
        }

        return (
            <div style={{ paddingLeft: "2px" }}>
                <Button onClick={() => { onClick("completed", data) }} style={{ display: style }}>{GetTranslation(userlang, "Complete")}</Button>
            </div>
        )
    }

    //======= CANCEL =======
    const cancelBtn = (data) => {
        let style = "none";

        //==== STATUS IS NOT CANCEL =====
        if (status == 0) {
            if ((data.assignto == userid && data.createdby == userid) || (data.createdby == userid)) {
                style = "";
            }
        }
        else {
            //==== IF STATUS IS NOT PROGRESS =====
            if (status == 1.1) {
                style = "";
            }
        }

        if (data.status == 3) {
            style = "none"
        }

        if (data.status == 1) {
            style = "none"
        }

        // if((status != 9 && status != 3) && (status == 0 && (data.createdby == userid && data.assignto == userid) || ((status != 1 && data.createdby == userid) || data.reportto == userid))){
        //     style   = "";
        // }

        return (
            <div style={{ paddingLeft: "2px" }}>
                <Button type="danger" onClick={() => { onClick("cancel", data) }} style={{ display: style }}>{GetTranslation(userlang, "Cancel")}</Button>
            </div>
        )
    }

    //====== Start Now Button =======
    const startnowBtn = (data) => {
        let style = "none";
        if ((data.assignto == userid && data.actsdate == "" && data.plansdate != "" && data.status == 0 && data.currentstatus == "Not Started")) {
            style = "";
        }

        return (
            <div style={{ paddingLeft: "2px" }}>
                <Button type="primary" onClick={() => { onClick("startnow", data) }} style={{ display: style }}>{GetTranslation(userlang, "Start Now")}</Button>
            </div>
        )
    }

    //====== On Hold Button =======
    const onholdBtn = (data) => {
        let style = "none";
        if (data.status == 0 && data.currentstatus != "On Hold" && (data.createdby == userid || data.reportto == userid)) {
            style = "";
        }


        return (
            <div style={{ paddingLeft: "2px" }}>
                <Button onClick={() => { onClick("onhold", data) }} style={{ display: style }}>{GetTranslation(userlang, "On Hold")}</Button>
            </div>
        )
    }
    //====== Active Button =======
    const activeBtn = (data) => {
        let style = "none";
        if (data.status == 2 && (data.createdby == userid || data.reportto == userid)) {
            style = "";
        }
        return (
            <div style={{ paddingLeft: "2px" }}>
                <Button onClick={() => { onClick("activate", data) }} style={{ display: style }}>{GetTranslation(userlang, "Reactivate")}</Button>
            </div>
        )
    }
    //====== Extended Button =======
    const extendedBtn = (data) => {
        let style = "none";
        if (data.status == 0 && data.deadline != "" && data.assignto == userid && data.createdby != userid && (data.currentstatus == "Not Planned" || data.currentstatus == "Not Started" || data.currentstatus == "In Progress")) {
            style = "";
        }


        return (
            <div style={{ paddingLeft: "2px" }}>
                <Button onClick={() => { onClick("extend", data) }} style={{ display: style }}>{GetTranslation(userlang, "Request Extend")}</Button>
            </div>
        )
    }

    //====== MODAL ========
    const onModal = () => {
        return (
            <Modal
                // title   ={modalTitle}
                visible={modalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
            >{ModalContent()}
            </Modal>
        )
    }

    const handleOk = () => {
        //===== UPDATE STATUS ======
        // console.log("chat1",chatmsg)
        if (currentstatus == "Request Extend") {
            if (extendmessage.length > 0) {
                onUpdate(listdata);
                setModalVisible(false);
                setlistdata("");
                setdeadline("");
                setNewStatus(-1);
                setCurrentstatus("");
            }

            else {
                message.error('Reason Must Key In !');
            }
        }

        else {
            if (deadline != "") {
                if (newStatus == 0 || newStatus == -1) {
                    var tempdeadline2 = moment(deadline).subtract(2, "hours")


                    if (listdata.assignto == userid) {
                        CreateDeadlineReminder(listdata._id, listdata.taskname, moment(tempdeadline2).unix(), userid, listdata.assignto)
                    }
                    else {
                        CreateDeadlineReminder(listdata._id, listdata.taskname, moment(tempdeadline2).unix(), userid, listdata.assignto)

                        CreateDeadlineReminder(listdata._id, listdata.taskname, moment(tempdeadline2).unix(), userid, listdata.createdby)
                    }


                }



            }

            onUpdate(listdata);

            setModalVisible(false);
            setlistdata("");
            setdeadline("");
            setNewStatus(-1);
            setCurrentstatus("");
        }

    }

    const handleCancel = () => {
        setModalVisible(false);
        setlistdata("");
        setdeadline("");
        setNewStatus(-1);
        setChatmsg("");
        setCurrentstatus("");
    }

    function onreasonchange(e) {
        setextendmessage(e.target.value)
        setChatmsg(`Request to Extend at ${moment().format("DD/M ddd h:mm a")} \n Reason : ${e.target.value}`)
    }

    const ModalContent = () => {
        let act = "";
        let placeholder = "";
        let hidden = true;
        let required = false;

        if (deadline != "") {
            // FOR DEADLINE
            act = `${GetTranslation(userlang, "Are you sure you want to update to this dead line?")}${"\n"}`;
            act += `${GetTranslation(userlang, "Ended Time is")} ${deadline.format("MM/D HH:mm")}? ${GetTranslation(userlang, "Once updated cannot be modified!")}`

        }

        else {
            //===== STATUS ======
            switch (newStatus) {
                case 9:
                    act = GetTranslation(userlang, "Are you sure you want to cancel?");
                    break;
                case 0:
                    if (currentstatus == "In Progress") {
                        act = GetTranslation(userlang, "Are you sure you want to start this task now?");
                    }
                    else if (currentstatus == "Request Extend") {
                        act = GetTranslation(userlang, "Are you sure you want to request extend this task?");
                        hidden = false
                        placeholder = GetTranslation(userlang, "Reason To Extend")
                        required = true
                    }
                    else if (currentstatus == "Not Planned") {
                        act = GetTranslation(userlang, "Are you sure you want to active this task?");
                    }
                    else {
                        act = GetTranslation(userlang, "Are you sure you want to incomplete this task?");
                    }
                    break;
                case 1:

                    act = GetTranslation(userlang, "Are you sure you want to complete this task?");


                    break;

                case 2:
                    act = GetTranslation(userlang, "Are you sure you want to on hold this task?");
                    break
                case 3:
                    act = GetTranslation(userlang, "Are you sure you want to approve this task?");
                    break;

            }
        }

        return (<div>{act}
            <Input placeholder={placeholder} hidden={hidden} onChange={onreasonchange} />

        </div>)
    }

    //===================== IMAGE PREVIEW (FILE) ================================
    const onFileChange = (info) => {
        console.log("upload info >>>", info)
        let newFileList = [...info.fileList];
        let index = 0
        if (newFileList && newFileList.length > 0 && newFileList.length >= filelist.length) {
            for (var i = 0; i < newFileList.length; i++) {
                let src = info.url;

                if (!src) {
                    return new Promise(resolve => {
                        const reader = new FileReader();
                        reader.readAsDataURL(info.file);
                        reader.onload = () => resolve(reader.result);
                    }).then(src => {
                        //let index   = newFileList.findIndex(x => x.originFileObj == info.file);
                        index = i
                        // console.log("index",index)
                        // console.log("i",i)
                        // console.log("newfilelistlength",newFileList.length)
                        newFileList[index].preview = src;
                        // console.log("newFileList",newFileList)
                        setFileList(newFileList);

                    })
                }
            }
        }
        else {
            setFileList(newFileList)
        }
        if (chatContentRef.current) {
            chatContentRef.current.scrollTop = chatContentRef.current.scrollHeight;
        }
    }





    //============================================================

    //==== PROPS ====
    const hiddenfileProps = {
        listType: "picture",
        fileList: filelist,
        className: "commentAttachment",
        accept: ".png,.jpeg,.jpg,.pdf,.xls,.xlsx,.doc,.docx,.txt,.csv,.odt,.ods,.mp4,.avi,.mkv,.wmv,.mov,.mp3",
        multiple: true,
        beforeUpload: (file) => {
            return false;
        },
        onChange: onFileChange,
        onPreview: handleIconPreview
    };


    //==== PROPS ====
    const fileProps = {
        fileList: filelist,
        className: "commentAttachment2",
        accept: ".png,.jpeg,.jpg,.pdf,.xls,.xlsx,.doc,.docx,.txt,.csv,.odt,.ods,.mp4,.avi,.mkv,.wmv,.mov,.mp3",
        multiple: true,
        beforeUpload: (file) => {
            return false;
        },
        onChange: onFileChange
    };


    const tasklistProps = {
        loading: taskinitLoading,
        // loadMore    : taskloadMore,
        itemLayout: "horizontal",
        dataSource: newdatasource,
        renderItem: taskrenderItem
    }


    const chatProps = {
        loading: initLoading,
        loadMore: loadMore,
        itemLayout: "horizontal",
        dataSource: chatlist,
        renderItem: renderItem
    }


    const listInnerRef = useRef();
    var height = window.innerHeight;
    var width = window.innerWidth;
    const onScroll = () => {

        if (listInnerRef.current) {

            const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;

            if (scrollTop == 0) {
                if (displaymode == 'self') {
                    if (selfloadmore == false) {
                        console.log("Top!!!")
                        onGetselfprevioudtaskdeadline()

                    }
                    else {
                        setLoadpreviousbutton(true)
                        console.log("history data all loaded !!!")
                    }

                }
                // setheaderVisible(true)
            }
            else {
                // setheaderVisible(false)
            }
            if (scrollTop + clientHeight >= scrollHeight - 1) {
                if (displaymode == 'task') {
                    if (!linktaskid) {
                        if (currentask == 'main') {
                            setcurrenttaskamount(newdatasource.length)

                            if (currenttaskamount != newdatasource.length) {
                                onTaskLoadmore()
                            }

                        }
                    }


                }
                else if (displaymode == 'self') {

                    // if (selfloadmore == false) {
                    //     onGetselftaskdeadline("loadmore")

                    // }

                }


            }
        }
    };

    // Custom button style
    const loadpreviousbuttonStyle = {
        width: '100%',
        backgroundColor: '#f0f2f5', // Light background color
        color: '#1890ff', // Text color that stands out
        border: 'none', // No border for a modern look
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)', // Soft shadow for depth
        marginBottom: '10px', // Space below the button
    };

    const toggleChecklistDetail = (date, index) => {
        if (expandedChecklistIndex.date === date && expandedChecklistIndex.index === index) {
            setExpandedChecklistIndex({ date: null, index: null }); // Collapse if already expanded
        } else {
            setExpandedChecklistIndex({ date, index });
        }
    };

    const toggleChecklistDetailEdit = (date, index) => {
        if (editChecklistIndex.date === date && editChecklistIndex.index === index) {
            setEditChecklistIndex({ date: null, index: null }); // Close edit mode if already editing
            setEditChecklistitem(null); // Clear the temporary cache when closing without saving
        } else {
            const taskToEdit = selfdatasource[date][index];
            setEditChecklistitem({ date, index, items: taskToEdit.items });
            setEditChecklistIndex({ date, index }); // Open edit mode
        }
    };

    const EditsaveChanges = () => {
        if (editChecklistitem) {
            const { date, index, items } = editChecklistitem;
            // Update the main data source
            const newTasks = { ...selfdatasource };

            const newRawTasks = { ...selfrawdatasource };

            const tasksArray = Object.values(newRawTasks);

            const updatedTasks = [...newTasks[date]];

            var taskinfo = updatedTasks[index]

            var taskchecklist = tasksArray.filter(x => x._id === taskinfo.taskinfo._id)[0].checklist

            var itemIndex = taskchecklist.findIndex(item => item.items === taskinfo.items);

            if (itemIndex !== -1) {
                // Toggle the status of the found item
                taskchecklist[itemIndex].items = items;



                return onUpdateTasks({
                    taskid: taskinfo.taskinfo._id,
                    checklist: taskchecklist
                }).then(data => {

                    if (data.status == "ok") {

                        message.success("Check List Updated !")

                        setEditChecklistIndex({ date: null, index: null });
                        setEditChecklistitem(null);

                        var msg = `Checklist updated at ${moment().format("DD/M ddd h:mm a")} \n
                        (changed from '${updatedTasks[index].items}' to '${items}')`; // Include both original and changed values

                        onSendMessage(taskinfo.taskinfo, msg)

                        updatedTasks[index].items = items;
                        newTasks[date] = updatedTasks;
                        setSelfdatasource(newTasks);
                    }
                    else {
                        message.error("Check List Fail To Update !")
                    }


                }).catch(error => {
                    console.error('Failed to update checklist status:', error);
                    setEditChecklistIndex({ date: null, index: null });
                    setEditChecklistitem(null);
                });

            }


            // updatedTasks[index].items = items;
            // newTasks[date] = updatedTasks;
            // setSelfdatasource(newTasks);

            // Reset edit state

        }
    };

    const EditcancelChanges = () => {
        // Reset to original data by clearing the edit cache
        setEditChecklistIndex({ date: null, index: null });
        setEditChecklistitem(null);
    };

    const toggleChecklistStatus = (date, index) => {
        // const newTasks = [...selfdatasource];
        // newTasks[index].status = !newTasks[index].status;  // Toggle the status
        // setSelfdatasource(newTasks);


        const newTasks = { ...selfdatasource };

        const newRawTasks = { ...selfrawdatasource };

        const tasksArray = Object.values(newRawTasks);

        const updatedTasks = [...newTasks[date]];

        var taskinfo = updatedTasks[index]

        var taskchecklist = tasksArray.filter(x => x._id === taskinfo.taskinfo._id)[0].checklist


        //var taskchecklist = updatedTasks[index].taskinfo.checklist


        var itemIndex = taskchecklist.findIndex(item => item.items === taskinfo.items);

        if (itemIndex !== -1) {
            // Toggle the status of the found item
            taskchecklist[itemIndex].status = !taskchecklist[itemIndex].status;



            return onUpdateTasks({
                taskid: taskinfo.taskinfo._id,
                checklist: taskchecklist
            }).then(data => {


                if (data.status == "ok") {
                    updatedTasks[index].status = !updatedTasks[index].status;
                    newTasks[date] = updatedTasks;
                    setSelfdatasource(newTasks);
                    message.success("Check List Updated !")

                    var msg = `Checklist updated at ${moment().format("DD/M ddd h:mm a")}\n
                    ${updatedTasks[index].items} Status changed to  ${updatedTasks[index].status === true ? "Done" : "Processing"}`


                    onSendMessage(taskinfo.taskinfo, msg)
                }
                else {
                    message.error("Check List Fail To Update !")
                }



            }).catch(error => {
                console.error('Failed to update checklist status:', error);
            });

        }





    };

    const updateChecklistItem = (index, newItem) => {

        // Update only the editCache
        setEditChecklistitem(prev => ({ ...prev, items: newItem }));

    };

    const LinktoTask = async (task) => {

        console.log("link task >>>", task);


        try {
            // Assuming onGetTaskByID is an async function that fetches task details by ID
            var result = await onGetTaskByID({ taskid: task.taskinfo._id });
            console.log("link task result >>>", result);

            let newds = { all: [] }
            newds.all.push(result.data)
            console.log("newds >>>", newds)
            //setNewDatasource(result.data)


            onRefreshNewDatasource(newds, conditions);

            setLinktaskid(task.taskinfo._id)
            setDisplaymode("task");
        } catch (error) {
            console.error("Failed to get task details:", error);
        }
    }

    const onChatInputForm = () => {



        const changeMentionMsg2 = (val) => {

            let temptaguserlist = []
            if (val.includes("@[")) {
                var tempval = val.substring(val.indexOf("@["), val.length)
                var splitvar = tempval.split("@")

                if (splitvar) {
                    splitvar.forEach(function (xdata) {
                        if (xdata.includes("[")) {
                            if (xdata.includes("]")) {
                                let tempdata = xdata
                                temptaguserlist.push(tempdata.substring(tempdata.indexOf("[") + 1, tempdata.indexOf("]")))
                            }
                        }
                    })
                }
            }

            console.log("val 333 >>>", val)

            // const setData = new Set(temptaguserlist);
            // const uniqueArray = Array.from(setData);
            // settaguserlist(uniqueArray)
            setChatmsg(val)
            //tempmsg = val

        };

        return (
            <>
                {
                    audioURL ?
                        <>
                            <div className="mention-input-container">
                                <audio src={audioURL} controls />

                            </div>


                        </>
                        :
                        recording ?
                            <>
                                <div className="mention-input-container">
                                    <span className="pulsating-circle"></span> {/* Visual indicator */}
                                    <span> Recording in progress...</span>

                                </div>
                            </>
                            :
                            <>
                                <div className="mention-input-container">
                                    <MentionsInput
                                        value={chatmsg}
                                        onChange={(e) => changeMentionMsg2(e.target.value)}

                                        //onChange={(e) => setChatmsg(e.target.value)}
                                        a11ySuggestionsListLabel={"Suggested mentions"}
                                        style={defaultStyle}
                                        className="mentions__input" // Add a class for styling if needed
                                        forceSuggestionsAboveCursor={true}

                                    >
                                        <Mention
                                            markup="@[__id__]"
                                            trigger="@"
                                            data={ChatRoomMentionUser}
                                            renderSuggestion={(
                                                suggestion,
                                                search,
                                                highlightedDisplay,
                                                index,
                                                focused
                                            ) => (
                                                <div className={`user ${focused ? 'focused' : ''}`}>
                                                    {highlightedDisplay}
                                                </div>
                                            )}
                                            style={defaultMentionStyle}
                                            className="mentions__suggestions" // Add a class for styling if needed

                                        />
                                    </MentionsInput>
                                </div>




                            </>
                }
                <div className="buttons-container">
                    {
                        chatmsg.length != 0 || filelist.length != 0 || audioURL ?
                            <>
                                {audioURL ? (
                                    <Button onClick={deleteRecording} className="upload-button">
                                        <DeleteOutlined />
                                    </Button>
                                ) : (
                                    <Upload {...fileProps}>
                                        <Button className="upload-button">
                                            <PictureOutlined />
                                        </Button>
                                    </Upload>
                                )}

                                <Button disabled={btndisable} type="primary" onClick={() => onSendMessage(ChatRoomItem, "", "manual msg")} className="send-button">
                                    {btndisable ? <Spin /> : <SendOutlined />}
                                </Button>
                            </>
                            :
                            <>
                                {!recording && (
                                    <Upload {...fileProps}>
                                        <Button className="upload-button">
                                            <PictureOutlined />
                                        </Button>
                                    </Upload>
                                )}

                                <Button
                                    onClick={recording ? stopRecording : startRecording}
                                    className={`record-btn ${recording ? 'blinking' : ''}`}

                                    style={{
                                        touchAction: 'none', // Prevents default touch behaviors like scrolling and zooming
                                        userSelect: 'none', // Prevents text selection
                                        MozUserSelect: 'none', // Firefox prefix for user-select
                                        WebkitUserSelect: 'none', // Chrome and Safari prefix for user-select
                                        msUserSelect: 'none', // IE and Edge prefix for user-select
                                        WebkitTouchCallout: 'none', // iOS Safari - disable the default callout shown when you touch and hold a touch target
                                        WebkitTapHighlightColor: 'transparent' // Remove tap highlight in mobile Safari
                                    }}
                                >
                                    <AudioOutlined />
                                </Button>

                            </>
                    }
                </div>
            </>
        )
    }



    const handleCollapseClick = (e) => {
        e.stopPropagation();
        setChatRoomHeader(false);
    };

    const handleTabChange = (key) => {
        // setActiveTab(prevState => !prevState);
       
        setActiveTab(key);
    };

    const ClearTagUser = () => {
        setUserPermissions([]);
        setSelectedUsers([]);
    };

    // Handle change in the AntD Select component
    const handleTagSelectUser = (selectedUserIds) => {
        // Update permissions for newly selected users
        const updatedPermissions = selectedUserIds.map(userid => {
            // If the user is already in userPermissions, maintain their current permission
            const existingUser = userPermissions.find(user => user.userid === userid);
            return existingUser || { userid, permission: 'private' }; // Default to private if not already in the list
        });

        setUserPermissions(updatedPermissions);
        setSelectedUsers(selectedUserIds)
    };

    


    return (

        <>
            {(() => {
                if (isMaintenance) {
                    return (<T_Error />)
                }
                else {
                    return (
                        <>
                            <Row justify="start">
                                <div style={{ width: "10%", display: "flex", alignItems: "center" }}>
                                    {
                                        displaymode == "task" ?
                                            <>
                                                <IconButton onClick={(val) => setDisplaymode("self")}>
                                                    <ScheduleTwoTone />
                                                </IconButton>
                                            </>
                                            :
                                            <>
                                                <IconButton onClick={() => { setDisplaymode("task"); setLinktaskid(null); }}>
                                                    <ScheduleFilled />
                                                </IconButton>
                                            </>
                                    }


                                </div>
                                <div style={{ width: "70%" }}>
                                    <Divider style={{ paddingLeft: "10%" }}>{GetTranslation(userlang, prop.title) ?? "."}</Divider>
                                </div>
                                <div style={{ width: "20%", display: "flex", alignItems: "center" }}>
                                    {headerVisible ?
                                        <>
                                            <IconButton onClick={(val) => onReload()}>
                                                <RefreshIcon></RefreshIcon>
                                            </IconButton>
                                            <IconButton onClick={(val) => setheaderVisible(false)}>
                                                <FilterAltIcon></FilterAltIcon>
                                            </IconButton>
                                        </>

                                        :
                                        <>
                                            <IconButton onClick={(val) => onReload()}>
                                                <RefreshIcon></RefreshIcon>
                                            </IconButton>
                                            <IconButton onClick={(val) => setheaderVisible(true)}>
                                                <FilterAltOffIcon></FilterAltOffIcon>
                                            </IconButton>
                                        </>

                                    }

                                </div>
                            </Row>
                            {/* HEADER */}
                            {/* BODY */}
                            <div style={{ padding: "3px" }}>
                                <Row gutter={[8, 8]} style={{ padding: "3px" }}>
                                    <Col xs={24} xl={24}>
                                        {(() => {
                                            return (
                                                <Collapse expandIconPosition={"right"} activeKey={collapse} onChange={onCollapse}>
                                                    <Panel header={GetTranslation(userlang, "Start a new topic")} key="1" >
                                                        {onCreateForm()}
                                                    </Panel>
                                                </Collapse>
                                            )
                                        })()}
                                    </Col>
                                </Row>
                                {/*  DATA GRID  */}
                                <Row gutter={[8, 8]} style={{ padding: "3px" }}>
                                    <Col span={24}>
                                        <Search placeholder={GetTranslation(userlang, "Search Chat")} onSearch={onTaskSearch} allowClear></Search>
                                    </Col>
                                </Row>
                                {headerVisible ?
                                    <>

                                        {onFilterForm()}
                                        {/* <ToggleButtonGroup
                                            value={taskformat}
                                            exclusive
                                            onChange={handleTaskFormat}
                                        >
                                            <ToggleButton value="task" aria-label="left aligned">
                                                <FormatAlignLeftIcon />
                                            </ToggleButton>
                                            <ToggleButton value="deadline" aria-label="centered">
                                                <FormatAlignCenterIcon />
                                            </ToggleButton>
                                        </ToggleButtonGroup> */}
                                        {/* <Row >
                                    <Col span={24}>
                                        <Button style={{width:"100%"}} onClick={onReload}>{ refreshdisable ? <Spin /> : <ReloadOutlined />}</Button>
                                    </Col>
                                </Row> */}
                                    </>
                                    :
                                    <>
                                    </>}

                                {/* {chatdata.map((message) => (
                                                                                        <ChatMessage
                                                                                            key={message._id}
                                                                                            message={message}
                                                                                            userid={userid}
                                                                                            messageActionsMenuWithDelete={messageActionsMenuWithDelete}
                                                                                            messageActionsMenuNoDelete={messageActionsMenuNoDelete}
                                                                                        />
                                                                                    ))} */}



                                {
                                    displaymode == "task" ?
                                        <>
                                            <div
                                                onScroll={onScroll}
                                                ref={listInnerRef}
                                                style={{ height: `${height * 0.9}px`, overflowY: "auto", overflowX: "hidden", width: "100%" }}>
                                                <Row gutter={[8, 8]}>
                                                    <Col xs={24}>
                                                        <Spin spinning={taskloading} size='large'>
                                                            {
                                                                ChatRoomItem ?
                                                                    <>
                                                                        <div className='container'>
                                                                            <div className={`chat-room ${transitionClass}`}>
                                                                                <div className={`chat-room-header ${ChatRoomHeader ? 'expanded' : ''} `} 
                                                                                onClick={ChatRoomHeaderExpand}>
                                                                                    <div className="header-left">
                                                                                        {
                                                                                            ChatRoomHeader ?
                                                                                                <>

                                                                                                </>
                                                                                                :
                                                                                                <>
                                                                                                    <Button onClick={(e) => { e.stopPropagation(); handleBackClick(); }}>
                                                                                                        <LeftCircleTwoTone style={{ fontSize: '24px' }} />
                                                                                                    </Button>
                                                                                                </>
                                                                                        }

                                                                                    </div>
                                                                                    <div className="header-middle">
                                                                                        <h1>{ChatRoomItem.taskname}</h1>
                                                                                        {ChatRoomItem.pinmsg && <p className="pinned-message">
                                                                                            <PushPinIcon style={{ fontSize: "15px", color: "black" }} />
                                                                                            {ChatRoomItem.pinmsg}</p>}
                                                                                    </div>


                                                                                </div>
                                                                                {ChatRoomHeader && (
                                                                                    <>
                                                                                        <div className="collapse-button-container">
                                                                                            <Tabs className="tabs-container" activeKey={activeTab} onChange={handleTabChange}>
                                                                                                {ChatRoomItem.taskname !== ChatRoomItem.description && (
                                                                                                    <TabPane tab="Description" key="1">
                                                                                                        <p className="task-name tab-content">{ChatRoomItem.description}</p>
                                                                                                    </TabPane>
                                                                                                )}

                                                                                                <TabPane tab="Description" key="1">
                                                                                                    <p className="task-name tab-content">{ChatRoomItem.description}</p>
                                                                                                </TabPane>

                                                                                                <TabPane tab="Checklist" key="2">
                                                                                                    <div className="tab-content">
                                                                                                        <Checklist checklist={ChatRoomItem.checklist} taskdata={ChatRoomItem} />
                                                                                                    </div>
                                                                                                </TabPane>
                                                                                                <TabPane tab="Users" key="3">
                                                                                                    <div className="tab-content">
                                                                                                        <Button style={{ display: Array.isArray(ChatRoomItem.taguser) == true ? ChatRoomItem.taguser.length > 0 ? "" : "none" : "none" }} onClick={(val) => { showModalTagUser(val, ChatRoomItem.taguser) }}>Show Users List</Button>
                                                                                                        {/* <UserAddOutlined style={{ fontSize: "23px", color: "blue",paddingLeft:"10px" }} onClick={(e) => openTagModal(ChatRoomItem)} ></UserAddOutlined> */}
                                                                                                        <div>
                                                                                                            <h3>Add New Users:</h3>
                                                                                                            <Select
                                                                                                                mode="multiple"
                                                                                                                style={{ width: '100%', zIndex: 10005 }}
                                                                                                                placeholder="Select users"
                                                                                                                onChange={handleTagSelectUser}
                                                                                                                value={selectedUsers}
                                                                                                                optionLabelProp="label"
                                                                                                                dropdownStyle={{ zIndex: 10006 }} // Ensure the dropdown itself has a high z-index
                                                                                                            >
                                                                                                                {userLists.filter(user =>
                                                                                                                    // Check if the user is not already tagged
                                                                                                                    !(ChatRoomItem?.taguser?.some(taggedUser => taggedUser.userid === user._id) ?? false) &&
                                                                                                                    // Check if the user is not the creator
                                                                                                                    ChatRoomItem?.createdby !== user._id &&
                                                                                                                    // Check if the user is not the assignee
                                                                                                                    ChatRoomItem?.assignto !== user._id
                                                                                                                ).map(user => (
                                                                                                                    <Option key={user.userid} value={user.userid} label={`${user.userid} (${user.markingcode})`}>
                                                                                                                        {user.userid} ({user.markingcode})
                                                                                                                    </Option>
                                                                                                                ))}
                                                                                                            </Select>
                                                                                                        </div>
                                                                                                        <div>

                                                                                                            {

                                                                                                                userPermissions.length > 0 ?
                                                                                                                    <>
                                                                                                                        <h3>Permissions:</h3>
                                                                                                                        {userPermissions.map(user => (
                                                                                                                            <div key={user.userid} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', padding: '5px', border: '1px solid #ccc', borderRadius: '5px', width: '100%', maxWidth: '500px' }}>
                                                                                                                                <span>{user.userid}</span>
                                                                                                                                <a onClick={() => togglePermission(user.userid)} style={{ cursor: 'pointer' }}>
                                                                                                                                    {user.permission}
                                                                                                                                </a>
                                                                                                                            </div>
                                                                                                                        ))}
                                                                                                                        <Button type='danger' onClick={ClearTagUser}>Cancel</Button>
                                                                                                                        <Button style={{ marginLeft: "10px" }} onClick={handleTagModalSave}>Save</Button>
                                                                                                                    </>
                                                                                                                    :
                                                                                                                    <></>
                                                                                                            }
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    {/* <p className="tab-content">Coming Soon</p> */}

                                                                                                    <Modal
                                                                                                        destroyOnClose={true}
                                                                                                        title="Tag User List"
                                                                                                        visible={modalVisibleTagUser}
                                                                                                        //onOk={(val) => { handleCloseModalTagUser(val)}}
                                                                                                        onCancel={(val) => { handleCloseModalTagUser(val) }}
                                                                                                        style={{ zIndex: 10000 }} // Ensure the modal itself has a high z-index
                                                                                                        maskStyle={{ zIndex: 9999 }} // Ensure the modal mask has a high z-index
                                                                                                        wrapClassName="ant-modal-wrap"

                                                                                                        footer={[
                                                                                                            <Button key="back" onClick={(val) => { handleCloseModalTagUser(val) }}>
                                                                                                                Close
                                                                                                            </Button>
                                                                                                        ]}
                                                                                                    >
                                                                                                        <List
                                                                                                            dataSource={Showtaguserlist}
                                                                                                            renderItem={(items) => (
                                                                                                                <List.Item
                                                                                                                    actions=
                                                                                                                    {
                                                                                                                        ChatRoomItem.createdby == userid ?


                                                                                                                            [
                                                                                                                                <Popconfirm
                                                                                                                                    title={`Are you sure want to remove ${items.displayuserid}?`}
                                                                                                                                    onConfirm={() => handleCancelTagUser(ChatRoomItem, items.userid)}
                                                                                                                                    // onCancel={() => console.log('User canceled delete')}
                                                                                                                                    okText="Yes"
                                                                                                                                    cancelText="No"
                                                                                                                                    overlayStyle={{ zIndex: 10001 }} // Ensure the Popconfirm itself has a high z-index

                                                                                                                                >
                                                                                                                                    <a
                                                                                                                                        style={{
                                                                                                                                            color: "red",
                                                                                                                                            fontSize: "16px",
                                                                                                                                            // display: `${item.createdby}` === userid ? "block" : items.userid === userid ? "block" : "none"
                                                                                                                                            display: "block"
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        <DeleteOutlined></DeleteOutlined>
                                                                                                                                    </a>
                                                                                                                                </Popconfirm>
                                                                                                                                ,
                                                                                                                                <>
                                                                                                                                    {
                                                                                                                                        items.permission === 'private' ?
                                                                                                                                            (
                                                                                                                                                <Popconfirm
                                                                                                                                                    title={`Confirm change ${items.displayuserid} to public? If yes, user able to view all history message !`}
                                                                                                                                                    onConfirm={() => handleTagUserPermission(ChatRoomItem, items)}
                                                                                                                                                    okText="Yes"
                                                                                                                                                    cancelText="No"
                                                                                                                                                    overlayStyle={{ zIndex: 10001 }} // Ensure the Popconfirm itself has a high z-index

                                                                                                                                                >
                                                                                                                                                    <a href="#">{items.permission}</a>
                                                                                                                                                </Popconfirm>
                                                                                                                                            )
                                                                                                                                            :
                                                                                                                                            (
                                                                                                                                                <Popconfirm
                                                                                                                                                    title={`Confirm change ${items.displayuserid} to private?`}
                                                                                                                                                    onConfirm={() => handleTagUserPermission(ChatRoomItem, items)}
                                                                                                                                                    okText="Yes"
                                                                                                                                                    cancelText="No"
                                                                                                                                                    overlayStyle={{ zIndex: 10001 }} // Ensure the Popconfirm itself has a high z-index

                                                                                                                                                >
                                                                                                                                                    <a href="#">{items.permission}</a>
                                                                                                                                                </Popconfirm>
                                                                                                                                            )
                                                                                                                                    }
                                                                                                                                </>

                                                                                                                                ,
                                                                                                                                <Popconfirm
                                                                                                                                    title="Are you sure you want change task owner?"
                                                                                                                                    onConfirm={() => handleOwnerChanger(ChatRoomItem, items.userid)}
                                                                                                                                    // onCancel={() => console.log('User canceled delete')}
                                                                                                                                    okText="Yes"
                                                                                                                                    cancelText="No"
                                                                                                                                    overlayStyle={{ zIndex: 10001 }} // Ensure the Popconfirm itself has a high z-index

                                                                                                                                >
                                                                                                                                    <a
                                                                                                                                        style={{
                                                                                                                                            display: `${ChatRoomItem.createdby}` === userid ? "block" : "none"
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        Set Owner
                                                                                                                                    </a>
                                                                                                                                </Popconfirm>
                                                                                                                            ]

                                                                                                                            :

                                                                                                                            [
                                                                                                                                <Popconfirm
                                                                                                                                    title={`Are you sure want to remove ${items.displayuserid}?`}
                                                                                                                                    onConfirm={() => handleCancelTagUser(ChatRoomItem, items.userid)}
                                                                                                                                    // onCancel={() => console.log('User canceled delete')}
                                                                                                                                    okText="Yes"
                                                                                                                                    cancelText="No"
                                                                                                                                    overlayStyle={{ zIndex: 10001 }} // Ensure the Popconfirm itself has a high z-index

                                                                                                                                >
                                                                                                                                    <a
                                                                                                                                        style={{
                                                                                                                                            color: "red",
                                                                                                                                            fontSize: "16px",
                                                                                                                                            // display: `${item.createdby}` === userid ? "block" : items.userid === userid ? "block" : "none"
                                                                                                                                            display: "block"
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        <DeleteOutlined></DeleteOutlined>
                                                                                                                                    </a>
                                                                                                                                </Popconfirm>
                                                                                                                            ]

                                                                                                                    }
                                                                                                                >

                                                                                                                    <List.Item.Meta
                                                                                                                        style={{ width: "50%" }}
                                                                                                                        title={
                                                                                                                            <>
                                                                                                                                <a style={{ color: items.color, fontSize: "14px", textOverflow: "ellipsis", overflow: "hidden", width: "100%" }}>
                                                                                                                                    {items.displayuserid}
                                                                                                                                </a>
                                                                                                                            </>
                                                                                                                        }
                                                                                                                    />
                                                                                                                </List.Item>
                                                                                                            )}
                                                                                                        >

                                                                                                        </List>

                                                                                                    </Modal>
                                                                                                </TabPane>
                                                                                                <TabPane tab="Action" key="4">
                                                                                                    <div className="tab-content">
                                                                                                        <div style={{ display: "flex", margin: "10 0", float: "right", paddingTop: '5px', paddingBottom: '5px' }}>
                                                                                                            {/* START NOW  */}
                                                                                                            {/* {startnowBtn(ChatRoomItem)} */}
                                                                                                            {/* ON HOLD   */}
                                                                                                            {/* {onholdBtn(ChatRoomItem)} */}
                                                                                                            {/* Active */}
                                                                                                            {activeBtn(ChatRoomItem)}
                                                                                                            {/* EXTENDED  */}
                                                                                                            {/* {extendedBtn(item)} */}
                                                                                                            {/* MAIN */}
                                                                                                            {/* {mainBtn(ChatRoomItem)} */}
                                                                                                            {/* SUB */}
                                                                                                            {/* {subBtn(item)} */}
                                                                                                            {/* ASSIGN */}
                                                                                                            {/* {assignBtn(item)} */}
                                                                                                            {/* APPROVE */}
                                                                                                            {approveBtn(ChatRoomItem)}
                                                                                                            {/* REJECT */}
                                                                                                            {/* {rejectBtn(item)} */}
                                                                                                            {/* <a style={{ color: "rgba(0, 0, 0, 0.85)", display: item.status != 1 ? "none" : item.createdby == userid ? "" : "none" }}>
                                                                                                                {assignto_username} has completed this task <Button onClick={() => onUpdateStatus(item, 3, "Complete Task", 'main')}>Close</Button>
                                                                                                            </a> */}
                                                                                                            {/* COMPLETED */}
                                                                                                            {completeBtn(ChatRoomItem)}
                                                                                                            {/* CANCEL */}
                                                                                                            {cancelBtn(ChatRoomItem)}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </TabPane>
                                                                                            </Tabs>
                                                                                            <Button className="collapse-button" onClick={handleCollapseClick}>
                                                                                                <UpCircleTwoTone style={{ fontSize: '24px' }} />
                                                                                            </Button>
                                                                                        </div>

                                                                                    </>
                                                                                )}
                                                                                <div className="chat-room-content" ref={chatContentRef}>
                                                                                    {/* Display sorted chat messages */}
                                                                                    {/* {chatdata.map((message, index) => (
                                                                                        <ChatMessage
                                                                                            key={index}
                                                                                            message={message}
                                                                                            userid={userid}
                                                                                            getUserLabel={getUserLabel}
                                                                                            showAttachmentList={showAttachmentList}
                                                                                            showAttachmentListRE={showAttachmentListRE}
                                                                                            StyledMessage={StyledMessage}
                                                                                            messageActionsMenuWithDelete={messageActionsMenuWithDelete}
                                                                                            messageActionsMenuNoDelete={messageActionsMenuNoDelete}
                                                                                        />
                                                                                    ))} */}
                                                                                    {/* {ChatMessage(chatdata,userid)> */}
                                                                                    <ChatMessage messages={chatdata} userid={userid} fulluserlist={FULLuserLists}
                                                                                        messageActionsMenuWithDelete={messageActionsMenuWithDelete} messageActionsMenuNoDelete={messageActionsMenuNoDelete}
                                                                                        chatinfo={ChatRoomItem} openlightbox={openLightbox} UpdatePinMsg={UpdatePinMsg} />

                                                                                </div>

                                                                                <div className="chat-room-footer">
                                                                                    <div className="preview-container">
                                                                                        {replyTo && (
                                                                                            <div ref={mentionsInputRef} className="reply-preview">
                                                                                                <div className="reply-message">
                                                                                                    <p className="reply-user">
                                                                                                        {getUserLabel(replyTo.from, FULLuserLists)}:
                                                                                                    </p>
                                                                                                    {showAttachmentList(replyTo)}

                                                                                                    <span className="reply-text">{replyTo.message}</span>
                                                                                                </div>
                                                                                                <Button
                                                                                                    type="text"
                                                                                                    onClick={clearReply}
                                                                                                    className="clear-reply-button"
                                                                                                >
                                                                                                    X
                                                                                                </Button>
                                                                                            </div>
                                                                                        )}
                                                                                        <Upload {...hiddenfileProps} ><Button hidden><PictureOutlined /></Button></Upload>
                                                                                    </div>
                                                                                    {onChatInputForm()}
                                                                                    {/* <onChatInputForm></onChatInputForm> */}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <List {...tasklistProps}></List>
                                                                    </>
                                                            }

                                                        </Spin>
                                                    </Col>

                                                </Row>
                                            </div>
                                        </>
                                        :
                                        displaymode == "self" ?

                                            <>
                                                <div
                                                    //onScroll={onScroll}
                                                    ref={listInnerRef}
                                                    style={{ height: `${height * 0.9}px`, overflowY: "auto", overflowX: "hidden", width: "100%", paddingBottom: "50px" }}>

                                                    {/* {
                                                        loadpreviousbutton ?

                                                            <>
                                                            </>
                                                            :
                                                            <>
                                                                <Button
                                                                    onClick={onScroll}
                                                                    style={loadpreviousbuttonStyle}
                                                                // icon={<UpOutlined />} // Use an icon for visual cue
                                                                >
                                                                    Load Previous
                                                                </Button>
                                                            </>
                                                    }
 */}

                                                    <Row gutter={[8, 8]} style={{ minHeight: `${height * 0.9}px` }}>

                                                        <Col xs={24}>
                                                            <Spin spinning={taskloading} size='large'>
                                                                <div className="task-calendar">
                                                                    {Object.keys(selfdatasource).sort().map(date => {
                                                                        const today = moment().format("YYYY-MM-DD");
                                                                        const isToday = moment(date).isSame(today);
                                                                        const hasOverdue = selfdatasource[date].some(task => task.deadline && moment.unix(task.deadline).isBefore(moment()) && !task.status);

                                                                        return (
                                                                            <div key={date} className={isToday ? "date-section today" : hasOverdue ? "date-section overdue" : "date-section"}>
                                                                                {/* `date-section ${isToday ? "today" : ""} ${hasOverdue ? "overdue" : ""}`} */}
                                                                                <h3>{isToday ? `Today ${moment(date).format("D-MMM-YYYY")}` : moment(date).format("dddd D-MMM-YYYY")}</h3>
                                                                                <ul>
                                                                                    {selfdatasource[date].length > 0 ? (
                                                                                        selfdatasource[date].map((task, index) => (
                                                                                            <>
                                                                                                <li
                                                                                                    key={index}
                                                                                                    className={`${task.deadline && moment.unix(task.deadline).isBefore(moment()) && !task.status ? "past" : ""}`}

                                                                                                >
                                                                                                    <div className="task-info">
                                                                                                        <span className={`task-userid ${task.userid === userid ? "self-user" : ""}`}>
                                                                                                            {task.userid === "ALL" || task.userid == null ? "ALL" : "SELF"}
                                                                                                        </span>
                                                                                                        {
                                                                                                            expandedChecklistIndex.index === index && expandedChecklistIndex.date === date &&
                                                                                                                editChecklistIndex.index === index && editChecklistIndex.date === date ? (
                                                                                                                <>
                                                                                                                    <textarea
                                                                                                                        value={editChecklistitem && editChecklistitem.date === date && editChecklistitem.index === index ? editChecklistitem.items : selfdatasource[date][index].items}
                                                                                                                        onChange={(e) => updateChecklistItem(index, e.target.value)}
                                                                                                                        className="task-content-edit"
                                                                                                                        rows={4} // Sets the default number of lines
                                                                                                                    />
                                                                                                                </>
                                                                                                            )
                                                                                                                :
                                                                                                                expandedChecklistIndex.index === index && expandedChecklistIndex.date === date ? (
                                                                                                                    <>
                                                                                                                        <span
                                                                                                                            style={{
                                                                                                                                color: task.status ? "white" : "",  // Changed from lightgray to white for better contrast
                                                                                                                                backgroundColor: task.status ? "mediumseagreen" : "",  // Using a Material Design green shade
                                                                                                                            }}
                                                                                                                            className="task-contentALL"
                                                                                                                            onClick={() => toggleChecklistDetail(date, index)}  // Use index for toggling
                                                                                                                        >
                                                                                                                            {task.status && <CheckCircleOutlined style={{ color: 'white', marginRight: '5px' }} />}
                                                                                                                            {task.items}
                                                                                                                        </span>
                                                                                                                    </>
                                                                                                                ) :
                                                                                                                    (
                                                                                                                        <span
                                                                                                                            style={{
                                                                                                                                color: task.status ? "white" : "",  // Changed from lightgray to white for better contrast
                                                                                                                                backgroundColor: task.status ? "mediumseagreen" : "",  // Using a Material Design green shade
                                                                                                                            }}
                                                                                                                            className="task-content"
                                                                                                                            onClick={() => toggleChecklistDetail(date, index)}
                                                                                                                        >
                                                                                                                            {task.status && <CheckCircleOutlined style={{ color: 'white', marginRight: '5px' }} />}
                                                                                                                            {task.items}
                                                                                                                        </span>
                                                                                                                    )}
                                                                                                    </div>

                                                                                                </li>
                                                                                                {
                                                                                                    expandedChecklistIndex.index === index && expandedChecklistIndex.date === date &&
                                                                                                        editChecklistIndex.index === index && editChecklistIndex.date === date ? (
                                                                                                        <>
                                                                                                            <div className="task-actions">
                                                                                                                <Button icon={<CheckOutlined />} onClick={() => EditsaveChanges(date, index)} type="primary" size="small" />
                                                                                                                <Button icon={<CloseOutlined />} onClick={() => EditcancelChanges()} size="small" />
                                                                                                            </div>
                                                                                                        </>
                                                                                                    )
                                                                                                        :
                                                                                                        expandedChecklistIndex.index === index && expandedChecklistIndex.date === date ?
                                                                                                            (
                                                                                                                <>
                                                                                                                    <div className="task-actions">
                                                                                                                        <Button onClick={() => LinktoTask(task)} size="small">Chat</Button>
                                                                                                                        <Button icon={<EditOutlined />} onClick={() => toggleChecklistDetailEdit(date, index)} type="primary" size="small" />
                                                                                                                        <Button icon={<CheckOutlined />} onClick={() => toggleChecklistStatus(date, index)} size="small">
                                                                                                                        </Button>
                                                                                                                    </div>
                                                                                                                </>
                                                                                                            )
                                                                                                            :
                                                                                                            <>
                                                                                                            </>}
                                                                                            </>


                                                                                        ))
                                                                                    ) : (
                                                                                        <li className="no-tasks">No Task List</li>
                                                                                    )}
                                                                                </ul>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </Spin>
                                                        </Col>

                                                    </Row>

                                                </div>
                                                {/* <SpeedDial
                                                    ariaLabel="SpeedDial basic example"
                                                    sx={{ position: 'fixed', bottom: 16, right: 16 }}
                                                    icon={<SpeedDialIcon />}
                                                >
                                                    <SpeedDialAction
                                                        icon={<BackToTodayIcon />}
                                                        tooltipTitle="Today"
                                                        tooltipOpen
                                                        onClick={onNavigateToday}
                                                    />
                                                </SpeedDial> */}
                                            </>
                                            :
                                            <>
                                            </>
                                }

                            </div>
                            {onModal()}
                            <Modal
                                visible={previewIconVisible}
                                footer={null}
                                onCancel={handleIconPreviewCancel}
                            >
                                <img alt="" style={{ width: '100%' }} src={previewIconImage} />
                            </Modal>

                            <Modal
                                title="Check List"
                                destroyOnClose={true}
                                visible={checklistmodalvisible}
                                onOk={(val) => { handleChecklistOk(val) }}
                                onCancel={(val) => { handleChecklistCancel(val) }}
                                width="90%"
                                footer={[
                                    <Button key="submit" type="primary" onClick={(val) => { handleChecklistOk(val) }}>
                                        OK
                                    </Button>,
                                ]}
                            >
                                <Table dataSource={checklist} columns={Checklistcolumns} pagination={false} />
                            </Modal>

                            <Modal
                                title="Tag New User"
                                destroyOnClose={true}
                                visible={ModalTag}
                                onCancel={cancelTagModal}
                                style={{ zIndex: 10000 }} // Ensure the modal itself has a high z-index
                                maskStyle={{ zIndex: 9999 }} // Ensure the modal mask has a high z-index
                                wrapClassName="ant-modal-wrap"

                                footer={
                                    <>
                                        <Button type='danger' onClick={cancelTagModal}>Cancel</Button>
                                        <Button onClick={handleTagModalSave}>Save</Button>
                                    </>
                                }
                            >

                                <div>
                                    <h3>Users:</h3>
                                    <Select
                                        mode="multiple"
                                        style={{ width: '100%', zIndex: 10005 }}
                                        placeholder="Select users"
                                        onChange={handleTagModalSelectUser}
                                        optionLabelProp="label"
                                        dropdownStyle={{ zIndex: 10006 }} // Ensure the dropdown itself has a high z-index
                                    >
                                        {userLists.filter(user =>
                                            // Check if the user is not already tagged
                                            !(currenttaskdata?.taguser?.some(taggedUser => taggedUser.userid === user._id) ?? false) &&
                                            // Check if the user is not the creator
                                            currenttaskdata?.createdby !== user._id &&
                                            // Check if the user is not the assignee
                                            currenttaskdata?.assignto !== user._id
                                        ).map(user => (
                                            <Option key={user.userid} value={user.userid} label={`${user.userid} (${user.markingcode})`}>
                                                {user.userid} ({user.markingcode})
                                            </Option>
                                        ))}
                                    </Select>
                                </div>
                                <div>
                                    <h3>Permissions:</h3>
                                    {userPermissions.map(user => (
                                        <div key={user.userid} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', padding: '5px', border: '1px solid #ccc', borderRadius: '5px', width: '100%', maxWidth: '500px' }}>
                                            <span>{user.userid}</span>
                                            <a onClick={() => togglePermission(user.userid)} style={{ cursor: 'pointer' }}>
                                                {user.permission}
                                            </a>
                                        </div>
                                    ))}
                                </div>

                            </Modal>

                            {IsImageOpen && imagelist.length > 0 && (
                                <Lightbox
                                    slides={imagelist.map(src => ({ src }))}
                                    open={IsImageOpen}
                                    index={SelectedImageIndex}
                                    close={() => setIsImageOpen(false)}
                                    plugins={[Zoom, Download, Fullscreen, Share]}
                                />
                            )}

                            {/* <Box
                                sx={{
                                    position: 'fixed',
                                    bottom: 16,
                                    right: 16,
                                    display: Snackvisible ? 'flex' : 'none'
                                }}
                            >
                                <CircularProgress size={24} />
                            </Box> */}

                        </>
                    )
                }
            })()}
        </>
    )
}

const ChatMessage = React.memo(({ messages, userid, fulluserlist, messageActionsMenuWithDelete, messageActionsMenuNoDelete, chatinfo, openlightbox, UpdatePinMsg }) => {
    console.log("messages >>>", messages)
    console.log("userid >>>", userid)
    const formatDate = (timestamp) => {
        const date = new Date(parseInt(timestamp) * 1000);
        const now = new Date();
        const isSameDay = date.toDateString() === now.toDateString();
        const isYesterday = date.toDateString() === new Date(now.setDate(now.getDate() - 1)).toDateString();
        const isSameYear = date.getFullYear() === now.getFullYear();

        if (isSameDay) {
            return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
        } else if (isYesterday) {
            return `Yesterday ${date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}`;
        } else if (isSameYear) {
            return `${date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} ${date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}`;
        } else {
            return `${date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })} ${date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}`;
        }
    };

    if (!messages || messages.length === 0) {
        return <div>No messages to display.</div>;
    }

     // Sort messages by createdte in ascending order
     const sortedMessages = [...messages].sort((a, b) => a.createdte - b.createdte);


    return (
        <div>
            {sortedMessages.map((message) => {
                const { from, message: text, createdte, reid, refrom, remessage: retext, refilepath } = message;
                const isDeletable = moment().diff(moment.unix(message.createdte), 'seconds') <= 300 && message.from === userid;

                let rotate = 0;
                let pinmsgcolor = 'red';

                if (chatinfo !== undefined) {
                    if (chatinfo.pinmsg !== undefined) {
                        if (text === chatinfo.pinmsg) {
                            rotate = 315;
                            pinmsgcolor = 'grey';
                        }
                    }
                }

                return (
                    <div key={message.id} className={`chat-message ${from === userid ? 'self' : ''}`}>
                        <div className="chat-message-header">
                            {from !== userid && <strong>{getUserLabel(from, fulluserlist)}</strong>}
                            <a onClick={(val) => { UpdatePinMsg(val, text) }}>
                                <PushpinOutlined style={{ fontSize: '16px', color: pinmsgcolor, transform: `rotate(${rotate}deg)` }} />
                            </a>
                            <span>{formatDate(createdte)}</span>
                        </div>
                        <div className="chat-message-body">
                            {reid && (
                                <div className="referenced-message">
                                    <div>{getUserLabel(refrom, fulluserlist)}</div>
                                    {showAttachmentListRE(message, openlightbox)}
                                    <StyledMessage message={{ remessage: retext }} msgtype="reply" chatinfo={chatinfo} fulluserlist={fulluserlist} userid={userid} />
                                </div>
                            )}
                            {showAttachmentList(message, openlightbox)}
                            {message.msgtype === 'audio' ? (
                                <div className="audio-player-container">
                                    <ReactAudioPlayer
                                        src={`https://qc9sk2.naxgo.online${message.message}`}
                                        controls
                                    />
                                </div>
                            ) : (
                                <StyledMessage message={{ message: text }} msgtype="message" chatinfo={chatinfo} fulluserlist={fulluserlist} userid={userid} />
                            )}
                            <div className="chat-message-menu">
                                <Dropdown overlay={isDeletable ? messageActionsMenuWithDelete(message) : messageActionsMenuNoDelete(message)} trigger={['click']}>
                                    <a onClick={(e) => e.preventDefault()}>
                                        <MoreOutlined style={{ fontSize: '16px', marginLeft: '10px' }} />
                                    </a>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
});

function getUserLabel(userid, FULLuserLists) {
    // Find the user in the FULLuserLists by their id



    if (userid == "ALL") {
        // If a user is found, return a formatted string, otherwise return "Unknown user"
        return `ALL`;
    }
    else {
        if (FULLuserLists == undefined) {
            return "Unknown user";
        }
        const user = FULLuserLists.find(user => user._id === userid);
        // If a user is found, return a formatted string, otherwise return "Unknown user"
        return user ? `${user.userid} (${user.markingcode})` : "Unknown user";
    }

}


//====== ATTACHMENT ======
const showAttachmentList = (item, openLightbox) => {

    // Filter out images from the filepaths for the lightbox
    const images = item.filepath ? item.filepath.split(',').filter(filepath => {
        const ext = filepath.split('.').pop().toLowerCase();
        return ["png", "jpeg", "jpg"].includes(ext);
    }).map(filepath => `https://qc9sk2.naxgo.online${filepath}`) : [];


    return (
        <div>
            {item.filepath && item.filepath.split(',').map((filepath, index) => {
                const ext = filepath.split('.').pop().toLowerCase();
                if (["png", "jpeg", "jpg"].includes(ext)) {
                    return (
                        <>
                            <div style={{ display: "inline-block" }}>
                                <img
                                    key={index}
                                    src={`https://qc9sk2.naxgo.online${filepath}`}
                                    alt={`Gallery item ${index}`}
                                    style={{ width: '100px', height: '100px', objectFit: 'cover', cursor: 'pointer' }}
                                    onClick={(e) => openLightbox(images.indexOf(`https://qc9sk2.naxgo.online${filepath}`), images)}
                                />
                            </div>

                        </>

                    );
                } else if (["mp4", "avi", "mkv", "wmv", "mov", "MOV", "MP4", "AVI", "MKV", "WMV"].includes(ext.toLowerCase())) {
                    const playerOptions = {
                        src: `https://qc9sk2.naxgo.online${filepath}`,
                        controls: true,
                        autoplay: false,

                    };
                    const videojsOptions = {
                        fluid: true,

                    };

                    return (

                        <div style={{
                            width: '100%',
                            position: 'relative',
                            display: "inline-block",
                            maxWidth: '500px',  // Adjust the maximum width as needed
                            maxHeight: '500px', // Adjust the maximum height as needed
                            overflow: 'hidden'  // This will clip the content if it exceeds the container size
                        }}>
                            <VREPlayer
                                playerOptions={playerOptions}
                                videojsOptions={videojsOptions}
                                onReady={(player) => console.log(player)}
                                onPlay={(e, _, second) => console.log('Play!')}
                                onPause={(e, _, second) => console.log('Pause!')}
                                onEnded={(e, _) => console.log('Ended!')}
                            />
                        </div>

                    );
                }
                // else if (["pdf"].includes(ext.toLowerCase())) {
                //     let filename = filepath.split('/');
                //     return (
                //         <>
                //             <FileOutlined /> {filename[filename.length - 1]}
                //             <Button onClick={() => openPDF(`https://qc9sk2.naxgo.online${filepath}`)}>View</Button>
                //         </>
                //     );
                // }
                // else if (["doc", "docx", "ppt", "pptx", "xls", "xlsx", "txt", "csv"].includes(ext.toLowerCase())) {
                //     let filename = filepath.split('/');
                //     return (
                //         <>
                //             <FileOutlined /> {filename[filename.length - 1]}
                //             <Button onClick={() => toggleViewer(`https://qc9sk2.naxgo.online${filepath}`)}>View</Button>
                //         </>
                //     );
                // }
                else {
                    // ======= OTHER FILE ========
                    let filename = filepath.split('/');
                    return (
                        <>
                            <div>
                                <FileOutlined /> {filename[filename.length - 1]}
                                <Button style={{ marginLeft: "10px" }}>
                                    <a href={`https://qc9sk2.naxgo.online${filepath}`} target="_blank" >
                                        {/* <a href={`/Applications/MAMP/htdocs/Web_Projects/naxgoadmin/API/src${filepath}`} target="_blank" > */}
                                        {GetTranslation(userlang, "Open")}
                                    </a>
                                </Button>
                            </div>
                        </>
                    )
                }
            })}


        </div>
    )
}


//====== ATTACHMENT ======
const showAttachmentListRE = (item, openLightbox) => {

    // Filter out images from the filepaths for the lightbox
    const images = item.refilepath ? item.refilepath.split(',').filter(refilepath => {
        const ext = refilepath.split('.').pop().toLowerCase();
        return ["png", "jpeg", "jpg"].includes(ext);
    }).map(refilepath => `https://qc9sk2.naxgo.online${refilepath}`) : [];



    return (
        <div>
            {item.refilepath && item.refilepath.split(',').map((refilepath, index) => {
                const ext = refilepath.split('.').pop().toLowerCase();
                if (["png", "jpeg", "jpg"].includes(ext)) {
                    return (
                        <>
                            <div>
                                <img
                                    key={index}
                                    src={`https://qc9sk2.naxgo.online${refilepath}`}
                                    alt={`Gallery item ${index}`}
                                    style={{ width: '100px', height: '100px', objectFit: 'cover', cursor: 'pointer' }}
                                    onClick={(e) => openLightbox(images.indexOf(`https://qc9sk2.naxgo.online${refilepath}`), images)}
                                />
                            </div>

                        </>

                    );
                } else if (["mp4", "avi", "mkv", "wmv", "mov", "MOV", "MP4", "AVI", "MKV", "WMV"].includes(ext.toLowerCase())) {
                    const playerOptions = {
                        src: `https://qc9sk2.naxgo.online${refilepath}`,
                        controls: true,
                        autoplay: false,

                    };
                    const videojsOptions = {
                        fluid: true,

                    };

                    return (

                        <div style={{
                            width: '100%',
                            position: 'relative',
                            display: "inline-block",
                            maxWidth: '500px',  // Adjust the maximum width as needed
                            maxHeight: '500px', // Adjust the maximum height as needed
                            overflow: 'hidden'  // This will clip the content if it exceeds the container size
                        }}>
                            <VREPlayer
                                playerOptions={playerOptions}
                                videojsOptions={videojsOptions}
                                onReady={(player) => console.log(player)}
                                onPlay={(e, _, second) => console.log('Play!')}
                                onPause={(e, _, second) => console.log('Pause!')}
                                onEnded={(e, _) => console.log('Ended!')}
                            />
                        </div>

                    );
                } else {
                    // ======= OTHER FILE ========
                    let filename = refilepath.split('/');
                    return (
                        <>
                            <div>
                                <FileOutlined /> {filename[filename.length - 1]}
                                <Button style={{ marginLeft: "10px" }}>
                                    <a href={`https://qc9sk2.naxgo.online${refilepath}`} target="_blank" >
                                        {/* <a href={`/Applications/MAMP/htdocs/Web_Projects/naxgoadmin/API/src${filepath}`} target="_blank" > */}
                                        {GetTranslation(userlang, "Open")}
                                    </a>
                                </Button>
                            </div>
                        </>
                    )
                }
            })}


        </div>
    )
}

function StyledMessage({ message, msgtype, chatinfo, fulluserlist,userid }) {

    var safeMessage

    console.log("task chatinfo >>>",chatinfo)
    console.log("task message >>>",message)

    var temptask = chatinfo

    // temptask = temptask.filter((x => x._id == message.taskid))[0]


    var privateuserlist = []

    if (temptask != undefined) {
        if (temptask.taguser != undefined && temptask.taguser.length > 0) {

            temptask.taguser.forEach(function (items) {

                if (items.permission == "private") {

                    var tempuserid = fulluserlist.filter((x => x._id == items.userid))[0]

                    if (tempuserid != undefined) {
                        privateuserlist.push(tempuserid.userid)
                    }

                }

            })
        }
    }

    //console.log("privateuserlist >>>",privateuserlist)

    if (msgtype == "reply") {
        safeMessage = message.remessage

    }
    else if (msgtype == "message") {
        safeMessage = message.message
    }
    safeMessage = typeof safeMessage === 'string' ? safeMessage : '';

    // Function to safely create React elements from parts of the message
    const createMessageElements = (part, index) => {
        // Check if the part is a mention pattern
        if (part.startsWith('@[') && part.endsWith(']')) {
            const username = part.slice(2, -1);
            var textcolor = "blue"
            if (privateuserlist.includes(username)) {
                textcolor = "red"
            }
            else {
                textcolor = "blue"
            }
            return <span key={index} style={{ color: textcolor, fontWeight: 'bold' }}>{username} </span>;
        }
        // Check if the part is a URL
        else if (/https?:\/\/[^\s]+/.test(part)) {
            return <a key={index} href={part} target="_blank" rel="noopener noreferrer" style={{ color: 'blue' }}>{part}</a>;
        }
        // Return the part as plain text
        return part;
    };

    // Combining username and URL regex patterns and splitting the message
    const partsRegex = /(\@\[[^\]]+\])|(https?:\/\/[^\s]+)/g;
    const parts = safeMessage.split(partsRegex);



    return (
        <Text className="textparagraph" style={{ color: message.msgtype == "system" ? "darkgreen" : "",fontWeight: message.newmessage == true && message.from != userid ? "bold" : "" }} >
            {parts.filter(Boolean).map(createMessageElements)}
        </Text>
    );
}